[
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ADAMANTINA",
    "municipioIbge": 3500105,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.34,
    "precoMinimo": 3.18,
    "precoMaximo": 3.69,
    "desvioPadrao": 0.22174631580125198,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "AGUAS LINDAS DE GOIAS",
    "municipioIbge": 5200258,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.09,
    "precoMinimo": 4.09,
    "precoMaximo": 4.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.71,
    "precoMinimo": 4.41,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.2461513278259457,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALEGRETE",
    "municipioIbge": 4300406,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALENQUER",
    "municipioIbge": 1500404,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ALFENAS",
    "municipioIbge": 3101607,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.04,
    "precoMinimo": 3.89,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.11362707032706208,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "ALTA FLORESTA",
    "municipioIbge": 5100250,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.7,
    "precoMinimo": 3.53,
    "precoMaximo": 3.77,
    "desvioPadrao": 0.08717797887081348,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALTAMIRA",
    "municipioIbge": 1500602,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.69,
    "precoMinimo": 5.35,
    "precoMaximo": 5.82,
    "desvioPadrao": 0.1918332609325088,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALVORADA",
    "municipioIbge": 4300604,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 4.54,
    "precoMinimo": 4.29,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.3535533905932738,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.75,
    "precoMinimo": 3.39,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.16406411236779656,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ANANINDEUA",
    "municipioIbge": 1500800,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.42,
    "precoMinimo": 4.08,
    "precoMaximo": 5.59,
    "desvioPadrao": 0.5933099246318627,
    "coeficienteVariacao": 0.134
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ANAPOLIS",
    "municipioIbge": 5201108,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 4.09,
    "precoMinimo": 4.08,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.03060005941764879,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.6,
    "precoMinimo": 5.59,
    "precoMaximo": 5.65,
    "desvioPadrao": 0.02683281572999748,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "APARECIDA DE GOIANIA",
    "municipioIbge": 5201405,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 4.48,
    "precoMinimo": 4.29,
    "precoMaximo": 4.54,
    "desvioPadrao": 0.07658271528681752,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "APUCARANA",
    "municipioIbge": 4101408,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.1,
    "precoMinimo": 4.07,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.06928203230275509,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 5.33,
    "precoMinimo": 5.3,
    "precoMaximo": 5.5,
    "desvioPadrao": 0.069602043392737,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARACATUBA",
    "municipioIbge": 3502804,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.22,
    "precoMinimo": 3.04,
    "precoMaximo": 3.49,
    "desvioPadrao": 0.15631224035089666,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "ARAGUAINA",
    "municipioIbge": 1702109,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.98,
    "precoMinimo": 4.77,
    "precoMaximo": 5.34,
    "desvioPadrao": 0.16921058543194697,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 5.07,
    "precoMinimo": 4.79,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.22124133264995327,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAPONGAS",
    "municipioIbge": 4101507,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.93,
    "precoMinimo": 3.59,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.1675879300120217,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 4.74,
    "precoMinimo": 4.59,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.53,
    "precoMinimo": 2.85,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.4581965927929395,
    "coeficienteVariacao": 0.13
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAS",
    "municipioIbge": 3503307,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.7,
    "precoMinimo": 3.47,
    "precoMaximo": 3.97,
    "desvioPadrao": 0.1935917812764214,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARARIPINA",
    "municipioIbge": 2601102,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.59,
    "precoMinimo": 5.59,
    "precoMaximo": 5.6,
    "desvioPadrao": 0.00447213595499958,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.95,
    "precoMinimo": 4.49,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.21192990755031654,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAUCARIA",
    "municipioIbge": 4101804,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.46,
    "precoMinimo": 4.39,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.04629100498862758,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ARAXA",
    "municipioIbge": 3104007,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.29,
    "precoMinimo": 4.09,
    "precoMaximo": 5.12,
    "desvioPadrao": 0.3092571745327827,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARCOVERDE",
    "municipioIbge": 2601201,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.09,
    "precoMinimo": 5.04,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.05477225575051661,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "ARIQUEMES",
    "municipioIbge": 1100023,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.46,
    "precoMinimo": 5.43,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.042426406871192854,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ASSIS",
    "municipioIbge": 3504008,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.6,
    "precoMinimo": 3.14,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.36168740339936883,
    "coeficienteVariacao": 0.1
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ATIBAIA",
    "municipioIbge": 3504107,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 4.3,
    "precoMinimo": 3.98,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.2887001943154909,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AVARE",
    "municipioIbge": 3504503,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 3.79,
    "precoMinimo": 3.79,
    "precoMaximo": 3.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BAGE",
    "municipioIbge": 4301602,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.38,
    "precoMinimo": 4.99,
    "precoMaximo": 5.67,
    "desvioPadrao": 0.29003448070875987,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BALSAS",
    "municipioIbge": 2101400,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.4,
    "precoMinimo": 4.99,
    "precoMaximo": 5.95,
    "desvioPadrao": 0.4299003206724621,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BARBACENA",
    "municipioIbge": 3105608,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.36,
    "precoMinimo": 4.19,
    "precoMaximo": 4.78,
    "desvioPadrao": 0.23302360395462088,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.08,
    "precoMinimo": 4.79,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.2263109954612605,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.85,
    "precoMinimo": 4.69,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.21777919500672643,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "BARREIRAS",
    "municipioIbge": 2903201,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.2,
    "precoMinimo": 4.04,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.24016660883644922,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARRETOS",
    "municipioIbge": 3505500,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.44,
    "precoMinimo": 2.87,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.2638939180807318,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARUERI",
    "municipioIbge": 3505708,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 4.16,
    "precoMinimo": 3.39,
    "precoMaximo": 5.99,
    "desvioPadrao": 1.001962908659632,
    "coeficienteVariacao": 0.24
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BAURU",
    "municipioIbge": 3506003,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.48,
    "precoMinimo": 2.96,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.23682644427065647,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.69,
    "precoMinimo": 4.59,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.12648404755428364,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BEBEDOURO",
    "municipioIbge": 3506102,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.64,
    "precoMinimo": 3.49,
    "precoMaximo": 3.69,
    "desvioPadrao": 0.07646972634722218,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BELEM",
    "municipioIbge": 1501402,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.55,
    "precoMinimo": 3.95,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.4167904578013822,
    "coeficienteVariacao": 0.092
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "ETHANOL",
    "postosPesquisados": 41,
    "unidade": "R$/l",
    "precoMedio": 3.82,
    "precoMinimo": 3.37,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.3814518158363885,
    "coeficienteVariacao": 0.1
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "BELO JARDIM",
    "municipioIbge": 2601706,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.83,
    "precoMinimo": 4.79,
    "precoMaximo": 4.95,
    "desvioPadrao": 0.0648074069840786,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.73,
    "precoMinimo": 4.19,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.31304951684997057,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BETIM",
    "municipioIbge": 3106705,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.8,
    "precoMinimo": 3.57,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.19250374621729394,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BIRIGUI",
    "municipioIbge": 3506508,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.34,
    "precoMinimo": 3.19,
    "precoMaximo": 3.69,
    "desvioPadrao": 0.190029237516523,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.4,
    "precoMinimo": 4,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.24999777776790116,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RR",
    "estadoNome": "RORAIMA",
    "municipioNome": "BOA VISTA",
    "municipioIbge": 1400100,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.41,
    "precoMinimo": 5.41,
    "precoMaximo": 5.45,
    "desvioPadrao": 0.015735915849388864,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BOM DESPACHO",
    "municipioIbge": 3107406,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4,
    "precoMinimo": 3.94,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.0930693545798227,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BRAGANCA",
    "municipioIbge": 1501709,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 5.2,
    "precoMinimo": 5.2,
    "precoMaximo": 5.2,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BRAGANCA PAULISTA",
    "municipioIbge": 3507605,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.89,
    "precoMinimo": 3.59,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.2737902684740843,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "DF",
    "estadoNome": "DISTRITO FEDERAL",
    "municipioNome": "BRASILIA",
    "municipioIbge": 5300108,
    "produto": "ETHANOL",
    "postosPesquisados": 25,
    "unidade": "R$/l",
    "precoMedio": 4.17,
    "precoMinimo": 3.99,
    "precoMaximo": 4.26,
    "desvioPadrao": 0.042414620120896994,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.4,
    "precoMinimo": 4.08,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.19788163850429089,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.86,
    "precoMinimo": 4.67,
    "precoMaximo": 5.13,
    "desvioPadrao": 0.1698879182340662,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CABO DE SANTO AGOSTINHO",
    "municipioIbge": 2602902,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.11,
    "precoMinimo": 5.06,
    "precoMaximo": 5.15,
    "desvioPadrao": 0.046690470119715013,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CABO FRIO",
    "municipioIbge": 3300704,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 5.05,
    "precoMinimo": 4.95,
    "precoMaximo": 5.37,
    "desvioPadrao": 0.13846092795958206,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CACADOR",
    "municipioIbge": 4203006,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.93,
    "precoMinimo": 4.79,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.1511857892036909,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.23,
    "precoMinimo": 3.57,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.59357873469803,
    "coeficienteVariacao": 0.14
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CACERES",
    "municipioIbge": 5102504,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.69,
    "precoMinimo": 3.69,
    "precoMaximo": 3.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRA DO SUL",
    "municipioIbge": 4303004,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 4.57,
    "precoMinimo": 4.55,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.028284271247461905,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRINHA",
    "municipioIbge": 4303103,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.49,
    "precoMinimo": 4.49,
    "precoMaximo": 4.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.86,
    "precoMinimo": 4.59,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.1830634376991272,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "CACOAL",
    "municipioIbge": 1100049,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.42,
    "precoMinimo": 5.38,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.11659861961120337,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "CAETITE",
    "municipioIbge": 2905206,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.98,
    "precoMinimo": 4.98,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.0037796447300922726,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "CAICO",
    "municipioIbge": 2402006,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.03,
    "precoMinimo": 5.95,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.127501633976458,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CALDAS NOVAS",
    "municipioIbge": 5204508,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.96,
    "precoMinimo": 3.86,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.13332291625973383,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMBE",
    "municipioIbge": 4103701,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.79,
    "precoMinimo": 3.19,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.282842712474619,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 4.79,
    "precoMinimo": 4.69,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.06662081756728398,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "ETHANOL",
    "postosPesquisados": 24,
    "unidade": "R$/l",
    "precoMedio": 3.77,
    "precoMinimo": 3.25,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.3072446506650992,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CAMPO BELO",
    "municipioIbge": 3111200,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.78,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.005345224838248488,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "ETHANOL",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.59,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.11634104217875177,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO LARGO",
    "municipioIbge": 4104204,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4,
    "precoMinimo": 3.99,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.035355339059327376,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO MOURAO",
    "municipioIbge": 4104303,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.73,
    "precoMinimo": 3.57,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.1423610433604175,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.68,
    "precoMinimo": 4.19,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.20044395171163878,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CANINDE",
    "municipioIbge": 2302800,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.38,
    "precoMinimo": 5.25,
    "precoMaximo": 5.55,
    "desvioPadrao": 0.09848857801796106,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.39,
    "precoMinimo": 3.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.44158804331639234,
    "coeficienteVariacao": 0.101
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CARAGUATATUBA",
    "municipioIbge": 3510500,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.19,
    "precoMinimo": 3.77,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.2078728243689182,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CARATINGA",
    "municipioIbge": 3113404,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.21,
    "precoMinimo": 4.07,
    "precoMaximo": 4.35,
    "desvioPadrao": 0.0886942313043338,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 4.5,
    "precoMinimo": 4.37,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.11120824037486039,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 4.91,
    "precoMinimo": 4.69,
    "precoMaximo": 5.64,
    "desvioPadrao": 0.20760439141148565,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASCAVEL",
    "municipioIbge": 4104808,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 3.92,
    "precoMinimo": 3.69,
    "precoMaximo": 4.08,
    "desvioPadrao": 0.12868801832574026,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CASTANHAL",
    "municipioIbge": 1502400,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.09,
    "precoMinimo": 4.99,
    "precoMaximo": 5.32,
    "desvioPadrao": 0.16294170736800326,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASTRO",
    "municipioIbge": 4104907,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.75,
    "precoMinimo": 4.36,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.28561629271921213,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CATALAO",
    "municipioIbge": 5205109,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.96,
    "precoMinimo": 3.77,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.17750117370503968,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CAUCAIA",
    "municipioIbge": 2303709,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 4.85,
    "precoMinimo": 4.63,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.15902749318826476,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.88,
    "precoMinimo": 4.19,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.39612708398526186,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CHAPECO",
    "municipioIbge": 4204202,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.95,
    "precoMinimo": 4.65,
    "precoMaximo": 6.36,
    "desvioPadrao": 0.5798260207042405,
    "coeficienteVariacao": 0.117
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CIANORTE",
    "municipioIbge": 4105508,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 3.95,
    "precoMinimo": 3.89,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.05477225575051661,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "CODO",
    "municipioIbge": 2103307,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.6,
    "precoMinimo": 5.25,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.36356567494745706,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "COLATINA",
    "municipioIbge": 3201506,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.82,
    "precoMinimo": 4.59,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.2081665999466133,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.7,
    "precoMinimo": 4.49,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.16674997917707682,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CONCEICAO DO ARAGUAIA",
    "municipioIbge": 1502707,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.62,
    "precoMinimo": 5.5,
    "precoMaximo": 5.75,
    "desvioPadrao": 0.1767766952966369,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CONCORDIA",
    "municipioIbge": 4204301,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.26,
    "precoMinimo": 4.79,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.27313000567495327,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONGONHAS",
    "municipioIbge": 3118007,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.31,
    "precoMinimo": 3.99,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.16069788276081776,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONSELHEIRO LAFAIETE",
    "municipioIbge": 3118304,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.2,
    "precoMinimo": 3.99,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.16761634196950517,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.72,
    "precoMinimo": 3.57,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.13801644109197972,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CORNELIO PROCOPIO",
    "municipioIbge": 4106407,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.11,
    "precoMinimo": 3.99,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.18838916155255903,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CORONEL FABRICIANO",
    "municipioIbge": 3119401,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.02,
    "precoMinimo": 3.95,
    "precoMaximo": 4.24,
    "desvioPadrao": 0.12409673645990855,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CORUMBA",
    "municipioIbge": 5003207,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 4.93,
    "precoMinimo": 4.89,
    "precoMaximo": 4.97,
    "desvioPadrao": 0.05656854249492381,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COSMOPOLIS",
    "municipioIbge": 3512803,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.89,
    "precoMinimo": 3.84,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.04172614801981401,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COTIA",
    "municipioIbge": 3513009,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 3.72,
    "precoMinimo": 3.47,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.25334130768948476,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CRATEUS",
    "municipioIbge": 2304103,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.9,
    "precoMinimo": 5.59,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.22634045153264143,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.62,
    "precoMinimo": 4.34,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.13346347815039142,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.72,
    "precoMinimo": 3.59,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.12553883861180173,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CUBATAO",
    "municipioIbge": 3513504,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.52,
    "precoMinimo": 4.19,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.1380476108346061,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CUIABA",
    "municipioIbge": 5103403,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.74,
    "precoMinimo": 3.39,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.09782428452728317,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CURITIBA",
    "municipioIbge": 4106902,
    "produto": "ETHANOL",
    "postosPesquisados": 44,
    "unidade": "R$/l",
    "precoMedio": 4.72,
    "precoMinimo": 4.33,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.12025409145483537,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CURVELO",
    "municipioIbge": 3120904,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.03,
    "precoMinimo": 3.87,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.11369602330022681,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "DELMIRO GOUVEIA",
    "municipioIbge": 2702405,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 5.37,
    "precoMinimo": 4.88,
    "precoMaximo": 5.98,
    "desvioPadrao": 0.331027021387815,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "DIADEMA",
    "municipioIbge": 3513801,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 3.77,
    "precoMinimo": 3.39,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.3945851440404668,
    "coeficienteVariacao": 0.105
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "DIVINOPOLIS",
    "municipioIbge": 3122306,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.88,
    "precoMinimo": 3.69,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.2068072309403875,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "DOURADOS",
    "municipioIbge": 5003702,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.26,
    "precoMinimo": 4.15,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.139204086785474,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "EMBU DAS ARTES",
    "municipioIbge": 3515004,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.85,
    "precoMinimo": 3.53,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.27546065314046475,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ERECHIM",
    "municipioIbge": 4307005,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.04,
    "precoMinimo": 4.8,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.34648232278140834,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.37,
    "precoMinimo": 4.05,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.45003703551300456,
    "coeficienteVariacao": 0.103
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "EUNAPOLIS",
    "municipioIbge": 2910727,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 5.13,
    "precoMinimo": 4.96,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.1345893224378729,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 4.48,
    "precoMinimo": 4.41,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.1243047330823194,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 4.49,
    "precoMinimo": 4.06,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.24911114715396349,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FORMIGA",
    "municipioIbge": 3126109,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.04,
    "precoMinimo": 3.89,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.22253945610567472,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "FORMOSA",
    "municipioIbge": 5208004,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.64,
    "precoMinimo": 3.49,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.1760681686165901,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "FORTALEZA",
    "municipioIbge": 2304400,
    "produto": "ETHANOL",
    "postosPesquisados": 41,
    "unidade": "R$/l",
    "precoMedio": 4.79,
    "precoMinimo": 4.62,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.1640902488147835,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "FRANCA",
    "municipioIbge": 3516200,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.46,
    "precoMinimo": 2.94,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.17184754565418858,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "FRANCISCO BELTRAO",
    "municipioIbge": 4108403,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.01,
    "precoMinimo": 4.01,
    "precoMaximo": 4.01,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FRUTAL",
    "municipioIbge": 3127107,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.77,
    "precoMinimo": 3.59,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.12186057606953941,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "GARANHUNS",
    "municipioIbge": 2606002,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.88,
    "precoMinimo": 4.82,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.0648074069840786,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GARCA",
    "municipioIbge": 3516705,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.59,
    "precoMinimo": 3.19,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.21985384755722218,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIANIA",
    "municipioIbge": 5208707,
    "produto": "ETHANOL",
    "postosPesquisados": 44,
    "unidade": "R$/l",
    "precoMedio": 4.33,
    "precoMinimo": 3.69,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.29378516837744273,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIATUBA",
    "municipioIbge": 5209101,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 3.45,
    "precoMinimo": 3.28,
    "precoMaximo": 3.69,
    "desvioPadrao": 0.20445048300260873,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GOVERNADOR VALADARES",
    "municipioIbge": 3127701,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.88,
    "precoMinimo": 3.79,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.08130873945100313,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAMADO",
    "municipioIbge": 4309100,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.11,
    "precoMinimo": 4.89,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.17888543819998318,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.19,
    "precoMinimo": 4.19,
    "precoMaximo": 4.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GUAIBA",
    "municipioIbge": 4309308,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.4,
    "precoMinimo": 3.87,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.3850293742659371,
    "coeficienteVariacao": 0.087
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "GUANAMBI",
    "municipioIbge": 2911709,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.63,
    "precoMinimo": 4.4,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.21117020893785457,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "GUARAPARI",
    "municipioIbge": 3202405,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.32,
    "precoMinimo": 5.03,
    "precoMaximo": 5.59,
    "desvioPadrao": 0.3069744831958079,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "GUARAPUAVA",
    "municipioIbge": 4109401,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.59,
    "precoMinimo": 3.47,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.1505739933472161,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.96,
    "precoMinimo": 3.7,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.18473705036558793,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARUJA",
    "municipioIbge": 3518701,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.32,
    "precoMinimo": 3.49,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.42073914551825176,
    "coeficienteVariacao": 0.097
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "ETHANOL",
    "postosPesquisados": 24,
    "unidade": "R$/l",
    "precoMedio": 3.65,
    "precoMinimo": 3.29,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.254293209173749,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GUAXUPE",
    "municipioIbge": 3128709,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.99,
    "precoMinimo": 3.97,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.041403933560541256,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "GURUPI",
    "municipioIbge": 1709500,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.07,
    "precoMinimo": 4.99,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.15735915849388862,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.88,
    "precoMinimo": 3.79,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.056764621219754674,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "IBITINGA",
    "municipioIbge": 3519600,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.43,
    "precoMinimo": 3.16,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.2551715109490086,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ICO",
    "municipioIbge": 2305407,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.73,
    "precoMinimo": 5.48,
    "precoMaximo": 5.89,
    "desvioPadrao": 0.1414802695313614,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "IGARASSU",
    "municipioIbge": 2606804,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 5.07,
    "precoMinimo": 5.03,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.04911720676097125,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "IGUATU",
    "municipioIbge": 2305506,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.32,
    "precoMinimo": 4.99,
    "precoMaximo": 5.59,
    "desvioPadrao": 0.20655911179772893,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "IJUI",
    "municipioIbge": 4310207,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.03,
    "precoMinimo": 4.49,
    "precoMaximo": 5.83,
    "desvioPadrao": 0.7068238818828917,
    "coeficienteVariacao": 0.141
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ILHEUS",
    "municipioIbge": 2913606,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.95,
    "precoMinimo": 4.94,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.016666666666666666,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "IMPERATRIZ",
    "municipioIbge": 2105302,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 5.31,
    "precoMinimo": 4.97,
    "precoMaximo": 5.79,
    "desvioPadrao": 0.2622224362265862,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "INDAIATUBA",
    "municipioIbge": 3520509,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.58,
    "precoMinimo": 3.14,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.22167293224227647,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "IPATINGA",
    "municipioIbge": 3131307,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.19,
    "precoMinimo": 3.99,
    "precoMaximo": 4.43,
    "desvioPadrao": 0.17224014243685087,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IPIRA",
    "municipioIbge": 2914000,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.51,
    "precoMinimo": 4.35,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.18319908504658194,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IRECE",
    "municipioIbge": 2914604,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.88,
    "precoMinimo": 4.69,
    "precoMaximo": 5.06,
    "desvioPadrao": 0.15820872289478857,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ITABAIANA",
    "municipioIbge": 2802908,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.6,
    "precoMinimo": 5.5,
    "precoMaximo": 5.7,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.65,
    "precoMinimo": 4.39,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.2615202805574687,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.93,
    "precoMinimo": 4.93,
    "precoMaximo": 4.93,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 4.42,
    "precoMinimo": 4.28,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.17041051490369832,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAJUBA",
    "municipioIbge": 3132404,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.12,
    "precoMinimo": 3.99,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITAMARAJU",
    "municipioIbge": 2915601,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.81,
    "precoMinimo": 4.69,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.1625423021862309,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPECERICA DA SERRA",
    "municipioIbge": 3522208,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.86,
    "precoMinimo": 3.49,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.34377889488947483,
    "coeficienteVariacao": 0.089
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.75,
    "precoMinimo": 4.69,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.0402077936060494,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ITAPIPOCA",
    "municipioIbge": 2306405,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 5.73,
    "precoMinimo": 5.68,
    "precoMaximo": 5.88,
    "desvioPadrao": 0.08135996831639283,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPIRA",
    "municipioIbge": 3522604,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.88,
    "precoMinimo": 3.49,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.27152676795168046,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPOLIS",
    "municipioIbge": 3522703,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.65,
    "precoMinimo": 3.53,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.11895377253370319,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.72,
    "precoMinimo": 3.19,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.6000925854492047,
    "coeficienteVariacao": 0.161
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 3.6,
    "precoMinimo": 3.29,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.21800750612598807,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAUNA",
    "municipioIbge": 3133808,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.79,
    "precoMinimo": 3.59,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.21325705481547716,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.51,
    "precoMinimo": 3.09,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.2860167050288419,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITUIUTABA",
    "municipioIbge": 3134202,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.79,
    "precoMinimo": 3.74,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.03689323936863109,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ITUMBIARA",
    "municipioIbge": 5211503,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.9,
    "precoMinimo": 3.59,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.1628320782717144,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "JABOATAO DOS GUARARAPES",
    "municipioIbge": 2607901,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.07,
    "precoMinimo": 5.05,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.028284271247461905,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JABOTICABAL",
    "municipioIbge": 3524303,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.9,
    "precoMinimo": 3.89,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.038224483137265716,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.64,
    "precoMinimo": 3.49,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.10797842682379041,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JACOBINA",
    "municipioIbge": 2917508,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 4.7,
    "precoMinimo": 4.63,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.08501336793277119,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JAGUAQUARA",
    "municipioIbge": 2917607,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.86,
    "precoMinimo": 4.54,
    "precoMaximo": 5.59,
    "desvioPadrao": 0.3706943292178689,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JALES",
    "municipioIbge": 3524808,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.68,
    "precoMinimo": 3.39,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.1868345333634627,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANAUBA",
    "municipioIbge": 3135100,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.08,
    "precoMinimo": 3.88,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.27738575511885455,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANUARIA",
    "municipioIbge": 3135209,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.34,
    "precoMinimo": 3.99,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.2138089935299395,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JAU",
    "municipioIbge": 3525300,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.5,
    "precoMinimo": 2.8,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.3973187916802101,
    "coeficienteVariacao": 0.113
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JEQUIE",
    "municipioIbge": 2918001,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 4.63,
    "precoMinimo": 4.19,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.22344411544561368,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "JI-PARANA",
    "municipioIbge": 1100122,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.17,
    "precoMinimo": 4.99,
    "precoMaximo": 5.34,
    "desvioPadrao": 0.1755942292142123,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO MONLEVADE",
    "municipioIbge": 3136207,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.28,
    "precoMinimo": 4.18,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.1304388198132968,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "ETHANOL",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 4.7,
    "precoMinimo": 4.57,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.08507699593953255,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO PINHEIRO",
    "municipioIbge": 3136306,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.18,
    "precoMinimo": 4.09,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.0542481072744215,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "ETHANOL",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 4.31,
    "precoMinimo": 4.13,
    "precoMaximo": 4.97,
    "desvioPadrao": 0.21942999751520714,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JUAZEIRO",
    "municipioIbge": 2918407,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.47,
    "precoMinimo": 5.47,
    "precoMaximo": 5.47,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "JUAZEIRO DO NORTE",
    "municipioIbge": 2307304,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 5.45,
    "precoMinimo": 4.99,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.4115403437640769,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 4.53,
    "precoMinimo": 3.95,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.20316182041595632,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.39,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.23942946892192551,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.4,
    "precoMinimo": 5.35,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.052153619241621194,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.56,
    "precoMinimo": 4.27,
    "precoMaximo": 5.03,
    "desvioPadrao": 0.40857475856118836,
    "coeficienteVariacao": 0.09
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.85,
    "precoMinimo": 4.19,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.3714835124201342,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "LAJEDO",
    "municipioIbge": 2608800,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.96,
    "precoMinimo": 4.64,
    "precoMaximo": 5.6,
    "desvioPadrao": 0.3328312885932852,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LAVRAS",
    "municipioIbge": 3138203,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.9,
    "precoMinimo": 3.48,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.33581191589510767,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LEME",
    "municipioIbge": 3526704,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.92,
    "precoMinimo": 3.59,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.2002141710411985,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LEOPOLDINA",
    "municipioIbge": 3138401,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.85,
    "precoMinimo": 4.55,
    "precoMaximo": 4.95,
    "desvioPadrao": 0.1617537811437053,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LIMEIRA",
    "municipioIbge": 3526902,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 3.79,
    "precoMinimo": 3.29,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.4092582408361592,
    "coeficienteVariacao": 0.108
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "LIMOEIRO DO NORTE",
    "municipioIbge": 2307601,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 5.5,
    "precoMinimo": 4.99,
    "precoMaximo": 5.79,
    "desvioPadrao": 0.22682347517152826,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LINS",
    "municipioIbge": 3527108,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.33,
    "precoMinimo": 3.26,
    "precoMaximo": 3.39,
    "desvioPadrao": 0.05657836257007719,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "LIVRAMENTO DE NOSSA SENHORA",
    "municipioIbge": 2919504,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.94,
    "precoMinimo": 4.58,
    "precoMaximo": 5.97,
    "desvioPadrao": 0.5951218362654827,
    "coeficienteVariacao": 0.12
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "LONDRINA",
    "municipioIbge": 4113700,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.76,
    "precoMinimo": 3.34,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.362064139589204,
    "coeficienteVariacao": 0.096
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LORENA",
    "municipioIbge": 3527207,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.14,
    "precoMinimo": 3.89,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.255044347217536,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.28,
    "precoMinimo": 5.07,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.12229939843328282,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AP",
    "estadoNome": "AMAPA",
    "municipioNome": "MACAPA",
    "municipioIbge": 1600303,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.81,
    "precoMinimo": 5.81,
    "precoMaximo": 5.81,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "MACEIO",
    "municipioIbge": 2704302,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 5.09,
    "precoMinimo": 5.09,
    "precoMaximo": 5.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANACAPURU",
    "municipioIbge": 1302504,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.95,
    "precoMinimo": 4.79,
    "precoMaximo": 5.59,
    "desvioPadrao": 0.3204163957519444,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "ETHANOL",
    "postosPesquisados": 29,
    "unidade": "R$/l",
    "precoMedio": 5.02,
    "precoMinimo": 4.79,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.13299875920751636,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "MARABA",
    "municipioIbge": 1504208,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.11,
    "precoMinimo": 4.89,
    "precoMaximo": 5.35,
    "desvioPadrao": 0.18560069786404107,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.69,
    "precoMinimo": 4.39,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.2683281572999747,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MARILIA",
    "municipioIbge": 3529005,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.4,
    "precoMinimo": 2.89,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.28250547014056326,
    "coeficienteVariacao": 0.083
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "MARINGA",
    "municipioIbge": 4115200,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.95,
    "precoMinimo": 3.69,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.0720038806143767,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MATAO",
    "municipioIbge": 3529302,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.9,
    "precoMinimo": 3.89,
    "precoMaximo": 3.93,
    "desvioPadrao": 0.020310096011589902,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.72,
    "precoMinimo": 3.29,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.3204349722308279,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "MINEIROS",
    "municipioIbge": 5213103,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.29,
    "precoMinimo": 4.29,
    "precoMaximo": 4.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOCOCA",
    "municipioIbge": 3530508,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.12,
    "precoMinimo": 3.95,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.12906255404703124,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.69,
    "precoMinimo": 3.19,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.1983201511519724,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI GUACU",
    "municipioIbge": 3530706,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.47,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.24605780711947436,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.67,
    "precoMinimo": 3.32,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.27210489048999364,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MONTE ALTO",
    "municipioIbge": 3531308,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.82,
    "precoMinimo": 3.74,
    "precoMaximo": 3.98,
    "desvioPadrao": 0.08202786982831768,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTE CARMELO",
    "municipioIbge": 3143104,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.88,
    "precoMinimo": 3.68,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.1645285472407231,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTES CLAROS",
    "municipioIbge": 3143302,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 4.06,
    "precoMinimo": 3.94,
    "precoMaximo": 4.26,
    "desvioPadrao": 0.1037537236191317,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 5.51,
    "precoMinimo": 5.29,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.1151645726249127,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MURIAE",
    "municipioIbge": 3143906,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.68,
    "precoMinimo": 4.67,
    "precoMaximo": 4.7,
    "desvioPadrao": 0.008997354108424374,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 5.18,
    "precoMinimo": 4.89,
    "precoMaximo": 5.87,
    "desvioPadrao": 0.27086598596527617,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 4.6,
    "precoMinimo": 4.39,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.1334603561611712,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.45,
    "precoMinimo": 5.3,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.16944025495731527,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NOVA FRIBURGO",
    "municipioIbge": 3303401,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.97,
    "precoMinimo": 4.77,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.18973665961010275,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "NOVA LIMA",
    "municipioIbge": 3144805,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.14,
    "precoMinimo": 3.95,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.2241810492819205,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "NOVO HAMBURGO",
    "municipioIbge": 4313409,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.07,
    "precoMinimo": 3.79,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.17165857586111644,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OLIMPIA",
    "municipioIbge": 3533908,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.44,
    "precoMinimo": 3.29,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.2618614682831909,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "OLINDA",
    "municipioIbge": 2609600,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 5.04,
    "precoMinimo": 5.02,
    "precoMaximo": 5.05,
    "desvioPadrao": 0.00966091783079296,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.76,
    "precoMinimo": 3.39,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.25724132524772275,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "OSORIO",
    "municipioIbge": 4313508,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 3.99,
    "precoMinimo": 3.99,
    "precoMaximo": 3.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OURINHOS",
    "municipioIbge": 3534708,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.55,
    "precoMinimo": 2.94,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.46438707684738295,
    "coeficienteVariacao": 0.131
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "OURO PRETO",
    "municipioIbge": 3146107,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.36,
    "precoMinimo": 4.29,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.048795003647426664,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.47,
    "precoMinimo": 4.89,
    "precoMaximo": 5.89,
    "desvioPadrao": 0.3653243829282475,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARA DE MINAS",
    "municipioIbge": 3147105,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.03,
    "precoMinimo": 3.97,
    "precoMaximo": 4.27,
    "desvioPadrao": 0.11621818561080131,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARACATU",
    "municipioIbge": 3147006,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.88,
    "precoMinimo": 3.67,
    "precoMaximo": 4.1,
    "desvioPadrao": 0.11903630898655611,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAGOMINAS",
    "municipioIbge": 1505502,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.07,
    "precoMinimo": 4.69,
    "precoMaximo": 5.35,
    "desvioPadrao": 0.34428670223134283,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PARAGUACU PAULISTA",
    "municipioIbge": 3535507,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.4,
    "precoMinimo": 3.14,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.2710473513367483,
    "coeficienteVariacao": 0.08
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PARAISO DO TOCANTINS",
    "municipioIbge": 1716109,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.15,
    "precoMinimo": 4.99,
    "precoMaximo": 5.83,
    "desvioPadrao": 0.3756594202199647,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAGUA",
    "municipioIbge": 4118204,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.32,
    "precoMinimo": 4.05,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.3232056694457954,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAVAI",
    "municipioIbge": 4118402,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.63,
    "precoMinimo": 3.4,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.1864518321558834,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAUAPEBAS",
    "municipioIbge": 1505536,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 5.15,
    "precoMinimo": 4.79,
    "precoMaximo": 5.79,
    "desvioPadrao": 0.2953133928557931,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PARNAIBA",
    "municipioIbge": 2207702,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.77,
    "precoMinimo": 4.59,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.20354009783964297,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "PARNAMIRIM",
    "municipioIbge": 2403251,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PASSO FUNDO",
    "municipioIbge": 4314100,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.79,
    "precoMinimo": 4.79,
    "precoMaximo": 4.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PASSOS",
    "municipioIbge": 3147907,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.03,
    "precoMinimo": 3.87,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.2031310469185403,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PATO BRANCO",
    "municipioIbge": 4118501,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.98,
    "precoMinimo": 3.97,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.007071067811865476,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5,
    "precoMinimo": 4.88,
    "precoMaximo": 5.17,
    "desvioPadrao": 0.1167210757481678,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PATROCINIO",
    "municipioIbge": 3148103,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 4.48,
    "precoMinimo": 4.25,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.17193575765937918,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PAULINIA",
    "municipioIbge": 3536505,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.52,
    "precoMinimo": 3.29,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.2,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PAULISTA",
    "municipioIbge": 2610707,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 5.06,
    "precoMinimo": 5.03,
    "precoMaximo": 5.13,
    "desvioPadrao": 0.029489707647632882,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PAULO AFONSO",
    "municipioIbge": 2924009,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.2,
    "precoMinimo": 4.74,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.6975887040369848,
    "coeficienteVariacao": 0.134
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PELOTAS",
    "municipioIbge": 4314407,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.73,
    "precoMinimo": 4.49,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.16172617952223178,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PETROLINA",
    "municipioIbge": 2611101,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 5.5,
    "precoMinimo": 5.4,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.06893091170320681,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 5.49,
    "precoMinimo": 5.42,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.0678988689909958,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PICOS",
    "municipioIbge": 2208007,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.22,
    "precoMinimo": 5,
    "precoMaximo": 5.4,
    "desvioPadrao": 0.20822663934601005,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PIMENTA BUENO",
    "municipioIbge": 1100189,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.49,
    "precoMinimo": 5.49,
    "precoMaximo": 5.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PINHEIRO",
    "municipioIbge": 2108603,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.72,
    "precoMinimo": 5.29,
    "precoMaximo": 5.94,
    "desvioPadrao": 0.37527767497325676,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRACICABA",
    "municipioIbge": 3538709,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 3.58,
    "precoMinimo": 3.29,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.23909551787239064,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRASSUNUNGA",
    "municipioIbge": 3539301,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.65,
    "precoMinimo": 3.47,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.22558917569439405,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PIRIPIRI",
    "municipioIbge": 2208403,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 4.96,
    "precoMinimo": 4.9,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.045,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.92,
    "precoMinimo": 3.57,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.23071318000619606,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "POCOES",
    "municipioIbge": 2925105,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.76,
    "precoMinimo": 4.69,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.10802612117975383,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "POCOS DE CALDAS",
    "municipioIbge": 3151800,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.12,
    "precoMinimo": 3.79,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.3186708507396168,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 4.18,
    "precoMinimo": 3.79,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.22351360883251234,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "PONTA PORA",
    "municipioIbge": 5006606,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.93,
    "precoMinimo": 3.77,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.19371063348151418,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "PORANGATU",
    "municipioIbge": 5218003,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.22,
    "precoMinimo": 4.15,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.07851296526234196,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "ETHANOL",
    "postosPesquisados": 25,
    "unidade": "R$/l",
    "precoMedio": 4.46,
    "precoMinimo": 3.86,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.48496666552111256,
    "coeficienteVariacao": 0.109
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.95,
    "precoMinimo": 3.77,
    "precoMaximo": 4.22,
    "desvioPadrao": 0.1963330503676512,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PORTO SEGURO",
    "municipioIbge": 2925303,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.27,
    "precoMinimo": 5.14,
    "precoMaximo": 5.35,
    "desvioPadrao": 0.10285912696499033,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PORTO VELHO",
    "municipioIbge": 1100205,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 5.22,
    "precoMinimo": 4.89,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.3642449161956265,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRAIA GRANDE",
    "municipioIbge": 3541000,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 4.19,
    "precoMinimo": 3.49,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.41725599348908593,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PRESIDENTE DUTRA",
    "municipioIbge": 2109106,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.8,
    "precoMinimo": 5.49,
    "precoMaximo": 6.1,
    "desvioPadrao": 0.2547744100179608,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRESIDENTE PRUDENTE",
    "municipioIbge": 3541406,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 3.28,
    "precoMinimo": 2.96,
    "precoMaximo": 3.69,
    "desvioPadrao": 0.21472365961858977,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "QUIXADA",
    "municipioIbge": 2311306,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.13,
    "precoMinimo": 4.99,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.15165750888103102,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "RECIFE",
    "municipioIbge": 2611606,
    "produto": "ETHANOL",
    "postosPesquisados": 25,
    "unidade": "R$/l",
    "precoMedio": 5.08,
    "precoMinimo": 5.02,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.04407191093353377,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.6,
    "precoMinimo": 4.18,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.283847922058878,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PIRES",
    "municipioIbge": 3543303,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.67,
    "precoMinimo": 3.39,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.18077215335491092,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PRETO",
    "municipioIbge": 3543402,
    "produto": "ETHANOL",
    "postosPesquisados": 23,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.59,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.14473500386524857,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.77,
    "precoMinimo": 4.28,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.312697937313312,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AC",
    "estadoNome": "ACRE",
    "municipioNome": "RIO BRANCO",
    "municipioIbge": 1200401,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 5.09,
    "precoMinimo": 4.65,
    "precoMaximo": 5.89,
    "desvioPadrao": 0.3475773295253878,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 3.57,
    "precoMinimo": 3.19,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.2741794284302872,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "ETHANOL",
    "postosPesquisados": 62,
    "unidade": "R$/l",
    "precoMedio": 4.66,
    "precoMinimo": 4.07,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.27819524889865244,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "RIO LARGO",
    "municipioIbge": 2707701,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.13,
    "precoMinimo": 5.09,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.11338934190276817,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "RIO VERDE",
    "municipioIbge": 5218805,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.7,
    "precoMinimo": 3.59,
    "precoMaximo": 3.93,
    "desvioPadrao": 0.11117751373564513,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "RONDONOPOLIS",
    "municipioIbge": 5107602,
    "produto": "ETHANOL",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 3.75,
    "precoMinimo": 3.49,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.09643650760992956,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 3.99,
    "precoMinimo": 3.85,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.2257474357814608,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SALGUEIRO",
    "municipioIbge": 2612208,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.58,
    "precoMinimo": 5.49,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.07293833011524188,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SALTO",
    "municipioIbge": 3545209,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.67,
    "precoMinimo": 3.19,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.31819805153394637,
    "coeficienteVariacao": 0.087
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SALVADOR",
    "municipioIbge": 2927408,
    "produto": "ETHANOL",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 4.63,
    "precoMinimo": 4.43,
    "precoMaximo": 5.28,
    "desvioPadrao": 0.30543801491035943,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SANTA CRUZ DO CAPIBARIBE",
    "municipioIbge": 2612505,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.22,
    "precoMinimo": 5.14,
    "precoMaximo": 5.47,
    "desvioPadrao": 0.14310835055998655,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTA MARIA",
    "municipioIbge": 4316907,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.87,
    "precoMinimo": 4.77,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.0864787339672097,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTANA DO LIVRAMENTO",
    "municipioIbge": null,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.6,
    "precoMinimo": 5.39,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.13291601358251257,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "SANTAREM",
    "municipioIbge": 1506807,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 4.58,
    "precoMinimo": 4.35,
    "precoMaximo": 4.97,
    "desvioPadrao": 0.29091808698211485,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.8,
    "precoMinimo": 3.39,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.22065161341563758,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTO ANGELO",
    "municipioIbge": 4317509,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.98,
    "precoMinimo": 4.69,
    "precoMaximo": 5.28,
    "desvioPadrao": 0.20861447696648477,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SANTO ANTONIO DE JESUS",
    "municipioIbge": 2928703,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.09,
    "precoMinimo": 5.09,
    "precoMaximo": 5.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.5,
    "precoMinimo": 4.14,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.3390263837651708,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTOS",
    "municipioIbge": 3548500,
    "produto": "ETHANOL",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 4.08,
    "precoMinimo": 3.35,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.5467279292037572,
    "coeficienteVariacao": 0.134
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 4,
    "precoMinimo": 3.69,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.2922988137013698,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CAETANO DO SUL",
    "municipioIbge": 3548807,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.87,
    "precoMinimo": 3.38,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.43929868350967466,
    "coeficienteVariacao": 0.113
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CARLOS",
    "municipioIbge": 3548906,
    "produto": "ETHANOL",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 3.51,
    "precoMinimo": 2.92,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.4203819125283013,
    "coeficienteVariacao": 0.12
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 4.75,
    "precoMinimo": 4.39,
    "precoMaximo": 5.24,
    "desvioPadrao": 0.28616608052147907,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOAO DA BOA VISTA",
    "municipioIbge": 3549102,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.47,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.26520881260944984,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO JOAO DEL REI",
    "municipioIbge": 3162500,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.42,
    "precoMinimo": 4.38,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.08256310717667224,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "SAO JOSE",
    "municipioIbge": 4216602,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 4.58,
    "precoMinimo": 4.39,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.08659816640231147,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO JOSE DE RIBAMAR",
    "municipioIbge": 2111201,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.01,
    "precoMinimo": 4.77,
    "precoMaximo": 5.2,
    "desvioPadrao": 0.1440899190155396,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DO RIO PRETO",
    "municipioIbge": 3549805,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.16,
    "precoMinimo": 2.94,
    "precoMaximo": 3.49,
    "desvioPadrao": 0.21205345238091897,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.74,
    "precoMinimo": 3.29,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.2925407953757293,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 4.76,
    "precoMinimo": 4.54,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.0824354559373841,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.34,
    "precoMinimo": 4.19,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.12457929201917951,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO LUIS",
    "municipioIbge": 2111300,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 4.97,
    "precoMinimo": 4.68,
    "precoMaximo": 5.18,
    "desvioPadrao": 0.1437233810359687,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LUIZ GONZAGA",
    "municipioIbge": 4318903,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.18,
    "precoMinimo": 4.99,
    "precoMaximo": 5.57,
    "desvioPadrao": 0.33486315612998296,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SAO MATEUS",
    "municipioIbge": 3204906,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 4.55,
    "precoMinimo": 4.55,
    "precoMaximo": 4.55,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "ETHANOL",
    "postosPesquisados": 210,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.19,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.4621903457433276,
    "coeficienteVariacao": 0.122
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO SEBASTIAO DO PARAISO",
    "municipioIbge": 3164704,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.91,
    "precoMinimo": 3.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.32030119753578373,
    "coeficienteVariacao": 0.082
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO VICENTE",
    "municipioIbge": 3551009,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.85,
    "precoMinimo": 3.64,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.3086304874405278,
    "coeficienteVariacao": 0.08
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPIRANGA",
    "municipioIbge": 4319901,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.22,
    "precoMinimo": 3.97,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.23004347415216977,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 4.14,
    "precoMinimo": 3.96,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.1504216296503487,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5,
    "precoMinimo": 4.98,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.03860668582611295,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SENHOR DO BONFIM",
    "municipioIbge": 2930105,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 4.82,
    "precoMinimo": 4.49,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.22735634825293333,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 4.63,
    "precoMinimo": 4.39,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.16414147630146453,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SERRA TALHADA",
    "municipioIbge": 2613909,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.32,
    "precoMinimo": 4.89,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.6286626016128737,
    "coeficienteVariacao": 0.118
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SERRINHA",
    "municipioIbge": 2930501,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.71,
    "precoMinimo": 4.45,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.2229029257002121,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SERTAOZINHO",
    "municipioIbge": 3551702,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.78,
    "precoMinimo": 3.73,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.04821825380496478,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 3.81,
    "precoMinimo": 3.59,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.14583303030271547,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SINOP",
    "municipioIbge": 5107909,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.69,
    "precoMinimo": 3.19,
    "precoMaximo": 3.94,
    "desvioPadrao": 0.22502469000336633,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "SOBRAL",
    "municipioIbge": 2312908,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.45,
    "precoMinimo": 5.29,
    "precoMaximo": 5.69,
    "desvioPadrao": 0.15165750888103102,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SOROCABA",
    "municipioIbge": 3552205,
    "produto": "ETHANOL",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 3.52,
    "precoMinimo": 3.14,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.22361595105727916,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SORRISO",
    "municipioIbge": 5107925,
    "produto": "ETHANOL",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 3.84,
    "precoMinimo": 3.59,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.13784048752090222,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "SOUSA",
    "municipioIbge": 2516201,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.29,
    "precoMinimo": 5.09,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.51,
    "precoMinimo": 3.09,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.25473537227897874,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.64,
    "precoMinimo": 3.38,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.27672188204043424,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TABOAO DA SERRA",
    "municipioIbge": 3552809,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.77,
    "precoMinimo": 3.19,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.9219079594592324,
    "coeficienteVariacao": 0.245
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TATUI",
    "municipioIbge": 3554003,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.09,
    "precoMinimo": 3.29,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.5,
    "coeficienteVariacao": 0.122
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "ETHANOL",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 3.64,
    "precoMinimo": 3.35,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.20011535135054942,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "TEIXEIRA DE FREITAS",
    "municipioIbge": 2931350,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.92,
    "precoMinimo": 4.89,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.95,
    "precoMinimo": 3.74,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.24748737341529164,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "TERESINA",
    "municipioIbge": 2211001,
    "produto": "ETHANOL",
    "postosPesquisados": 26,
    "unidade": "R$/l",
    "precoMedio": 4.88,
    "precoMinimo": 4.49,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.1513554146321219,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "TOLEDO",
    "municipioIbge": 4127700,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 3.9,
    "precoMinimo": 3.39,
    "precoMaximo": 4.52,
    "desvioPadrao": 0.3001464289107548,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 4.89,
    "precoMinimo": 4.89,
    "precoMaximo": 4.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TRES CORACOES",
    "municipioIbge": 3169307,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.51,
    "precoMinimo": 4.19,
    "precoMaximo": 4.74,
    "desvioPadrao": 0.22360679774997896,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.91,
    "precoMinimo": 4.79,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.08366600265340755,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 4.58,
    "precoMinimo": 4.58,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.005773502691896258,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBA",
    "municipioIbge": 3169901,
    "produto": "ETHANOL",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 4.42,
    "precoMinimo": 4.39,
    "precoMaximo": 4.45,
    "desvioPadrao": 0.042426406871192854,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "UBATUBA",
    "municipioIbge": 3555406,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.26,
    "precoMinimo": 3.97,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.22243779226689747,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERABA",
    "municipioIbge": 3170107,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.69,
    "precoMinimo": 3.29,
    "precoMaximo": 4.94,
    "desvioPadrao": 0.5012162983959898,
    "coeficienteVariacao": 0.136
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERLANDIA",
    "municipioIbge": 3170206,
    "produto": "ETHANOL",
    "postosPesquisados": 21,
    "unidade": "R$/l",
    "precoMedio": 4.51,
    "precoMinimo": 4.15,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.14426826862942985,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UMUARAMA",
    "municipioIbge": 4128104,
    "produto": "ETHANOL",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 3.91,
    "precoMinimo": 3.81,
    "precoMaximo": 4.22,
    "desvioPadrao": 0.1222282438299086,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UNAI",
    "municipioIbge": 3170404,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.04,
    "precoMinimo": 3.98,
    "precoMaximo": 4.09,
    "desvioPadrao": 0.05859465277082316,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UNIAO DA VITORIA",
    "municipioIbge": 4128203,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.62,
    "precoMinimo": 4.19,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.20448105046678533,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "URUGUAIANA",
    "municipioIbge": 4322400,
    "produto": "ETHANOL",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 5.29,
    "precoMinimo": 5.29,
    "precoMaximo": 5.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VACARIA",
    "municipioIbge": 4322509,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.09,
    "precoMinimo": 4.64,
    "precoMaximo": 5.65,
    "desvioPadrao": 0.505329925230372,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "ETHANOL",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 4.9,
    "precoMinimo": 4.89,
    "precoMaximo": 4.95,
    "desvioPadrao": 0.02683281572999748,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VALENCA",
    "municipioIbge": 2932903,
    "produto": "ETHANOL",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.13,
    "precoMinimo": 5.09,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.11282097069504157,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VALINHOS",
    "municipioIbge": 3556206,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.59,
    "precoMinimo": 3.39,
    "precoMaximo": 3.89,
    "desvioPadrao": 0.199276469035135,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "VALPARAISO DE GOIAS",
    "municipioIbge": 5221858,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 4.2,
    "precoMinimo": 4.09,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.11666666666666667,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VARGINHA",
    "municipioIbge": 3170701,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 3.86,
    "precoMinimo": 3.39,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.36076462009336663,
    "coeficienteVariacao": 0.093
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "ETHANOL",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 3.77,
    "precoMinimo": 3.75,
    "precoMaximo": 3.79,
    "desvioPadrao": 0.016627404735414787,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VARZEA PAULISTA",
    "municipioIbge": 3556503,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.74,
    "precoMinimo": 3.49,
    "precoMaximo": 3.99,
    "desvioPadrao": 0.18986837546047525,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.92,
    "precoMinimo": 4.59,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.3511884584284246,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VICOSA",
    "municipioIbge": 3171303,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.27,
    "precoMinimo": 3.89,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.25825997422309616,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "VIDEIRA",
    "municipioIbge": 4219309,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.95,
    "precoMinimo": 4.59,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.47258156262526085,
    "coeficienteVariacao": 0.095
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VILA VELHA",
    "municipioIbge": 3205200,
    "produto": "ETHANOL",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 4.57,
    "precoMinimo": 4.28,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.26210540327174187,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "VILHENA",
    "municipioIbge": 1100304,
    "produto": "ETHANOL",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.72,
    "precoMinimo": 5.3,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.33496268448888455,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VITORIA",
    "municipioIbge": 3205309,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 4.6,
    "precoMinimo": 4.39,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.2328661990643268,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "ETHANOL",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 4.63,
    "precoMinimo": 4.29,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.3072221582917719,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "VITORIA DE SANTO ANTAO",
    "municipioIbge": 2616407,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 4.92,
    "precoMinimo": 4.89,
    "precoMaximo": 5.19,
    "desvioPadrao": 0.10606601717798213,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "ETHANOL",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 5.01,
    "precoMinimo": 4.69,
    "precoMaximo": 5.15,
    "desvioPadrao": 0.13327081867802534,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTORANTIM",
    "municipioIbge": 3557006,
    "produto": "ETHANOL",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 3.41,
    "precoMinimo": 3.09,
    "precoMaximo": 3.69,
    "desvioPadrao": 0.2152573210966686,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTUPORANGA",
    "municipioIbge": 3557105,
    "produto": "ETHANOL",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 3.43,
    "precoMinimo": 3.29,
    "precoMaximo": 3.8,
    "desvioPadrao": 0.1464581851587681,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "XANXERE",
    "municipioIbge": 4219507,
    "produto": "ETHANOL",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 4.72,
    "precoMinimo": 4.59,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ABAETETUBA",
    "municipioIbge": 1500107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 6.99,
    "precoMaximo": 7.55,
    "desvioPadrao": 0.24185050478894327,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ADAMANTINA",
    "municipioIbge": 3500105,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.23,
    "precoMaximo": 6.71,
    "desvioPadrao": 0.22512430428754773,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "AGUAS LINDAS DE GOIAS",
    "municipioIbge": 5200258,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.49,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.0987420882906575,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.51,
    "precoMaximo": 7.26,
    "desvioPadrao": 0.2504947485429965,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALEGRETE",
    "municipioIbge": 4300406,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.10829852920779409,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALENQUER",
    "municipioIbge": 1500404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 6.89,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.23388031127053,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ALFENAS",
    "municipioIbge": 3101607,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.29,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.24961398770329934,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "ALTA FLORESTA",
    "municipioIbge": 5100250,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.35,
    "precoMinimo": 7.29,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.05507570547286102,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALTAMIRA",
    "municipioIbge": 1500602,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.33,
    "precoMinimo": 7.05,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.19052558883257653,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALVORADA",
    "municipioIbge": 4300604,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.39,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.09574271077563382,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2507233978355874,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ANANINDEUA",
    "municipioIbge": 1500800,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.17,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.5519057890618652,
    "coeficienteVariacao": 0.083
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ANAPOLIS",
    "municipioIbge": 5201108,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.89,
    "precoMaximo": 7.14,
    "desvioPadrao": 0.10904127658827184,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.3,
    "precoMinimo": 7.08,
    "precoMaximo": 7.57,
    "desvioPadrao": 0.17406895185529211,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "APARECIDA DE GOIANIA",
    "municipioIbge": 5201405,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.65,
    "precoMaximo": 7.24,
    "desvioPadrao": 0.17898634336482522,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "APUCARANA",
    "municipioIbge": 4101408,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.59,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.15280706789936124,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.12,
    "precoMaximo": 7.52,
    "desvioPadrao": 0.14741173555799342,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARACATUBA",
    "municipioIbge": 3502804,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 5.98,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.27351416782316784,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "ARACRUZ",
    "municipioIbge": 3200607,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "ARAGUAINA",
    "municipioIbge": 1702109,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 6.87,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.11689933509415075,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.44,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.22570876022973596,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAPONGAS",
    "municipioIbge": 4101507,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.12659694196261503,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.54,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.14330287605527772,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.14,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.33060382467371563,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAS",
    "municipioIbge": 3503307,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.17,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.19881793537951106,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARARIPINA",
    "municipioIbge": 2601102,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.56,
    "precoMinimo": 7.51,
    "precoMaximo": 7.61,
    "desvioPadrao": 0.0530722777603022,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.99,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.04183300132670378,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAUCARIA",
    "municipioIbge": 4101804,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.74,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.079435508432942,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ARAXA",
    "municipioIbge": 3104007,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3150255091711962,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARCOVERDE",
    "municipioIbge": 2601201,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.89,
    "precoMaximo": 7.04,
    "desvioPadrao": 0.06123724356957946,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "ARIQUEMES",
    "municipioIbge": 1100023,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.46,
    "precoMinimo": 7.29,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.15770111875678897,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ASSIS",
    "municipioIbge": 3504008,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.06,
    "precoMinimo": 6.39,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.45,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ATIBAIA",
    "municipioIbge": 3504107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.19,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.39876703915337774,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AVARE",
    "municipioIbge": 3504503,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.69,
    "precoMaximo": 6.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BACABAL",
    "municipioIbge": 2101202,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.89,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BAGE",
    "municipioIbge": 4301602,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.52,
    "precoMinimo": 7.25,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.16492422502470644,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BALSAS",
    "municipioIbge": 2101400,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.35,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.2540341184434353,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BARBACENA",
    "municipioIbge": 3105608,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.99,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.06,
    "precoMinimo": 6.85,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.13533028380331477,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.69,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.13285330255586425,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "BARREIRAS",
    "municipioIbge": 2903201,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.88,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.1099025542404335,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARRETOS",
    "municipioIbge": 3505500,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3473902704452156,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARUERI",
    "municipioIbge": 3505708,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.29,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.5900693333683917,
    "coeficienteVariacao": 0.085
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BAURU",
    "municipioIbge": 3506003,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.29,
    "precoMaximo": 6.76,
    "desvioPadrao": 0.19882152800941855,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.49,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.13203534880225573,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BEBEDOURO",
    "municipioIbge": 3506102,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 6.19,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.17435595774162696,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BELEM",
    "municipioIbge": 1501402,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.47,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.28699146775488393,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 40,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.89,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3246279922208394,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "BELO JARDIM",
    "municipioIbge": 2601706,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.43,
    "precoMaximo": 6.7,
    "desvioPadrao": 0.14429137188342206,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.29,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.10562512327408981,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BETIM",
    "municipioIbge": 3106705,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.07,
    "precoMinimo": 5.85,
    "precoMaximo": 6.27,
    "desvioPadrao": 0.15763882770434445,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BIRIGUI",
    "municipioIbge": 3506508,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2786873995477131,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.27,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.2617354667320701,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RR",
    "estadoNome": "RORAIMA",
    "municipioNome": "BOA VISTA",
    "municipioIbge": 1400100,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 7.63,
    "precoMinimo": 7.59,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.044462603128056694,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BOM DESPACHO",
    "municipioIbge": 3107406,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 6.19,
    "precoMaximo": 6.38,
    "desvioPadrao": 0.08573214099741124,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BRAGANCA",
    "municipioIbge": 1501709,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.85,
    "precoMaximo": 7.34,
    "desvioPadrao": 0.22218610817660644,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BRAGANCA PAULISTA",
    "municipioIbge": 3507605,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.37,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.2743375860342711,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "DF",
    "estadoNome": "DISTRITO FEDERAL",
    "municipioNome": "BRASILIA",
    "municipioIbge": 5300108,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 42,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.39,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.18280940869409534,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.44,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.10669270515519481,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.38,
    "precoMaximo": 6.77,
    "desvioPadrao": 0.15727894540168644,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CABO DE SANTO AGOSTINHO",
    "municipioIbge": 2602902,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.99,
    "precoMaximo": 7.22,
    "desvioPadrao": 0.11090536506409418,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CABO FRIO",
    "municipioIbge": 3300704,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.1,
    "precoMinimo": 6.79,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.18742141210194133,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CACADOR",
    "municipioIbge": 4203006,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.23566016694748032,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.07,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.414961271859022,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CACERES",
    "municipioIbge": 5102504,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.53,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.06250333324444919,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRA DO SUL",
    "municipioIbge": 4303004,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 6.24,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.06232117273791124,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRINHA",
    "municipioIbge": 4303103,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.16,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.19178112524437854,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.33,
    "precoMinimo": 7.14,
    "precoMaximo": 7.56,
    "desvioPadrao": 0.16078799015404657,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "CACOAL",
    "municipioIbge": 1100049,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.3,
    "precoMinimo": 7.12,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.09007933011676827,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "CAETITE",
    "municipioIbge": 2905206,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.66,
    "precoMinimo": 7.59,
    "precoMaximo": 7.7,
    "desvioPadrao": 0.049904671028634086,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "CAICO",
    "municipioIbge": 2402006,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.45,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.3161012496020856,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CALDAS NOVAS",
    "municipioIbge": 5204508,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.72,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.06984108946585654,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMBE",
    "municipioIbge": 4103701,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 5.99,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.5522680508593631,
    "coeficienteVariacao": 0.08
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.39,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.14215956056256174,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 24,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 5.99,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.3161312216079935,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CAMPO BELO",
    "municipioIbge": 3111200,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 6.29,
    "precoMaximo": 6.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.19,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.13948526929707378,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO LARGO",
    "municipioIbge": 4104204,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.62,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.03311595788538611,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO MOURAO",
    "municipioIbge": 4104303,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.15,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.19415629442968535,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.39,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1565921808747522,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CANINDE",
    "municipioIbge": 2302800,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.99,
    "precoMaximo": 7.05,
    "desvioPadrao": 0.02683281572999748,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.09,
    "precoMinimo": 5.76,
    "precoMaximo": 6.96,
    "desvioPadrao": 0.3835180714270334,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CARAGUATATUBA",
    "municipioIbge": 3510500,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.47,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.20827332469084414,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CARATINGA",
    "municipioIbge": 3113404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.15,
    "precoMaximo": 6.75,
    "desvioPadrao": 0.17914612285319864,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.23895986730373406,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASCAVEL",
    "municipioIbge": 4104808,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.29,
    "precoMaximo": 7.08,
    "desvioPadrao": 0.2472687165450134,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CASTANHAL",
    "municipioIbge": 1502400,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.55,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.147648230602334,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASTRO",
    "municipioIbge": 4104907,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.99,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.15745747725293055,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CATALAO",
    "municipioIbge": 5205109,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.18,
    "precoMaximo": 6.84,
    "desvioPadrao": 0.254983659607173,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CAUCAIA",
    "municipioIbge": 2303709,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.55,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1361900410188912,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.26,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.1304378591043233,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CHAPECO",
    "municipioIbge": 4204202,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1881999754761694,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CIANORTE",
    "municipioIbge": 4105508,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.59,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "CODO",
    "municipioIbge": 2103307,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.72,
    "precoMinimo": 7.67,
    "precoMaximo": 7.74,
    "desvioPadrao": 0.030822070014844882,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "COLATINA",
    "municipioIbge": 3201506,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.10171856598805681,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.1,
    "precoMinimo": 6.79,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.18055470085267789,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CONCEICAO DO ARAGUAIA",
    "municipioIbge": 1502707,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.21,
    "precoMinimo": 7.15,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.07211102550927978,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CONCORDIA",
    "municipioIbge": 4204301,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.19789968598834543,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONGONHAS",
    "municipioIbge": 3118007,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.59,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONSELHEIRO LAFAIETE",
    "municipioIbge": 3118304,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.21323695739716417,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.18,
    "precoMinimo": 5.87,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2243199599778059,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CORNELIO PROCOPIO",
    "municipioIbge": 4106407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.87,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.09418067742376883,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CORONEL FABRICIANO",
    "municipioIbge": 3119401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.64,
    "precoMaximo": 6.78,
    "desvioPadrao": 0.07571877794400365,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CORUMBA",
    "municipioIbge": 5003207,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 7.1,
    "precoMaximo": 7.26,
    "desvioPadrao": 0.05244044240850758,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COSMOPOLIS",
    "municipioIbge": 3512803,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 6.19,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2217355782608345,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COTIA",
    "municipioIbge": 3513009,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 5.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.32404545135745166,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CRATEUS",
    "municipioIbge": 2304103,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.58,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.5728059590006608,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.57,
    "precoMaximo": 7.18,
    "desvioPadrao": 0.16735115851529161,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CRUZ ALTA",
    "municipioIbge": 4306106,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.08,
    "precoMinimo": 5.78,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.5253887449625595,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.19,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.19776248380317235,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CUBATAO",
    "municipioIbge": 3513504,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.12,
    "precoMinimo": 6.79,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2250925735484551,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CUIABA",
    "municipioIbge": 5103403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.75,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.10796824930109249,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CURITIBA",
    "municipioIbge": 4106902,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 27,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.79,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.1096744730030194,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CURVELO",
    "municipioIbge": 3120904,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.36,
    "precoMaximo": 6.6,
    "desvioPadrao": 0.09584710046040344,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "DELMIRO GOUVEIA",
    "municipioIbge": 2702405,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.83,
    "precoMinimo": 7.59,
    "precoMaximo": 8.04,
    "desvioPadrao": 0.2043281674170255,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "DIADEMA",
    "municipioIbge": 3513801,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.29,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.36224607965059086,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "DIVINOPOLIS",
    "municipioIbge": 3122306,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.25,
    "precoMinimo": 6.19,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "DOURADOS",
    "municipioIbge": 5003702,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.6,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.30589758634767505,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "EMBU DAS ARTES",
    "municipioIbge": 3515004,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.19,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.5353770367027068,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ERECHIM",
    "municipioIbge": 4307005,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.17799387119173002,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.25,
    "precoMinimo": 5.67,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.3487050875671849,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "EUNAPOLIS",
    "municipioIbge": 2910727,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.35,
    "precoMinimo": 7.12,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.2325121604602752,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.51,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.24688974351832732,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.26,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.2721389044832314,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FORMIGA",
    "municipioIbge": 3126109,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.19,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2509980079602227,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "FORMOSA",
    "municipioIbge": 5208004,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.40414518843273806,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "FORTALEZA",
    "municipioIbge": 2304400,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 38,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.43,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1425095140444038,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "FRANCA",
    "municipioIbge": 3516200,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.53,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.22867702512098112,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "FRANCISCO BELTRAO",
    "municipioIbge": 4108403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.5,
    "precoMaximo": 6.5,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FRUTAL",
    "municipioIbge": 3127107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.19,
    "precoMinimo": 6.09,
    "precoMaximo": 6.28,
    "desvioPadrao": 0.0971253485622231,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "GARANHUNS",
    "municipioIbge": 2606002,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.73,
    "precoMaximo": 7.04,
    "desvioPadrao": 0.106256652452805,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GARCA",
    "municipioIbge": 3516705,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.49,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.05163977794943223,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIANIA",
    "municipioIbge": 5208707,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 30,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.67,
    "precoMaximo": 7.57,
    "desvioPadrao": 0.2679243331163896,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIATUBA",
    "municipioIbge": 5209101,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 5.98,
    "precoMinimo": 5.98,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.007071067811865476,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GOVERNADOR VALADARES",
    "municipioIbge": 3127701,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 6.18,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2098412098071619,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAMADO",
    "municipioIbge": 4309100,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.12136132591798521,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.46,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.11886967653695371,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GUAIBA",
    "municipioIbge": 4309308,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.13,
    "precoMinimo": 6.05,
    "precoMaximo": 6.25,
    "desvioPadrao": 0.07406560798180412,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "GUANAMBI",
    "municipioIbge": 2911709,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.21,
    "precoMinimo": 7.08,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.11590225767142474,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "GUARAPARI",
    "municipioIbge": 3202405,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 6.81,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.24668878600953298,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "GUARAPUAVA",
    "municipioIbge": 4109401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6,
    "precoMinimo": 5.79,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.22370841411411987,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.24,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.22875751353780713,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARUJA",
    "municipioIbge": 3518701,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.59,
    "precoMaximo": 8.19,
    "desvioPadrao": 0.5255382728122436,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 18,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.09,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.32175631179979447,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GUAXUPE",
    "municipioIbge": 3128709,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.39,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.125,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "GURUPI",
    "municipioIbge": 1709500,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.49,
    "precoMaximo": 7.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.35,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.16638643107069892,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "IBITINGA",
    "municipioIbge": 3519600,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.09,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.30400109648925067,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ICO",
    "municipioIbge": 2305407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 7.07,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.08876936408468859,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "IGARASSU",
    "municipioIbge": 2606804,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.97,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.09797958971132713,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "IGUATU",
    "municipioIbge": 2305506,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.54,
    "precoMinimo": 7.47,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.05740416444159862,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "IJUI",
    "municipioIbge": 4310207,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 6.19,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.22090722034374521,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ILHEUS",
    "municipioIbge": 2913606,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.34,
    "precoMinimo": 7.24,
    "precoMaximo": 7.56,
    "desvioPadrao": 0.10954451150103323,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "IMPERATRIZ",
    "municipioIbge": 2105302,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17078251276599332,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "INDAIATUBA",
    "municipioIbge": 3520509,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1587713240271471,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "IPATINGA",
    "municipioIbge": 3131307,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.59,
    "precoMaximo": 6.81,
    "desvioPadrao": 0.08846845012017938,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IPIRA",
    "municipioIbge": 2914000,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.55,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.23065125189341593,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IRECE",
    "municipioIbge": 2914604,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 7.05,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.09909591313469995,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ITABAIANA",
    "municipioIbge": 2802908,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 7.05,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.08164965809277261,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.39,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.3056063449852409,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.3,
    "precoMinimo": 7.24,
    "precoMaximo": 7.43,
    "desvioPadrao": 0.1096965511460289,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.23,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.21708145700257075,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAJUBA",
    "municipioIbge": 3132404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.45,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.22030282189144407,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITAMARAJU",
    "municipioIbge": 2915601,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 7.16,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.021213203435596427,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPECERICA DA SERRA",
    "municipioIbge": 3522208,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.19,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.33964266937053544,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.69,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.13291601358251257,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ITAPIPOCA",
    "municipioIbge": 2306405,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.52,
    "precoMinimo": 7.49,
    "precoMaximo": 7.58,
    "desvioPadrao": 0.03925648263117098,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPIRA",
    "municipioIbge": 3522604,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.24929901724635822,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPOLIS",
    "municipioIbge": 3522703,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.39,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2081665999466133,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 5.96,
    "precoMaximo": 8.27,
    "desvioPadrao": 0.6828498580005921,
    "coeficienteVariacao": 0.101
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.45,
    "precoMaximo": 6.95,
    "desvioPadrao": 0.24055491403558288,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAUNA",
    "municipioIbge": 3133808,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.39,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.16431676725154984,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.24,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.17590074311546108,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITUIUTABA",
    "municipioIbge": 3134202,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.19,
    "precoMaximo": 6.52,
    "desvioPadrao": 0.2333452377915607,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ITUMBIARA",
    "municipioIbge": 5211503,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.59,
    "precoMaximo": 6.61,
    "desvioPadrao": 0.014142135623730952,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "JABOATAO DOS GUARARAPES",
    "municipioIbge": 2607901,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 7.09,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.05656854249492381,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JABOTICABAL",
    "municipioIbge": 3524303,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.65,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.21602468994692867,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 6.14,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2114506174887263,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JACOBINA",
    "municipioIbge": 2917508,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.89,
    "precoMaximo": 7.08,
    "desvioPadrao": 0.05680375574437545,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JAGUAQUARA",
    "municipioIbge": 2917607,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.49,
    "precoMaximo": 7.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JALES",
    "municipioIbge": 3524808,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2738612787525831,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANAUBA",
    "municipioIbge": 3135100,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.36,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.546168472176855,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANUARIA",
    "municipioIbge": 3135209,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.69,
    "precoMaximo": 6.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JAU",
    "municipioIbge": 3525300,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 5.9,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3389242435370224,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JEQUIE",
    "municipioIbge": 2918001,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.57,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.25718994277900264,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "JI-PARANA",
    "municipioIbge": 1100122,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.31,
    "precoMinimo": 7.02,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.12421389177177775,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO MONLEVADE",
    "municipioIbge": 3136207,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.44,
    "precoMaximo": 6.85,
    "desvioPadrao": 0.15942605391424158,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.45,
    "precoMaximo": 6.96,
    "desvioPadrao": 0.142796740477187,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO PINHEIRO",
    "municipioIbge": 3136306,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.35,
    "precoMaximo": 6.62,
    "desvioPadrao": 0.13650396819628846,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 5.97,
    "precoMaximo": 6.77,
    "desvioPadrao": 0.23248592990187425,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JUAZEIRO",
    "municipioIbge": 2918407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.39,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.10016652800877814,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "JUAZEIRO DO NORTE",
    "municipioIbge": 2307304,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.23,
    "precoMinimo": 6.82,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.1941634634771706,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.45,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.15122212757441245,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.19,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.2857322464592799,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.99,
    "precoMaximo": 7.33,
    "desvioPadrao": 0.12149857925879118,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.25,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.41117717186958064,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 6.09,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.1417509553171806,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "LAJEDO",
    "municipioIbge": 2608800,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.47,
    "precoMaximo": 6.75,
    "desvioPadrao": 0.125532200384337,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LAVRAS",
    "municipioIbge": 3138203,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.08,
    "precoMaximo": 6.85,
    "desvioPadrao": 0.2387001838662421,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LEME",
    "municipioIbge": 3526704,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LEOPOLDINA",
    "municipioIbge": 3138401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 7.11,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.016329931618554522,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LIMEIRA",
    "municipioIbge": 3526902,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.49,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.28751811537130434,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "LIMOEIRO DO NORTE",
    "municipioIbge": 2307601,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.11,
    "precoMinimo": 6.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.13887301496588272,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LINS",
    "municipioIbge": 3527108,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 6.16,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.1250333288900737,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "LIVRAMENTO DE NOSSA SENHORA",
    "municipioIbge": 2919504,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.84,
    "precoMinimo": 7.84,
    "precoMaximo": 7.85,
    "desvioPadrao": 0.005773502691896258,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "LONDRINA",
    "municipioIbge": 4113700,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.09,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.3341830835535116,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LORENA",
    "municipioIbge": 3527207,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.34,
    "precoMaximo": 7.05,
    "desvioPadrao": 0.26628305741572567,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.75,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.18012341448141728,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AP",
    "estadoNome": "AMAPA",
    "municipioNome": "MACAPA",
    "municipioIbge": 1600303,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.69,
    "precoMaximo": 6.84,
    "desvioPadrao": 0.08660254037844387,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "MACEIO",
    "municipioIbge": 2704302,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 7.03,
    "precoMinimo": 6.87,
    "precoMaximo": 7.27,
    "desvioPadrao": 0.13582902417938447,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANACAPURU",
    "municipioIbge": 1302504,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.75,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.13899640283115244,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 31,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 7.29,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.0672021505032247,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "MARABA",
    "municipioIbge": 1504208,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.46,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.24300777308098148,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.59,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2683281572999747,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MARILIA",
    "municipioIbge": 3529005,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 5.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3562291992864179,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "MARINGA",
    "municipioIbge": 4115200,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.29,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2628633539638853,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MATAO",
    "municipioIbge": 3529302,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.55,
    "precoMaximo": 6.72,
    "desvioPadrao": 0.0805708797684788,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 5.96,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3494931394826722,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "MINEIROS",
    "municipioIbge": 5213103,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.99,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.07998883850709601,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOCOCA",
    "municipioIbge": 3530508,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.89,
    "precoMaximo": 7.03,
    "desvioPadrao": 0.0621825270205921,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.34,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2595013533316395,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI GUACU",
    "municipioIbge": 3530706,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.19,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.20701966780270625,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.09574271077563382,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MONTE ALTO",
    "municipioIbge": 3531308,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.35597752738059185,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTE CARMELO",
    "municipioIbge": 3143104,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 6.19,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.12583057392117916,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTES CLAROS",
    "municipioIbge": 3143302,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 6.18,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.15455132193259014,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.1,
    "precoMinimo": 6.99,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.05774464862170731,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MURIAE",
    "municipioIbge": 3143906,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.71,
    "precoMaximo": 7.14,
    "desvioPadrao": 0.13808210118138653,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.74,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.12777421492617358,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.12909944487358058,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.24,
    "precoMinimo": 7.19,
    "precoMaximo": 7.37,
    "desvioPadrao": 0.07047458170621992,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NOVA FRIBURGO",
    "municipioIbge": 3303401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.19,
    "precoMinimo": 6.85,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.2490203026082635,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "NOVA LIMA",
    "municipioIbge": 3144805,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.54,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.19407902170679517,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "NOVO HAMBURGO",
    "municipioIbge": 4313409,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.25,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.1603329868326124,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OLIMPIA",
    "municipioIbge": 3533908,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.47,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.34917590054843356,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "OLINDA",
    "municipioIbge": 2609600,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.9,
    "precoMaximo": 7.05,
    "desvioPadrao": 0.053049841793220406,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.09,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.3064885611164601,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "OSORIO",
    "municipioIbge": 4313508,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.17,
    "precoMinimo": 5.94,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.2254624876411447,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OURINHOS",
    "municipioIbge": 3534708,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "OURO PRETO",
    "municipioIbge": 3146107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 6.39,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.0433589667773576,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.9,
    "precoMaximo": 7.14,
    "desvioPadrao": 0.08757853618324528,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARA DE MINAS",
    "municipioIbge": 3147105,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.42,
    "precoMaximo": 8.28,
    "desvioPadrao": 0.6262687122952895,
    "coeficienteVariacao": 0.092
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARACATU",
    "municipioIbge": 3147006,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.42,
    "precoMaximo": 6.56,
    "desvioPadrao": 0.07274384280931732,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAGOMINAS",
    "municipioIbge": 1505502,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 6.95,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.1293058390019569,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PARAGUACU PAULISTA",
    "municipioIbge": 3535507,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.09,
    "precoMaximo": 6.87,
    "desvioPadrao": 0.3037762334350731,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PARAISO DO TOCANTINS",
    "municipioIbge": 1716109,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.89,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.16586892415398372,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAGUA",
    "municipioIbge": 4118204,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3063005060394122,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAVAI",
    "municipioIbge": 4118402,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.33,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.35820385257559695,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAUAPEBAS",
    "municipioIbge": 1505536,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.34,
    "precoMinimo": 6.99,
    "precoMaximo": 7.57,
    "desvioPadrao": 0.24719762674157425,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "PARINTINS",
    "municipioIbge": 1303403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 8.99,
    "precoMinimo": 8.99,
    "precoMaximo": 8.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PARNAIBA",
    "municipioIbge": 2207702,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.77,
    "precoMaximo": 7.28,
    "desvioPadrao": 0.18813622217754372,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "PARNAMIRIM",
    "municipioIbge": 2403251,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.75,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16970562748477142,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PASSO FUNDO",
    "municipioIbge": 4314100,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.69,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.044721359549995794,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PASSOS",
    "municipioIbge": 3147907,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 5.97,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.44219528114472983,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PATO BRANCO",
    "municipioIbge": 4118501,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.39,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.13969354213522442,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.1541103500742244,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PATROCINIO",
    "municipioIbge": 3148103,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.29,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.32002604060711476,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PAULINIA",
    "municipioIbge": 3536505,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.89,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.23299294900428702,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PAULISTA",
    "municipioIbge": 2610707,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.03,
    "precoMinimo": 6.97,
    "precoMaximo": 7.07,
    "desvioPadrao": 0.03823486317361109,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PAULO AFONSO",
    "municipioIbge": 2924009,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.98,
    "precoMaximo": 7.78,
    "desvioPadrao": 0.25921585048537665,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PELOTAS",
    "municipioIbge": 4314407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.68,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.11557083389445118,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PETROLINA",
    "municipioIbge": 2611101,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 7.55,
    "precoMinimo": 7.44,
    "precoMaximo": 7.78,
    "desvioPadrao": 0.08770214744615247,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.15,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.11060522810209508,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PICOS",
    "municipioIbge": 2208007,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.7,
    "precoMaximo": 7.02,
    "desvioPadrao": 0.10670832519848987,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PIMENTA BUENO",
    "municipioIbge": 1100189,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.47,
    "precoMinimo": 7.43,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.029277002188455997,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PINHEIRO",
    "municipioIbge": 2108603,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.27,
    "precoMinimo": 7.19,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.07014271166700073,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRACICABA",
    "municipioIbge": 3538709,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.263673679998231,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRASSUNUNGA",
    "municipioIbge": 3539301,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.28,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.19578048932414077,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PIRIPIRI",
    "municipioIbge": 2208403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.38,
    "precoMinimo": 7.18,
    "precoMaximo": 7.65,
    "desvioPadrao": 0.1920850506069295,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.44,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.3006936425444786,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "POCOES",
    "municipioIbge": 2925105,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.95,
    "precoMaximo": 7.05,
    "desvioPadrao": 0.07071067811865475,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "POCOS DE CALDAS",
    "municipioIbge": 3151800,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2258317958127243,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.19,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2555237385300649,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "PONTA PORA",
    "municipioIbge": 5006606,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.56,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16724661004465405,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "PORANGATU",
    "municipioIbge": 5218003,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.74,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.028867513459481287,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 33,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.74,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.33116301030450157,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.17907168024751058,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PORTO SEGURO",
    "municipioIbge": 2925303,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.5,
    "precoMinimo": 7.34,
    "precoMaximo": 7.55,
    "desvioPadrao": 0.09289779329994874,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PORTO VELHO",
    "municipioIbge": 1100205,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 7.58,
    "precoMinimo": 7.29,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.17496190061458144,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRAIA GRANDE",
    "municipioIbge": 3541000,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.24,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.3403021533219494,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PRESIDENTE DUTRA",
    "municipioIbge": 2109106,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 7.15,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.03443996386628637,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRESIDENTE PRUDENTE",
    "municipioIbge": 3541406,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.19,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.31685959035509725,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "QUIXADA",
    "municipioIbge": 2311306,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.65,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.0808290376865476,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "RECIFE",
    "municipioIbge": 2611606,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 24,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.87,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.09368077154102511,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.39,
    "precoMaximo": 7.14,
    "desvioPadrao": 0.24800633632458438,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PIRES",
    "municipioIbge": 3543303,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.07867957924694431,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PRETO",
    "municipioIbge": 3543402,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.47,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2534185320392974,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.75,
    "precoMaximo": 7.08,
    "desvioPadrao": 0.14150971698084908,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AC",
    "estadoNome": "ACRE",
    "municipioNome": "RIO BRANCO",
    "municipioIbge": 1200401,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.37,
    "precoMinimo": 7.18,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.10061929449286765,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 5.95,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2555101848174639,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 76,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.09,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.24344962373814757,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "RIO LARGO",
    "municipioIbge": 2707701,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.77,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.06066300355241241,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "RIO VERDE",
    "municipioIbge": 5218805,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.39,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.23440908482313363,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "RONDONOPOLIS",
    "municipioIbge": 5107602,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.49,
    "precoMaximo": 7.18,
    "desvioPadrao": 0.22002840725688128,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 6.19,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SALGUEIRO",
    "municipioIbge": 2612208,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.19,
    "precoMinimo": 7.14,
    "precoMaximo": 7.32,
    "desvioPadrao": 0.07158079018709924,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SALTO",
    "municipioIbge": 3545209,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.59,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.0987420882906575,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SALVADOR",
    "municipioIbge": 2927408,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.53,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.27842917774102605,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SANTA CRUZ DO CAPIBARIBE",
    "municipioIbge": 2612505,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.78,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.16856537519397544,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTA MARIA",
    "municipioIbge": 4316907,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.07,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.29877098681783437,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTANA DO LIVRAMENTO",
    "municipioIbge": null,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.93,
    "precoMaximo": 7.26,
    "desvioPadrao": 0.10525102269231296,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "SANTAREM",
    "municipioIbge": 1506807,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.58,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.3865962579574027,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 18,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.29,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.33368804656190587,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTO ANGELO",
    "municipioIbge": 4317509,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.48,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.3013303834663873,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SANTO ANTONIO DE JESUS",
    "municipioIbge": 2928703,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.4,
    "precoMinimo": 7.38,
    "precoMaximo": 7.48,
    "desvioPadrao": 0.05,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.55,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.16711606080140168,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTOS",
    "municipioIbge": 3548500,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.18,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.4571287200195003,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.42,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.4630852548034479,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CAETANO DO SUL",
    "municipioIbge": 3548807,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.12,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.42673176586703737,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CARLOS",
    "municipioIbge": 3548906,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 5.99,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.36146167909551,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16329931618554522,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOAO DA BOA VISTA",
    "municipioIbge": 3549102,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.25394975131012865,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO JOAO DEL REI",
    "municipioIbge": 3162500,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.69,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.1776701062831524,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "SAO JOSE",
    "municipioIbge": 4216602,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.74,
    "precoMaximo": 7.04,
    "desvioPadrao": 0.11875036148007447,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO JOSE DE RIBAMAR",
    "municipioIbge": 2111201,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.18428755997599178,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DO RIO PRETO",
    "municipioIbge": 3549805,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.59,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2345207879911715,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 5.79,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2951376797360852,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 6.89,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.14520483616066113,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 6.05,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.20333060107453904,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO LUIS",
    "municipioIbge": 2111300,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.65,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.13503086067019396,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LUIZ GONZAGA",
    "municipioIbge": 4318903,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16253204812179864,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 183,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 5.98,
    "precoMaximo": 8.99,
    "desvioPadrao": 0.5369385350784304,
    "coeficienteVariacao": 0.08
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO SEBASTIAO DO PARAISO",
    "municipioIbge": 3164704,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.39,
    "precoMaximo": 6.58,
    "desvioPadrao": 0.07762087348130013,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO VICENTE",
    "municipioIbge": 3551009,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.14,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.5283059178706433,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPIRANGA",
    "municipioIbge": 4319901,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 5.65,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.29668806771390305,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.15,
    "precoMinimo": 5.69,
    "precoMaximo": 6.64,
    "desvioPadrao": 0.3387160631392781,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.89,
    "precoMaximo": 7.14,
    "desvioPadrao": 0.10293317295817755,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SENHOR DO BONFIM",
    "municipioIbge": 2930105,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.79,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.28985628622934273,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.15607361839521233,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SERRA TALHADA",
    "municipioIbge": 2613909,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.48,
    "precoMaximo": 6.86,
    "desvioPadrao": 0.26870057685088805,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SERRINHA",
    "municipioIbge": 2930501,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.79,
    "precoMaximo": 7.12,
    "desvioPadrao": 0.1320101006236518,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SERTAOZINHO",
    "municipioIbge": 3551702,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.6,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.08103497187428813,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.17,
    "precoMinimo": 5.99,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.14716255699673808,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SINOP",
    "municipioIbge": 5107909,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.03,
    "precoMinimo": 6.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.09759000729485333,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "SOBRAL",
    "municipioIbge": 2312908,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 7.09,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.11278297743897348,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SOROCABA",
    "municipioIbge": 3552205,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.09,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.23855601933083634,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SORRISO",
    "municipioIbge": 5107925,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.19,
    "precoMinimo": 6.99,
    "precoMaximo": 7.65,
    "desvioPadrao": 0.24661035393240624,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "SOUSA",
    "municipioIbge": 2516201,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.89,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.09255628917943214,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 5.89,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.35839146815241635,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.29,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.31542110929751704,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TABOAO DA SERRA",
    "municipioIbge": 3552809,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 5.99,
    "precoMaximo": 8.49,
    "desvioPadrao": 0.8473825245172,
    "coeficienteVariacao": 0.125
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TATUI",
    "municipioIbge": 3554003,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.29,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.41143650785996133,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 6.04,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.13054431501148636,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "TEIXEIRA DE FREITAS",
    "municipioIbge": 2931350,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.37,
    "precoMinimo": 7.37,
    "precoMaximo": 7.37,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.99,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.15652475842498528,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "TERESINA",
    "municipioIbge": 2211001,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 23,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 6.79,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.19305327041361228,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "TOLEDO",
    "municipioIbge": 4127700,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.29,
    "precoMaximo": 7.36,
    "desvioPadrao": 0.309777045924675,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.10954451150103323,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TRES CORACOES",
    "municipioIbge": 3169307,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.79,
    "precoMaximo": 7.03,
    "desvioPadrao": 0.10039920318408907,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.69,
    "precoMaximo": 7.13,
    "desvioPadrao": 0.15375304875026058,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.26,
    "precoMaximo": 6.86,
    "desvioPadrao": 0.18442101591497406,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBA",
    "municipioIbge": 3169901,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.59,
    "precoMaximo": 6.67,
    "desvioPadrao": 0.046188021535170064,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "UBATUBA",
    "municipioIbge": 3555406,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.55,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17062908812475588,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERABA",
    "municipioIbge": 3170107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.04,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.44474176562949214,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERLANDIA",
    "municipioIbge": 3170206,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 18,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.49,
    "precoMaximo": 7.07,
    "desvioPadrao": 0.17084182188379743,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UMUARAMA",
    "municipioIbge": 4128104,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.43,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.24889756929307288,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UNAI",
    "municipioIbge": 3170404,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.38,
    "precoMaximo": 6.55,
    "desvioPadrao": 0.09291573243177569,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UNIAO DA VITORIA",
    "municipioIbge": 4128203,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.53,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.24055491403558288,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "URUGUAIANA",
    "municipioIbge": 4322400,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.49,
    "precoMaximo": 6.82,
    "desvioPadrao": 0.1024607938955886,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VACARIA",
    "municipioIbge": 4322509,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.20401330488825617,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.69,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.15988090805942018,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VALENCA",
    "municipioIbge": 2932903,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.22,
    "precoMinimo": 7.15,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.12549900398011135,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VALINHOS",
    "municipioIbge": 3556206,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 5.99,
    "precoMaximo": 6.83,
    "desvioPadrao": 0.2918447075643712,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "VALPARAISO DE GOIAS",
    "municipioIbge": 5221858,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.54,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.22472205054244232,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VARGINHA",
    "municipioIbge": 3170701,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2058663459163551,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 7.07,
    "desvioPadrao": 0.10917620823441547,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VARZEA PAULISTA",
    "municipioIbge": 3556503,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.39,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.3295451410656816,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.04,
    "precoMinimo": 5.89,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.13784048752090222,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VICOSA",
    "municipioIbge": 3171303,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.75,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.09542885657214314,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "VIDEIRA",
    "municipioIbge": 4219309,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.26,
    "precoMaximo": 6.86,
    "desvioPadrao": 0.2521148642224507,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VILA VELHA",
    "municipioIbge": 3205200,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.44,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17229064377982323,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "VILHENA",
    "municipioIbge": 1100304,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.24,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.08943273609654513,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VITORIA",
    "municipioIbge": 3205309,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.34,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.2208437676208448,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.27,
    "precoMinimo": 7.15,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.10367782264829306,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "VITORIA DE SANTO ANTAO",
    "municipioIbge": 2616407,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.67,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.12151817422372123,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.08153080845467392,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTORANTIM",
    "municipioIbge": 3557006,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.24,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.18152134860671348,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTUPORANGA",
    "municipioIbge": 3557105,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 6.49,
    "precoMaximo": 9.39,
    "desvioPadrao": 1.4253303710602208,
    "coeficienteVariacao": 0.196
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "XANXERE",
    "municipioIbge": 4219507,
    "produto": "GASOLINE_PREMIUM",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 5.95,
    "precoMaximo": 6.77,
    "desvioPadrao": 0.3074666067814752,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ABAETETUBA",
    "municipioIbge": 1500107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.74,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.15992706671063114,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ADAMANTINA",
    "municipioIbge": 3500105,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.23,
    "precoMaximo": 6.55,
    "desvioPadrao": 0.14342120783602005,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "AGUAS LINDAS DE GOIAS",
    "municipioIbge": 5200258,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.49,
    "precoMaximo": 6.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.51,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.19403607911932255,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALEGRETE",
    "municipioIbge": 4300406,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1216552506059644,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALENQUER",
    "municipioIbge": 1500404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.88,
    "precoMaximo": 7.2,
    "desvioPadrao": 0.1725688268488837,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ALFENAS",
    "municipioIbge": 3101607,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 6.29,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.16583123951776998,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "ALTA FLORESTA",
    "municipioIbge": 5100250,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.22,
    "precoMinimo": 7.1,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.0659292550137393,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALTAMIRA",
    "municipioIbge": 1500602,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.05,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.15026273286776362,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALVORADA",
    "municipioIbge": 4300604,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 6.09,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.10488088481701516,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.17,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.16764693407722825,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ANANINDEUA",
    "municipioIbge": 1500800,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 6.09,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.19224983745116667,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ANAPOLIS",
    "municipioIbge": 5201108,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.89,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.023094010767585032,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 6.93,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.1653945499188445,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "APARECIDA DE GOIANIA",
    "municipioIbge": 5201405,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.59,
    "precoMaximo": 6.85,
    "desvioPadrao": 0.07623064417352847,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "APUCARANA",
    "municipioIbge": 4101408,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.47,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.10488088481701516,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 7.12,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.0340522954223267,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARACATUBA",
    "municipioIbge": 3502804,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.79,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.2336252752395794,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "ARACRUZ",
    "municipioIbge": 3200607,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.69,
    "precoMaximo": 6.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "ARAGUAINA",
    "municipioIbge": 1702109,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.87,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.12356080578918514,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.44,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1322047474113363,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAPONGAS",
    "municipioIbge": 4101507,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 6.39,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.07796010375684333,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 6.17,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.18814413168024743,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.42071717480567705,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAS",
    "municipioIbge": 3503307,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 6.17,
    "precoMaximo": 6.57,
    "desvioPadrao": 0.10431595363039242,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARARIPINA",
    "municipioIbge": 2601102,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.58,
    "precoMinimo": 7.51,
    "precoMaximo": 7.72,
    "desvioPadrao": 0.06735065783725583,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1511857892036909,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAUCARIA",
    "municipioIbge": 4101804,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.49,
    "precoMaximo": 6.76,
    "desvioPadrao": 0.10162079371017388,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ARAXA",
    "municipioIbge": 3104007,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.24771175004652304,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARCOVERDE",
    "municipioIbge": 2601201,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.79,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.04629100498862758,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "ARIQUEMES",
    "municipioIbge": 1100023,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 7.21,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.05044248650140519,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ASSIS",
    "municipioIbge": 3504008,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 5.94,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3512280044516825,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ATIBAIA",
    "municipioIbge": 3504107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.19,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3381700376422701,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AVARE",
    "municipioIbge": 3504503,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.59,
    "precoMaximo": 6.59,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BACABAL",
    "municipioIbge": 2101202,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.85,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.07872873862646527,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BAGE",
    "municipioIbge": 4301602,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 6.99,
    "precoMaximo": 7.53,
    "desvioPadrao": 0.17765447112614732,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BALSAS",
    "municipioIbge": 2101400,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.36,
    "precoMinimo": 7.19,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.1880455027675778,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BARBACENA",
    "municipioIbge": 3105608,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.59,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.11807231440338344,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.11562717179427531,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.10593499054713802,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "BARREIRAS",
    "municipioIbge": 2903201,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.78,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.1002051467169797,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARRETOS",
    "municipioIbge": 3505500,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 5.97,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.374782900119819,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARUERI",
    "municipioIbge": 3505708,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 5.99,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.6744440119644665,
    "coeficienteVariacao": 0.102
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BAURU",
    "municipioIbge": 3506003,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 5.84,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2275169676930389,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.29,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.0982344135219425,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BEBEDOURO",
    "municipioIbge": 3506102,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 6.19,
    "precoMaximo": 6.45,
    "desvioPadrao": 0.09180725150319788,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BELEM",
    "municipioIbge": 1501402,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 5.97,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.238067266527368,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 41,
    "unidade": "R$/l",
    "precoMedio": 6.05,
    "precoMinimo": 5.7,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.3425597686856284,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "BELO JARDIM",
    "municipioIbge": 2601706,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.43,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.06584614100852294,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 6.21,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.045752959831395976,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BETIM",
    "municipioIbge": 3106705,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 5.99,
    "precoMinimo": 5.85,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.13831005144121064,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BIRIGUI",
    "municipioIbge": 3506508,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.28,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.20093116565961922,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.27,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.13559744343705993,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RR",
    "estadoNome": "RORAIMA",
    "municipioNome": "BOA VISTA",
    "municipioIbge": 1400100,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.57,
    "precoMinimo": 7.55,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.010690449676496976,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BOM DESPACHO",
    "municipioIbge": 3107406,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.16,
    "precoMinimo": 6.14,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.021876275473019367,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BRAGANCA",
    "municipioIbge": 1501709,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.85,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.17233687939614087,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BRAGANCA PAULISTA",
    "municipioIbge": 3507605,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 5.99,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.1679814804607275,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "DF",
    "estadoNome": "DISTRITO FEDERAL",
    "municipioNome": "BRASILIA",
    "municipioIbge": 5300108,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 50,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.29,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.05372226384519794,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.34,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.0653537383101465,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 6.35,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.07804150299985381,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CABO DE SANTO AGOSTINHO",
    "municipioIbge": 2602902,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.9,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.030472470011002204,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CABO FRIO",
    "municipioIbge": 3300704,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.78,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.06279217421667403,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CACADOR",
    "municipioIbge": 4203006,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16850180160122072,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 6.07,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.3367067397178568,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CACERES",
    "municipioIbge": 5102504,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.53,
    "precoMaximo": 6.65,
    "desvioPadrao": 0.041403933560541256,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRA DO SUL",
    "municipioIbge": 4303004,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.06,
    "precoMinimo": 5.89,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.07071067811865475,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRINHA",
    "municipioIbge": 4303103,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.13,
    "precoMinimo": 5.96,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.16754103974847478,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.89,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.13194064322009855,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "CACOAL",
    "municipioIbge": 1100049,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 7.02,
    "precoMaximo": 7.24,
    "desvioPadrao": 0.07406560798180412,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "CAETITE",
    "municipioIbge": 2905206,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.59,
    "precoMinimo": 7.58,
    "precoMaximo": 7.6,
    "desvioPadrao": 0.005345224838248488,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "CAICO",
    "municipioIbge": 2402006,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.45,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.406201920231798,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CALDAS NOVAS",
    "municipioIbge": 5204508,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.62,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.09271221901969316,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMBE",
    "municipioIbge": 4103701,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2850438562747845,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.39,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.05932607633522829,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 25,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 5.97,
    "precoMaximo": 6.95,
    "desvioPadrao": 0.2714577929132508,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CAMPO BELO",
    "municipioIbge": 3111200,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 6.18,
    "precoMaximo": 6.72,
    "desvioPadrao": 0.18442478141507992,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 23,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 6.17,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.07134783692581083,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO LARGO",
    "municipioIbge": 4104204,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.39,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.06627863262664026,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO MOURAO",
    "municipioIbge": 4104303,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 6.15,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.12696456198483103,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.17,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.15427837885399945,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CANINDE",
    "municipioIbge": 2302800,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17033056096895824,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6,
    "precoMinimo": 5.59,
    "precoMaximo": 6.96,
    "desvioPadrao": 0.37146500508123237,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CARAGUATATUBA",
    "municipioIbge": 3510500,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.47,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.132664991614216,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CARATINGA",
    "municipioIbge": 3113404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 6.37,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.14851647335276602,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 6.15,
    "precoMaximo": 6.58,
    "desvioPadrao": 0.10861385591612932,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.39,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.16755815496154655,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASCAVEL",
    "municipioIbge": 4104808,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.28,
    "precoMaximo": 6.67,
    "desvioPadrao": 0.13165611772087665,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CASTANHAL",
    "municipioIbge": 1502400,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.46,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.12671678206592393,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASTRO",
    "municipioIbge": 4104907,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.86,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.14547950272902954,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CATALAO",
    "municipioIbge": 5205109,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.18,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.161386354923691,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CAUCAIA",
    "municipioIbge": 2303709,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.47,
    "precoMaximo": 6.68,
    "desvioPadrao": 0.07258568260119429,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 6.17,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.09170254481281422,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CHAPECO",
    "municipioIbge": 4204202,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 6.39,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.1508565288865295,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CIANORTE",
    "municipioIbge": 4105508,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.59,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.06708203932499368,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "CODO",
    "municipioIbge": 2103307,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.7,
    "precoMinimo": 7.65,
    "precoMaximo": 7.72,
    "desvioPadrao": 0.024976179127511152,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "COLATINA",
    "municipioIbge": 3201506,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.55,
    "precoMaximo": 6.86,
    "desvioPadrao": 0.09862446813182676,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.79,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.04175324338699131,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CONCEICAO DO ARAGUAIA",
    "municipioIbge": 1502707,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 7.08,
    "precoMaximo": 7.22,
    "desvioPadrao": 0.05282045058497703,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CONCORDIA",
    "municipioIbge": 4204301,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.49,
    "precoMaximo": 6.78,
    "desvioPadrao": 0.11897628815380461,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONGONHAS",
    "municipioIbge": 3118007,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.19,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.17268882005337974,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONSELHEIRO LAFAIETE",
    "municipioIbge": 3118304,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.29,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.11338934190276817,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 5.9,
    "precoMinimo": 5.77,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.12261287913043627,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CORNELIO PROCOPIO",
    "municipioIbge": 4106407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.44,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1519555072726099,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CORONEL FABRICIANO",
    "municipioIbge": 3119401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 6.24,
    "precoMaximo": 6.46,
    "desvioPadrao": 0.10499433091271893,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CORUMBA",
    "municipioIbge": 5003207,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 7.05,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.048795003647426664,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COSMOPOLIS",
    "municipioIbge": 3512803,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 6.18,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.04718883039751796,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COTIA",
    "municipioIbge": 3513009,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2624520158163405,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CRATEUS",
    "municipioIbge": 2304103,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.58,
    "precoMaximo": 7.9,
    "desvioPadrao": 0.42205069092975755,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.55,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.0845056731303218,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CRUZ ALTA",
    "municipioIbge": 4306106,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.01,
    "precoMinimo": 5.78,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.4099186911246343,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 6.17,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.14763210387730066,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CUBATAO",
    "municipioIbge": 3513504,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.69,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.09241791724861273,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CUIABA",
    "municipioIbge": 5103403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.53,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.06911301025953437,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CURITIBA",
    "municipioIbge": 4106902,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 48,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.47,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.09316513783492954,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CURVELO",
    "municipioIbge": 3120904,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 6.34,
    "precoMaximo": 6.46,
    "desvioPadrao": 0.03716116764786033,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "DELMIRO GOUVEIA",
    "municipioIbge": 2702405,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.6,
    "precoMinimo": 7.32,
    "precoMaximo": 7.67,
    "desvioPadrao": 0.1050714042925096,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "DIADEMA",
    "municipioIbge": 3513801,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 5.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.37961229498726,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "DIVINOPOLIS",
    "municipioIbge": 3122306,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.09,
    "precoMinimo": 5.87,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.16106274799347237,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "DOURADOS",
    "municipioIbge": 5003702,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.6,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.19161717787594842,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "EMBU DAS ARTES",
    "municipioIbge": 3515004,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 6.08,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.37351372130083793,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ERECHIM",
    "municipioIbge": 4307005,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 6.07,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.16940001073306826,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.01,
    "precoMinimo": 5.63,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.2521195861377805,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "EUNAPOLIS",
    "municipioIbge": 2910727,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.12,
    "precoMaximo": 7.34,
    "desvioPadrao": 0.10180513599168617,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.51,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.10988630487917955,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.16,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2681285450426095,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FORMIGA",
    "municipioIbge": 3126109,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 6.09,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.19820624179302296,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "FORMOSA",
    "municipioIbge": 5208004,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.94,
    "precoMinimo": 5.69,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.12247448713915891,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "FORTALEZA",
    "municipioIbge": 2304400,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 38,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.43,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.07661443991822253,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "FRANCA",
    "municipioIbge": 3516200,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 5.89,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.22823118473208373,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "FRANCISCO BELTRAO",
    "municipioIbge": 4108403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 6.3,
    "precoMaximo": 6.3,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FRUTAL",
    "municipioIbge": 3127107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 6.09,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.12601020366847848,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "GARANHUNS",
    "municipioIbge": 2606002,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.72,
    "precoMaximo": 6.78,
    "desvioPadrao": 0.0166332999331662,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GARCA",
    "municipioIbge": 3516705,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 6.19,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.10690449676496976,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIANIA",
    "municipioIbge": 5208707,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 44,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.37,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.13620886212953093,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIATUBA",
    "municipioIbge": 5209101,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.08,
    "precoMinimo": 5.98,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.20338797080129067,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GOVERNADOR VALADARES",
    "municipioIbge": 3127701,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.19,
    "precoMinimo": 6.08,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.14075194887144943,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAMADO",
    "municipioIbge": 4309100,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.12841524905740825,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 6.26,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.09370165420097984,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GUAIBA",
    "municipioIbge": 4309308,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.04,
    "precoMinimo": 5.99,
    "precoMaximo": 6.05,
    "desvioPadrao": 0.021213203435596427,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "GUANAMBI",
    "municipioIbge": 2911709,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 7.08,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.0746420027292179,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "GUARAPARI",
    "municipioIbge": 3202405,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.65,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.14851647335276602,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "GUARAPUAVA",
    "municipioIbge": 4109401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 5.93,
    "precoMinimo": 5.79,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.21043649038015363,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.19,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1819340539866025,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARUJA",
    "municipioIbge": 3518701,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 5.99,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.5034326612809745,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 24,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.21752519427626663,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GUAXUPE",
    "municipioIbge": 3128709,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 6.26,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.1358745920395155,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "GURUPI",
    "municipioIbge": 1709500,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 7.09,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.0653834841531101,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.19,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.12866839377079187,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "IBITINGA",
    "municipioIbge": 3519600,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 6.06,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.22112940619852955,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ICO",
    "municipioIbge": 2305407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 7.07,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.05656854249492381,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "IGARASSU",
    "municipioIbge": 2606804,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.87,
    "precoMaximo": 6.95,
    "desvioPadrao": 0.03703280399090206,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "IGUATU",
    "municipioIbge": 2305506,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.48,
    "precoMinimo": 7.47,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.006324555320336759,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "IJUI",
    "municipioIbge": 4310207,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.97,
    "precoMaximo": 6.76,
    "desvioPadrao": 0.22633729570835523,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ILHEUS",
    "municipioIbge": 2913606,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 7.24,
    "precoMaximo": 7.34,
    "desvioPadrao": 0.03073181485764296,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "IMPERATRIZ",
    "municipioIbge": 2105302,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.25,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.21753379595123234,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "INDAIATUBA",
    "municipioIbge": 3520509,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 5.94,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.22189163444325125,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "IPATINGA",
    "municipioIbge": 3131307,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.25,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.07125852775477316,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IPIRA",
    "municipioIbge": 2914000,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.13618964368709924,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IRECE",
    "municipioIbge": 2914604,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.94,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.0772133716522259,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ITABAIANA",
    "municipioIbge": 2802908,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 7.05,
    "precoMaximo": 7.05,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.36,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.11738351199759227,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.23,
    "precoMinimo": 7.23,
    "precoMaximo": 7.23,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.23,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1913859227544477,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAJUBA",
    "municipioIbge": 3132404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 6.39,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITAMARAJU",
    "municipioIbge": 2915601,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPECERICA DA SERRA",
    "municipioIbge": 3522208,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.3098818899424194,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.67,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1407124727947029,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ITAPIPOCA",
    "municipioIbge": 2306405,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.48,
    "precoMinimo": 7.48,
    "precoMaximo": 7.5,
    "desvioPadrao": 0.006009252125773316,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPIRA",
    "municipioIbge": 3522604,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.30997407725716125,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPOLIS",
    "municipioIbge": 3522703,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.39,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.1267543556122103,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.69,
    "precoMaximo": 7.27,
    "desvioPadrao": 0.4290558109254423,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 5.99,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.23496227937112105,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAUNA",
    "municipioIbge": 3133808,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.16,
    "precoMinimo": 6.07,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.10232127274981903,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.79,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.33060382467371563,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITUIUTABA",
    "municipioIbge": 3134202,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.2,
    "precoMinimo": 6.15,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.03910100879630715,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ITUMBIARA",
    "municipioIbge": 5211503,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 5.99,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.25599944196367747,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "JABOATAO DOS GUARARAPES",
    "municipioIbge": 2607901,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.87,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.014142135623730952,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JABOTICABAL",
    "municipioIbge": 3524303,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.65,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.06831300510639733,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.12,
    "precoMinimo": 5.85,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.16607293512255325,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JACOBINA",
    "municipioIbge": 2917508,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.89,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.02195035721390843,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JAGUAQUARA",
    "municipioIbge": 2917607,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.69,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.2614610960772267,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JALES",
    "municipioIbge": 3524808,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.09,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.22360679774997896,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANAUBA",
    "municipioIbge": 3135100,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 6.16,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3474164853395911,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANUARIA",
    "municipioIbge": 3135209,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.59,
    "precoMaximo": 6.59,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JAU",
    "municipioIbge": 3525300,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 5.9,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.29487473800091984,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JEQUIE",
    "municipioIbge": 2918001,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.57,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1928730152198591,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "JI-PARANA",
    "municipioIbge": 1100122,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.97,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.12645516632747392,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO MONLEVADE",
    "municipioIbge": 3136207,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.44,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.07229651246281327,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 6.25,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.10627394810951377,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO PINHEIRO",
    "municipioIbge": 3136306,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 6.27,
    "precoMaximo": 6.42,
    "desvioPadrao": 0.05730557190560593,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.89,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.19036437820986382,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JUAZEIRO",
    "municipioIbge": 2918407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 7.39,
    "precoMaximo": 7.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "JUAZEIRO DO NORTE",
    "municipioIbge": 2307304,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.82,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.16612674449978015,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.35,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.09220341961248127,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 5.99,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.18351149988007645,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.15,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.42874234687047186,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.06,
    "precoMinimo": 5.99,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.09362454568944811,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "LAJEDO",
    "municipioIbge": 2608800,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.47,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.09113426658208505,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LAVRAS",
    "municipioIbge": 3138203,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.08,
    "precoMaximo": 6.63,
    "desvioPadrao": 0.18469494368342146,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LEME",
    "municipioIbge": 3526704,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.19,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.1826784841502375,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LEOPOLDINA",
    "municipioIbge": 3138401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.65,
    "precoMaximo": 6.95,
    "desvioPadrao": 0.1110126547912873,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LIMEIRA",
    "municipioIbge": 3526902,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 5.89,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.26812740943869895,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "LIMOEIRO DO NORTE",
    "municipioIbge": 2307601,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.06,
    "precoMinimo": 6.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.14893561757289014,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LINS",
    "municipioIbge": 3527108,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 6.09,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.06961002482082274,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "LIVRAMENTO DE NOSSA SENHORA",
    "municipioIbge": 2919504,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.84,
    "precoMinimo": 7.84,
    "precoMaximo": 7.84,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "LONDRINA",
    "municipioIbge": 4113700,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.09,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.30971973748773857,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LORENA",
    "municipioIbge": 3527207,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.29,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.2239220208656831,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.11948965552623281,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AP",
    "estadoNome": "AMAPA",
    "municipioNome": "MACAPA",
    "municipioIbge": 1600303,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.45,
    "precoMaximo": 6.66,
    "desvioPadrao": 0.06745913795860163,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "MACEIO",
    "municipioIbge": 2704302,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.75,
    "precoMaximo": 6.84,
    "desvioPadrao": 0.022203208239809643,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANACAPURU",
    "municipioIbge": 1302504,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.75,
    "precoMaximo": 7.18,
    "desvioPadrao": 0.15640302030940695,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 39,
    "unidade": "R$/l",
    "precoMedio": 7.28,
    "precoMinimo": 7.27,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.003202563076101743,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "MARABA",
    "municipioIbge": 1504208,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.31,
    "precoMaximo": 7.13,
    "desvioPadrao": 0.2198311039996713,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.24494897427831783,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MARILIA",
    "municipioIbge": 3529005,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 5.79,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.26678797607055715,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "MARINGA",
    "municipioIbge": 4115200,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1667509590765258,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MATAO",
    "municipioIbge": 3529302,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.06812540956626557,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.94,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.2745906043549196,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "MINEIROS",
    "municipioIbge": 5213103,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.85,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.014142135623730952,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOCOCA",
    "municipioIbge": 3530508,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.66,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.08105333341166703,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 5.89,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2410927939489641,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI GUACU",
    "municipioIbge": 3530706,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.25221243250702596,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 5.92,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2987563507992042,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MONTE ALTO",
    "municipioIbge": 3531308,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.19600170067289385,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTE CARMELO",
    "municipioIbge": 3143104,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.11,
    "precoMinimo": 5.89,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.13692194509142444,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTES CLAROS",
    "municipioIbge": 3143302,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.11,
    "precoMinimo": 5.89,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.1370349277686949,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.98,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.004385290096535146,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MURIAE",
    "municipioIbge": 3143906,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.71,
    "precoMaximo": 6.75,
    "desvioPadrao": 0.011952286093343936,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 18,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.72,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.08535202001277672,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.29,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.13666188418222286,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 7.12,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.02672612419124244,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NOVA FRIBURGO",
    "municipioIbge": 3303401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.85,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.1540956019666186,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "NOVA LIMA",
    "municipioIbge": 3144805,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 6.19,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.19969619783203543,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "NOVO HAMBURGO",
    "municipioIbge": 4313409,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 5.98,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.08436482823087026,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OLIMPIA",
    "municipioIbge": 3533908,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 6.27,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.28460498941515416,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "OLINDA",
    "municipioIbge": 2609600,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.87,
    "precoMaximo": 6.91,
    "desvioPadrao": 0.012692955176439848,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 18,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 5.89,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.21293160705035258,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "OSORIO",
    "municipioIbge": 4313508,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.04,
    "precoMinimo": 5.94,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.08660254037844387,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OURINHOS",
    "municipioIbge": 3534708,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 5.89,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.36620642110310253,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "OURO PRETO",
    "municipioIbge": 3146107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 6.29,
    "precoMaximo": 6.32,
    "desvioPadrao": 0.013887301496588273,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.65,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.11506985456048613,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARA DE MINAS",
    "municipioIbge": 3147105,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 6.32,
    "precoMaximo": 6.44,
    "desvioPadrao": 0.0377728171346236,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARACATU",
    "municipioIbge": 3147006,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 6.17,
    "precoMaximo": 6.41,
    "desvioPadrao": 0.08007808689023484,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAGOMINAS",
    "municipioIbge": 1505502,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.79,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.14257829929050014,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PARAGUACU PAULISTA",
    "municipioIbge": 3535507,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 5.99,
    "precoMaximo": 6.77,
    "desvioPadrao": 0.3216623488483952,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PARAISO DO TOCANTINS",
    "municipioIbge": 1716109,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.10690449676496976,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAGUA",
    "municipioIbge": 4118204,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.25,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.24050872010063262,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAVAI",
    "municipioIbge": 4118402,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.34,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.21547621678505496,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAUAPEBAS",
    "municipioIbge": 1505536,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.85,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.15639365191392637,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "PARINTINS",
    "municipioIbge": 1303403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 8.99,
    "precoMinimo": 8.99,
    "precoMaximo": 8.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PARNAIBA",
    "municipioIbge": 2207702,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.75,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.12651506078748334,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "PARNAMIRIM",
    "municipioIbge": 2403251,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.75,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.09899494936611666,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PASSO FUNDO",
    "municipioIbge": 4314100,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.49,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.044721359549995794,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PASSOS",
    "municipioIbge": 3147907,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 5.97,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2704748910096216,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PATO BRANCO",
    "municipioIbge": 4118501,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.39,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.07029275516418054,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.52,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.10344080432788602,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PATROCINIO",
    "municipioIbge": 3148103,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.29,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.21001700611413082,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PAULINIA",
    "municipioIbge": 3536505,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.1,
    "precoMinimo": 5.89,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.13638181696985857,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PAULISTA",
    "municipioIbge": 2610707,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.81,
    "precoMaximo": 6.93,
    "desvioPadrao": 0.032829526005987014,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PAULO AFONSO",
    "municipioIbge": 2924009,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.92,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.18935510857343443,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PELOTAS",
    "municipioIbge": 4314407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.39,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.12828048313341037,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PETROLINA",
    "municipioIbge": 2611101,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 7.53,
    "precoMinimo": 7.44,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.048974783427440556,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 7.11,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.05283189180039639,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PICOS",
    "municipioIbge": 2208007,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.6,
    "precoMaximo": 6.92,
    "desvioPadrao": 0.08664102184685189,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PIMENTA BUENO",
    "municipioIbge": 1100189,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.38,
    "precoMinimo": 7.37,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.009258200997725514,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PINHEIRO",
    "municipioIbge": 2108603,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 7.15,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.016329931618554522,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRACICABA",
    "municipioIbge": 3538709,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 6.09,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2074839351210916,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRASSUNUNGA",
    "municipioIbge": 3539301,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 6.27,
    "precoMaximo": 6.44,
    "desvioPadrao": 0.06876460883747852,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PIRIPIRI",
    "municipioIbge": 2208403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.11,
    "precoMinimo": 6.75,
    "precoMaximo": 7.53,
    "desvioPadrao": 0.25051019369051064,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.19,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2295181287579947,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "POCOES",
    "municipioIbge": 2925105,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.95,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.08838834764831845,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "POCOS DE CALDAS",
    "municipioIbge": 3151800,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1914157778240864,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.09,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.1991983935678197,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "PONTA PORA",
    "municipioIbge": 5006606,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.56,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.07593857166596345,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "PORANGATU",
    "municipioIbge": 5218003,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.65,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.03505098327538657,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 36,
    "unidade": "R$/l",
    "precoMedio": 6.06,
    "precoMinimo": 5.67,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.25830214865540707,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.51,
    "precoMaximo": 6.93,
    "desvioPadrao": 0.18114713830001763,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PORTO SEGURO",
    "municipioIbge": 2925303,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.4,
    "precoMinimo": 7.34,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.060249481325568274,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PORTO VELHO",
    "municipioIbge": 1100205,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 7.48,
    "precoMinimo": 7.19,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.13397215386674916,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRAIA GRANDE",
    "municipioIbge": 3541000,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 5.99,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3467800603500874,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PRESIDENTE DUTRA",
    "municipioIbge": 2109106,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 6.9,
    "precoMaximo": 7.24,
    "desvioPadrao": 0.06647644430216483,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRESIDENTE PRUDENTE",
    "municipioIbge": 3541406,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 5.94,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2257832926460575,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "QUIXADA",
    "municipioIbge": 2311306,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.55,
    "precoMaximo": 7.02,
    "desvioPadrao": 0.17852170736355844,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "RECIFE",
    "municipioIbge": 2611606,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 28,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.8,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.04497353719265417,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.34,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.24023426067070452,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PIRES",
    "municipioIbge": 3543303,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 6.05,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.1744992836661515,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PRETO",
    "municipioIbge": 3543402,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 24,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.42,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.20660427412557691,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.48,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.14909728367747013,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AC",
    "estadoNome": "ACRE",
    "municipioNome": "RIO BRANCO",
    "municipioIbge": 1200401,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.29,
    "precoMinimo": 7.14,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.10174239603781284,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.16,
    "precoMinimo": 5.89,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.2064970354291452,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 84,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 5.94,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.20532340888832312,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "RIO LARGO",
    "municipioIbge": 2707701,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.0915475416434127,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "RIO VERDE",
    "municipioIbge": 5218805,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 6.31,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.09778030993502225,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "RONDONOPOLIS",
    "municipioIbge": 5107602,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1381786283523372,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 5.99,
    "precoMinimo": 5.89,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.13314197577881184,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SALGUEIRO",
    "municipioIbge": 2612208,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 7.14,
    "precoMaximo": 7.18,
    "desvioPadrao": 0.011259916264596034,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SALTO",
    "municipioIbge": 3545209,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 5.89,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3024394862731103,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SALVADOR",
    "municipioIbge": 2927408,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 20,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.53,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.26681109027687894,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SANTA CRUZ DO CAPIBARIBE",
    "municipioIbge": 2612505,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.78,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.07603257447273755,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTA MARIA",
    "municipioIbge": 4316907,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.12,
    "precoMinimo": 5.87,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.28188143404123456,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTANA DO LIVRAMENTO",
    "municipioIbge": null,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.07193747284969079,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "SANTAREM",
    "municipioIbge": 1506807,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.48,
    "precoMaximo": 7.1,
    "desvioPadrao": 0.23817385606796923,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.99,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.2081736229927834,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTO ANGELO",
    "municipioIbge": 4317509,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.38,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.27654759342393753,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SANTO ANTONIO DE JESUS",
    "municipioIbge": 2928703,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.38,
    "precoMinimo": 7.38,
    "precoMaximo": 7.38,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.45,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.15351076690433008,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTOS",
    "municipioIbge": 3548500,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 5.77,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.4704536817441933,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.09,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.25747423649006196,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CAETANO DO SUL",
    "municipioIbge": 3548807,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 5.84,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.41119338516080245,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CARLOS",
    "municipioIbge": 3548906,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.79,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.3308402002405966,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.39,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.11114378604524226,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOAO DA BOA VISTA",
    "municipioIbge": 3549102,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 6.09,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.18076995817275,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO JOAO DEL REI",
    "municipioIbge": 3162500,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 6.4,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.030908852176312583,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "SAO JOSE",
    "municipioIbge": 4216602,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.74,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.020978796202592038,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO JOSE DE RIBAMAR",
    "municipioIbge": 2111201,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.059479221395187895,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DO RIO PRETO",
    "municipioIbge": 3549805,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.29829535188980794,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.11,
    "precoMinimo": 5.69,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.22263178632149938,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.54,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.0981821958898027,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 5.95,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.13091133555875814,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO LUIS",
    "municipioIbge": 2111300,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 21,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.48,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.05038896326625126,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LUIZ GONZAGA",
    "municipioIbge": 4318903,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.39,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1264911064067352,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SAO MATEUS",
    "municipioIbge": 3204906,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.55,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.16970562748477142,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 210,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 5.67,
    "precoMaximo": 8.97,
    "desvioPadrao": 0.4564210281448331,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO SEBASTIAO DO PARAISO",
    "municipioIbge": 3164704,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.38,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.053652319880611206,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO VICENTE",
    "municipioIbge": 3551009,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 5.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.4103569874424671,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPIRANGA",
    "municipioIbge": 4319901,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.12,
    "precoMinimo": 5.65,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.23760336096708976,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.1,
    "precoMinimo": 5.52,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.3122699152976476,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.07409774753982871,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SENHOR DO BONFIM",
    "municipioIbge": 2930105,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.75,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.19210040109943577,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.39,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.09643365879945938,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SERRA TALHADA",
    "municipioIbge": 2613909,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.45,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4937610758251404,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SERRINHA",
    "municipioIbge": 2930501,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.78,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.08516324194027479,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SERTAOZINHO",
    "municipioIbge": 3551702,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.53,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.07001983845866669,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.07,
    "precoMinimo": 5.9,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.0943951246645692,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SINOP",
    "municipioIbge": 5107909,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.23,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.26671279362961625,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "SOBRAL",
    "municipioIbge": 2312908,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 7.09,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.05477225575051661,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SOROCABA",
    "municipioIbge": 3552205,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.89,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2379751326140823,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SORRISO",
    "municipioIbge": 5107925,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.62,
    "precoMaximo": 7.04,
    "desvioPadrao": 0.15528200153269536,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "SOUSA",
    "municipioIbge": 2516201,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.13125039682479694,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.17,
    "precoMinimo": 5.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.33339083753074344,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.04,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.32493589111289833,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TABOAO DA SERRA",
    "municipioIbge": 3552809,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 5.69,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.7252770406639699,
    "coeficienteVariacao": 0.114
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TATUI",
    "municipioIbge": 3554003,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 5.99,
    "precoMaximo": 7.12,
    "desvioPadrao": 0.4286153416655908,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6,
    "precoMinimo": 5.77,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.17875761722031797,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "TEIXEIRA DE FREITAS",
    "municipioIbge": 2931350,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.23,
    "precoMinimo": 6.85,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.17065699377350324,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.09,
    "precoMinimo": 5.95,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.14234152981864118,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "TERESINA",
    "municipioIbge": 2211001,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 29,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.68,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.10798421705510916,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "TOLEDO",
    "municipioIbge": 4127700,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.39,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.2672410480779062,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 6.39,
    "precoMaximo": 6.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TRES CORACOES",
    "municipioIbge": 3169307,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.59,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.12372203868811271,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.13662601021279466,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 6.22,
    "precoMaximo": 6.66,
    "desvioPadrao": 0.12851286144022922,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBA",
    "municipioIbge": 3169901,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.38,
    "precoMinimo": 6.35,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.02,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "UBATUBA",
    "municipioIbge": 3555406,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.55,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16449055552566796,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERABA",
    "municipioIbge": 3170107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.08,
    "precoMinimo": 5.84,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.28530685235374215,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERLANDIA",
    "municipioIbge": 3170206,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 21,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.29,
    "precoMaximo": 6.64,
    "desvioPadrao": 0.09582971007643368,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UMUARAMA",
    "municipioIbge": 4128104,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.33,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.15943793320742258,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UNAI",
    "municipioIbge": 3170404,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.38,
    "precoMaximo": 6.45,
    "desvioPadrao": 0.03785938897200183,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UNIAO DA VITORIA",
    "municipioIbge": 4128203,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.38,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.21226667863125118,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "URUGUAIANA",
    "municipioIbge": 4322400,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.32,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.10041876603219427,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VACARIA",
    "municipioIbge": 4322509,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 5.99,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.24041630560342617,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VALENCA",
    "municipioIbge": 2932903,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 7.15,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.09071147352221454,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.10253919111386492,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VALINHOS",
    "municipioIbge": 3556206,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 5.99,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.25999145285096503,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "VALPARAISO DE GOIAS",
    "municipioIbge": 5221858,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.19,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.17873008824606013,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VARGINHA",
    "municipioIbge": 3170701,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.17,
    "precoMinimo": 5.89,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.27406406388125953,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.75,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.012366938848016847,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VARZEA PAULISTA",
    "municipioIbge": 3556503,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.09,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.12781124475457661,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.86,
    "precoMinimo": 5.69,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.09806460455570433,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VICOSA",
    "municipioIbge": 3171303,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.06556076788533129,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "VIDEIRA",
    "municipioIbge": 4219309,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.26,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1936860493538079,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VILA VELHA",
    "municipioIbge": 3205200,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.25,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.0945493698198636,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "VILHENA",
    "municipioIbge": 1100304,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.38,
    "precoMinimo": 7.37,
    "precoMaximo": 7.4,
    "desvioPadrao": 0.008997354108424374,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VITORIA",
    "municipioIbge": 3205309,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 6.34,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.09404624909956255,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 7.15,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.03397478056273085,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "VITORIA DE SANTO ANTAO",
    "municipioIbge": 2616407,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.67,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.042426406871192854,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.06187964858570958,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTORANTIM",
    "municipioIbge": 3557006,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 5.79,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.26139392822765745,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTUPORANGA",
    "municipioIbge": 3557105,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.29,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.33166247903553997,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "XANXERE",
    "municipioIbge": 4219507,
    "produto": "GASOLINE_REGULAR",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.2,
    "precoMinimo": 5.95,
    "precoMaximo": 6.58,
    "desvioPadrao": 0.27860622493302006,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ABAETETUBA",
    "municipioIbge": 1500107,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 114.66,
    "precoMinimo": 113,
    "precoMaximo": 118,
    "desvioPadrao": 2.581988897471611,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ADAMANTINA",
    "municipioIbge": 3500105,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 103.54,
    "precoMinimo": 99.9,
    "precoMaximo": 105,
    "desvioPadrao": 2.486604110026363,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "AGUAS LINDAS DE GOIAS",
    "municipioIbge": 5200258,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 107.15,
    "precoMinimo": 94.99,
    "precoMaximo": 118,
    "desvioPadrao": 8.085299892952293,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 116.84,
    "precoMinimo": 110,
    "precoMaximo": 120,
    "desvioPadrao": 3.7469352555820614,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALEGRETE",
    "municipioIbge": 4300406,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 117.14,
    "precoMinimo": 110,
    "precoMaximo": 125,
    "desvioPadrao": 4.8795003647426665,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALENQUER",
    "municipioIbge": 1500404,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 120,
    "precoMinimo": 120,
    "precoMaximo": 120,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ALFENAS",
    "municipioIbge": 3101607,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 107.57,
    "precoMinimo": 98,
    "precoMaximo": 115,
    "desvioPadrao": 6.160550377391695,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "ALTA FLORESTA",
    "municipioIbge": 5100250,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 136.28,
    "precoMinimo": 125,
    "precoMaximo": 145,
    "desvioPadrao": 8.693182879212225,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALTAMIRA",
    "municipioIbge": 1500602,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 130.71,
    "precoMinimo": 119.99,
    "precoMaximo": 140,
    "desvioPadrao": 8.363043134899549,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALVORADA",
    "municipioIbge": 4300604,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 110,
    "precoMinimo": 110,
    "precoMaximo": 110,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 119.99,
    "precoMinimo": 119.99,
    "precoMaximo": 119.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ANANINDEUA",
    "municipioIbge": 1500800,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 108.53,
    "precoMinimo": 98.99,
    "precoMaximo": 120,
    "desvioPadrao": 6.937118203862392,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ANAPOLIS",
    "municipioIbge": 5201108,
    "produto": "LPG_P13",
    "postosPesquisados": 17,
    "unidade": "R$/13kg",
    "precoMedio": 114.7,
    "precoMinimo": 110,
    "precoMaximo": 115,
    "desvioPadrao": 1.212678125181665,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 132.57,
    "precoMinimo": 130,
    "precoMaximo": 135,
    "desvioPadrao": 2.5071326821120348,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "APARECIDA DE GOIANIA",
    "municipioIbge": 5201405,
    "produto": "LPG_P13",
    "postosPesquisados": 19,
    "unidade": "R$/13kg",
    "precoMedio": 112.05,
    "precoMinimo": 95.99,
    "precoMaximo": 125,
    "desvioPadrao": 7.97743224015089,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "APUCARANA",
    "municipioIbge": 4101408,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 111.49,
    "precoMinimo": 109.9,
    "precoMaximo": 120,
    "desvioPadrao": 3.379825768027432,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 112.42,
    "precoMinimo": 105,
    "precoMaximo": 115,
    "desvioPadrao": 3.1021804927379404,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARACATUBA",
    "municipioIbge": 3502804,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 107.19,
    "precoMinimo": 95.99,
    "precoMaximo": 115,
    "desvioPadrao": 4.876330099377527,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "ARACRUZ",
    "municipioIbge": 3200607,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 108.99,
    "precoMinimo": 99.99,
    "precoMaximo": 120,
    "desvioPadrao": 8.487049798705925,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "ARAGUAINA",
    "municipioIbge": 1702109,
    "produto": "LPG_P13",
    "postosPesquisados": 11,
    "unidade": "R$/13kg",
    "precoMedio": 134.54,
    "precoMinimo": 130,
    "precoMaximo": 135,
    "desvioPadrao": 1.507556722888818,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 105.25,
    "precoMinimo": 97,
    "precoMaximo": 110,
    "desvioPadrao": 4.832922806867792,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAPONGAS",
    "municipioIbge": 4101507,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 107.83,
    "precoMinimo": 99.9,
    "precoMaximo": 113,
    "desvioPadrao": 5.008831486199437,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 112.19,
    "precoMinimo": 109.98,
    "precoMaximo": 120,
    "desvioPadrao": 4.3849834663314295,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "LPG_P13",
    "postosPesquisados": 12,
    "unidade": "R$/13kg",
    "precoMedio": 118.99,
    "precoMinimo": 110,
    "precoMaximo": 125,
    "desvioPadrao": 5.411100473409576,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAS",
    "municipioIbge": 3503307,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 113.57,
    "precoMinimo": 109,
    "precoMaximo": 123,
    "desvioPadrao": 4.503966505838414,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARARIPINA",
    "municipioIbge": 2601102,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 110,
    "precoMinimo": 110,
    "precoMaximo": 110,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 95.71,
    "precoMinimo": 89.99,
    "precoMaximo": 105,
    "desvioPadrao": 6.728937508997985,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAUCARIA",
    "municipioIbge": 4101804,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 105.3,
    "precoMinimo": 103,
    "precoMaximo": 110,
    "desvioPadrao": 2.002775851439974,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ARAXA",
    "municipioIbge": 3104007,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 108.71,
    "precoMinimo": 105,
    "precoMaximo": 110,
    "desvioPadrao": 1.8898223650461363,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARCOVERDE",
    "municipioIbge": 2601201,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 98.6,
    "precoMinimo": 95,
    "precoMaximo": 100,
    "desvioPadrao": 2.1908902300206647,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "ARIQUEMES",
    "municipioIbge": 1100023,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 128.69,
    "precoMinimo": 124.89,
    "precoMaximo": 133,
    "desvioPadrao": 3.878489519436781,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ASSIS",
    "municipioIbge": 3504008,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 115.47,
    "precoMinimo": 107.9,
    "precoMaximo": 120,
    "desvioPadrao": 5.113218164717793,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ATIBAIA",
    "municipioIbge": 3504107,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 123.62,
    "precoMinimo": 110,
    "precoMaximo": 135,
    "desvioPadrao": 10.041876603219427,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BACABAL",
    "municipioIbge": 2101202,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 128.57,
    "precoMinimo": 120,
    "precoMaximo": 130,
    "desvioPadrao": 3.7796447300922726,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BAGE",
    "municipioIbge": 4301602,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 122.25,
    "precoMinimo": 118,
    "precoMaximo": 129,
    "desvioPadrao": 4.267819784654188,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BALSAS",
    "municipioIbge": 2101400,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 130,
    "precoMinimo": 130,
    "precoMaximo": 130,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BARBACENA",
    "municipioIbge": 3105608,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 109.6,
    "precoMinimo": 100,
    "precoMaximo": 118,
    "desvioPadrao": 6.3874877690685254,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 102.99,
    "precoMinimo": 90,
    "precoMaximo": 110,
    "desvioPadrao": 8.184743734534393,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 102.25,
    "precoMinimo": 94.99,
    "precoMaximo": 111.9,
    "desvioPadrao": 6.859760512271131,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "BARREIRAS",
    "municipioIbge": 2903201,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 135,
    "precoMinimo": 135,
    "precoMaximo": 135,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARRETOS",
    "municipioIbge": 3505500,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 109.16,
    "precoMinimo": 105,
    "precoMaximo": 115,
    "desvioPadrao": 4.915960401250875,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARUERI",
    "municipioIbge": 3505708,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 119.1,
    "precoMinimo": 109.99,
    "precoMaximo": 130,
    "desvioPadrao": 8.341430899099054,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BAURU",
    "municipioIbge": 3506003,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 114.3,
    "precoMinimo": 105,
    "precoMaximo": 120,
    "desvioPadrao": 4.1379007023153935,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 115,
    "precoMaximo": 115,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BEBEDOURO",
    "municipioIbge": 3506102,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 124.16,
    "precoMinimo": 120,
    "precoMaximo": 125,
    "desvioPadrao": 2.041241452319315,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BELEM",
    "municipioIbge": 1501402,
    "produto": "LPG_P13",
    "postosPesquisados": 25,
    "unidade": "R$/13kg",
    "precoMedio": 120.27,
    "precoMinimo": 110,
    "precoMaximo": 139,
    "desvioPadrao": 7.008828955919337,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "LPG_P13",
    "postosPesquisados": 19,
    "unidade": "R$/13kg",
    "precoMedio": 114.73,
    "precoMinimo": 99,
    "precoMaximo": 145,
    "desvioPadrao": 13.207686867792589,
    "coeficienteVariacao": 0.115
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "BELO JARDIM",
    "municipioIbge": 2601706,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 96.22,
    "precoMinimo": 89.9,
    "precoMaximo": 100,
    "desvioPadrao": 4.830717683050143,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 126.81,
    "precoMinimo": 123,
    "precoMaximo": 130,
    "desvioPadrao": 3.1688588903052577,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BETIM",
    "municipioIbge": 3106705,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 114.38,
    "precoMinimo": 90,
    "precoMaximo": 133,
    "desvioPadrao": 12.196573709710865,
    "coeficienteVariacao": 0.107
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BIRIGUI",
    "municipioIbge": 3506508,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 105.22,
    "precoMinimo": 92,
    "precoMaximo": 110,
    "desvioPadrao": 6.554197976191375,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 134.97,
    "precoMinimo": 125,
    "precoMaximo": 145,
    "desvioPadrao": 7.050979161992832,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RR",
    "estadoNome": "RORAIMA",
    "municipioNome": "BOA VISTA",
    "municipioIbge": 1400100,
    "produto": "LPG_P13",
    "postosPesquisados": 21,
    "unidade": "R$/13kg",
    "precoMedio": 143.14,
    "precoMinimo": 130,
    "precoMaximo": 156,
    "desvioPadrao": 6.9374758686839,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BOM DESPACHO",
    "municipioIbge": 3107406,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 100.98,
    "precoMinimo": 95,
    "precoMaximo": 110.9,
    "desvioPadrao": 5.25372883451998,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BRAGANCA",
    "municipioIbge": 1501709,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 115,
    "precoMaximo": 115,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BRAGANCA PAULISTA",
    "municipioIbge": 3507605,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 115.17,
    "precoMinimo": 109,
    "precoMaximo": 119.99,
    "desvioPadrao": 4.468246113782603,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "DF",
    "estadoNome": "DISTRITO FEDERAL",
    "municipioNome": "BRASILIA",
    "municipioIbge": 5300108,
    "produto": "LPG_P13",
    "postosPesquisados": 33,
    "unidade": "R$/13kg",
    "precoMedio": 106.66,
    "precoMinimo": 94.99,
    "precoMaximo": 115.99,
    "desvioPadrao": 4.947855270751463,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 129.99,
    "precoMinimo": 125,
    "precoMaximo": 139.99,
    "desvioPadrao": 8.654480535152489,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114.42,
    "precoMinimo": 109,
    "precoMaximo": 122,
    "desvioPadrao": 5.883795341363228,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CABO DE SANTO AGOSTINHO",
    "municipioIbge": 2602902,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 95.42,
    "precoMinimo": 90,
    "precoMaximo": 105,
    "desvioPadrao": 6.159314665030286,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CACADOR",
    "municipioIbge": 4203006,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 129.16,
    "precoMinimo": 115,
    "precoMaximo": 145,
    "desvioPadrao": 10.684880283216403,
    "coeficienteVariacao": 0.083
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 97.83,
    "precoMinimo": 77.99,
    "precoMaximo": 110,
    "desvioPadrao": 15.47404331991696,
    "coeficienteVariacao": 0.158
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CACERES",
    "municipioIbge": 5102504,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 125,
    "precoMinimo": 125,
    "precoMaximo": 125,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRA DO SUL",
    "municipioIbge": 4303004,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 115.83,
    "precoMinimo": 115,
    "precoMaximo": 120,
    "desvioPadrao": 2.041241452319315,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRINHA",
    "municipioIbge": 4303103,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 116.99,
    "precoMinimo": 109.99,
    "precoMaximo": 120,
    "desvioPadrao": 3.700001930501427,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 104.56,
    "precoMinimo": 99.99,
    "precoMaximo": 115,
    "desvioPadrao": 5.128308455918737,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "CACOAL",
    "municipioIbge": 1100049,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 137.42,
    "precoMinimo": 135,
    "precoMaximo": 144,
    "desvioPadrao": 3.309438162646487,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "CAETITE",
    "municipioIbge": 2905206,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 104.28,
    "precoMinimo": 100,
    "precoMaximo": 105,
    "desvioPadrao": 1.8898223650461363,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "CAICO",
    "municipioIbge": 2402006,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 117.49,
    "precoMinimo": 104.99,
    "precoMaximo": 120,
    "desvioPadrao": 6.127806839862584,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CALDAS NOVAS",
    "municipioIbge": 5204508,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 112.9,
    "precoMinimo": 98,
    "precoMaximo": 120,
    "desvioPadrao": 8.761658899242008,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMBE",
    "municipioIbge": 4103701,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.71,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 4.4986770542121866,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109.28,
    "precoMinimo": 95,
    "precoMaximo": 120,
    "desvioPadrao": 9.322272357358043,
    "coeficienteVariacao": 0.085
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 118.83,
    "precoMinimo": 114.99,
    "precoMaximo": 129.99,
    "desvioPadrao": 5.4584691899319076,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CAMPO BELO",
    "municipioIbge": 3111200,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 115,
    "precoMaximo": 115,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "LPG_P13",
    "postosPesquisados": 33,
    "unidade": "R$/13kg",
    "precoMedio": 115.14,
    "precoMinimo": 100,
    "precoMaximo": 132,
    "desvioPadrao": 9.117381668266853,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO LARGO",
    "municipioIbge": 4104204,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 106.41,
    "precoMinimo": 98.9,
    "precoMaximo": 112,
    "desvioPadrao": 4.343742077759134,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO MOURAO",
    "municipioIbge": 4104303,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 126.66,
    "precoMinimo": 125,
    "precoMaximo": 132,
    "desvioPadrao": 2.875181153713043,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 101.99,
    "precoMinimo": 96,
    "precoMaximo": 108,
    "desvioPadrao": 4.164135364434415,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CANINDE",
    "municipioIbge": 2302800,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 113.99,
    "precoMinimo": 99.99,
    "precoMaximo": 128,
    "desvioPadrao": 19.806060941035195,
    "coeficienteVariacao": 0.174
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 110.05,
    "precoMinimo": 104.9,
    "precoMaximo": 115,
    "desvioPadrao": 3.851023839887857,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CARAGUATATUBA",
    "municipioIbge": 3510500,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 106.66,
    "precoMinimo": 105,
    "precoMaximo": 109.99,
    "desvioPadrao": 2.8809778432562325,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CARATINGA",
    "municipioIbge": 3113404,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 121.14,
    "precoMinimo": 115,
    "precoMaximo": 130,
    "desvioPadrao": 5.698788509515902,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 100.62,
    "precoMinimo": 94.99,
    "precoMaximo": 110,
    "desvioPadrao": 4.1745416771528,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 96.6,
    "precoMinimo": 90,
    "precoMaximo": 100,
    "desvioPadrao": 3.0983866769659336,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASCAVEL",
    "municipioIbge": 4104808,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 112.84,
    "precoMinimo": 100,
    "precoMaximo": 123,
    "desvioPadrao": 6.9574557473397185,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CASTANHAL",
    "municipioIbge": 1502400,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 116.12,
    "precoMinimo": 105,
    "precoMaximo": 120,
    "desvioPadrao": 5.0832357523811265,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASTRO",
    "municipioIbge": 4104907,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 121.82,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 3.7774392938931025,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CATALAO",
    "municipioIbge": 5205109,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114,
    "precoMinimo": 105,
    "precoMaximo": 122,
    "desvioPadrao": 6.683312551921141,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CAUCAIA",
    "municipioIbge": 2303709,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 112.09,
    "precoMinimo": 100,
    "precoMaximo": 135,
    "desvioPadrao": 11.201508628553368,
    "coeficienteVariacao": 0.1
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 119.56,
    "precoMinimo": 115,
    "precoMaximo": 130,
    "desvioPadrao": 4.365846782912581,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CHAPECO",
    "municipioIbge": 4204202,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 134.64,
    "precoMinimo": 124.9,
    "precoMaximo": 145,
    "desvioPadrao": 7.761138948490601,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CIANORTE",
    "municipioIbge": 4105508,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.68,
    "precoMinimo": 104.9,
    "precoMaximo": 135,
    "desvioPadrao": 10.588740650871971,
    "coeficienteVariacao": 0.088
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "CODO",
    "municipioIbge": 2103307,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 118.57,
    "precoMinimo": 118,
    "precoMaximo": 120,
    "desvioPadrao": 0.9759000729485332,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "COLATINA",
    "municipioIbge": 3201506,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 105.42,
    "precoMinimo": 95,
    "precoMaximo": 110,
    "desvioPadrao": 5.8853340723239445,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 106.26,
    "precoMinimo": 100,
    "precoMaximo": 110,
    "desvioPadrao": 4.830073498405589,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CONCEICAO DO ARAGUAIA",
    "municipioIbge": 1502707,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 110,
    "precoMinimo": 110,
    "precoMaximo": 110,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CONCORDIA",
    "municipioIbge": 4204301,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 104.27,
    "precoMinimo": 94.99,
    "precoMaximo": 135,
    "desvioPadrao": 16.44362736601572,
    "coeficienteVariacao": 0.158
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONGONHAS",
    "municipioIbge": 3118007,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 110.49,
    "precoMinimo": 104.99,
    "precoMaximo": 120,
    "desvioPadrao": 5.6144471381131265,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONSELHEIRO LAFAIETE",
    "municipioIbge": 3118304,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 100.42,
    "precoMinimo": 95,
    "precoMaximo": 115,
    "desvioPadrao": 7.390470053998434,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "LPG_P13",
    "postosPesquisados": 16,
    "unidade": "R$/13kg",
    "precoMedio": 116.36,
    "precoMinimo": 99.99,
    "precoMaximo": 135,
    "desvioPadrao": 9.946202541673882,
    "coeficienteVariacao": 0.085
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CORNELIO PROCOPIO",
    "municipioIbge": 4106407,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 127.5,
    "precoMinimo": 125,
    "precoMaximo": 130,
    "desvioPadrao": 3.5355339059327378,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CORONEL FABRICIANO",
    "municipioIbge": 3119401,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 125,
    "precoMinimo": 110,
    "precoMaximo": 135,
    "desvioPadrao": 9.574271077563381,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CORUMBA",
    "municipioIbge": 5003207,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 133.33,
    "precoMinimo": 130,
    "precoMaximo": 135,
    "desvioPadrao": 2.581988897471611,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COSMOPOLIS",
    "municipioIbge": 3512803,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 102.49,
    "precoMinimo": 99.99,
    "precoMaximo": 104.99,
    "desvioPadrao": 2.736789481612838,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COTIA",
    "municipioIbge": 3513009,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.57,
    "precoMinimo": 114.99,
    "precoMaximo": 129.09,
    "desvioPadrao": 5.090791406339209,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CRATEUS",
    "municipioIbge": 2304103,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 120,
    "precoMinimo": 120,
    "precoMaximo": 120,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 110,
    "precoMinimo": 105,
    "precoMaximo": 115,
    "desvioPadrao": 4.08248290463863,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CRUZ ALTA",
    "municipioIbge": 4306106,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 96.14,
    "precoMinimo": 95,
    "precoMaximo": 99,
    "desvioPadrao": 1.9518001458970664,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 98.28,
    "precoMinimo": 94.99,
    "precoMaximo": 105,
    "desvioPadrao": 3.7312107061024222,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CUBATAO",
    "municipioIbge": 3513504,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 123.68,
    "precoMinimo": 116.99,
    "precoMaximo": 129.9,
    "desvioPadrao": 5.643024771470402,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CUIABA",
    "municipioIbge": 5103403,
    "produto": "LPG_P13",
    "postosPesquisados": 23,
    "unidade": "R$/13kg",
    "precoMedio": 124.08,
    "precoMinimo": 105,
    "precoMaximo": 140,
    "desvioPadrao": 8.643462904886114,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CURITIBA",
    "municipioIbge": 4106902,
    "produto": "LPG_P13",
    "postosPesquisados": 41,
    "unidade": "R$/13kg",
    "precoMedio": 108.31,
    "precoMinimo": 97,
    "precoMaximo": 119.9,
    "desvioPadrao": 6.023503497985529,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CURVELO",
    "municipioIbge": 3120904,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 107.71,
    "precoMinimo": 99,
    "precoMaximo": 125,
    "desvioPadrao": 10.873734190152675,
    "coeficienteVariacao": 0.101
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "DELMIRO GOUVEIA",
    "municipioIbge": 2702405,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 108.75,
    "precoMinimo": 100,
    "precoMaximo": 120,
    "desvioPadrao": 10.30776406404415,
    "coeficienteVariacao": 0.095
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "DIADEMA",
    "municipioIbge": 3513801,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 115.99,
    "precoMinimo": 104.99,
    "precoMaximo": 125,
    "desvioPadrao": 6.282176459749326,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "DIVINOPOLIS",
    "municipioIbge": 3122306,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 102.79,
    "precoMinimo": 89.99,
    "precoMaximo": 120,
    "desvioPadrao": 8.205771410686776,
    "coeficienteVariacao": 0.08
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "DOURADOS",
    "municipioIbge": 5003702,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 121.85,
    "precoMinimo": 115,
    "precoMaximo": 151,
    "desvioPadrao": 11.339903288538514,
    "coeficienteVariacao": 0.093
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "EMBU DAS ARTES",
    "municipioIbge": 3515004,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 115.29,
    "precoMinimo": 104.99,
    "precoMaximo": 128,
    "desvioPadrao": 7.222639368294976,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ERECHIM",
    "municipioIbge": 4307005,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 134.43,
    "precoMinimo": 120,
    "precoMaximo": 140,
    "desvioPadrao": 6.82934843158555,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 110,
    "precoMaximo": 125,
    "desvioPadrao": 5.773502691896258,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "EUNAPOLIS",
    "municipioIbge": 2910727,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109.85,
    "precoMinimo": 102,
    "precoMaximo": 115,
    "desvioPadrao": 4.8795003647426665,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 103.33,
    "precoMinimo": 99.99,
    "precoMaximo": 110,
    "desvioPadrao": 5.77639160722332,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 127.28,
    "precoMinimo": 119.9,
    "precoMaximo": 140,
    "desvioPadrao": 9.672107664137464,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FORMIGA",
    "municipioIbge": 3126109,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 118.14,
    "precoMinimo": 110,
    "precoMaximo": 125,
    "desvioPadrao": 4.740906081772816,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "FORMOSA",
    "municipioIbge": 5208004,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 113.28,
    "precoMinimo": 105,
    "precoMaximo": 125,
    "desvioPadrao": 7.432233529572065,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "FOZ DO IGUACU",
    "municipioIbge": 4108304,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 104.99,
    "precoMinimo": 99.99,
    "precoMaximo": 110,
    "desvioPadrao": 4.474373326698016,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "FRANCA",
    "municipioIbge": 3516200,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 117.73,
    "precoMinimo": 104.99,
    "precoMaximo": 122,
    "desvioPadrao": 5.532026075498922,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FRUTAL",
    "municipioIbge": 3127107,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 97.99,
    "precoMinimo": 89.99,
    "precoMaximo": 110,
    "desvioPadrao": 10.959928375678373,
    "coeficienteVariacao": 0.112
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "GARANHUNS",
    "municipioIbge": 2606002,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 115,
    "precoMaximo": 115,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GARCA",
    "municipioIbge": 3516705,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 132.5,
    "precoMinimo": 120,
    "precoMaximo": 135,
    "desvioPadrao": 6.123724356957945,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIANIA",
    "municipioIbge": 5208707,
    "produto": "LPG_P13",
    "postosPesquisados": 19,
    "unidade": "R$/13kg",
    "precoMedio": 116.05,
    "precoMinimo": 100,
    "precoMaximo": 125,
    "desvioPadrao": 7.374684055082001,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIATUBA",
    "municipioIbge": 5209101,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 118.33,
    "precoMinimo": 115,
    "precoMaximo": 120,
    "desvioPadrao": 2.886751345948129,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GOVERNADOR VALADARES",
    "municipioIbge": 3127701,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 125.28,
    "precoMinimo": 110,
    "precoMaximo": 130,
    "desvioPadrao": 7.111359122659225,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAMADO",
    "municipioIbge": 4309100,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 131.33,
    "precoMinimo": 125,
    "precoMaximo": 138,
    "desvioPadrao": 5.5377492419453835,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 114.44,
    "precoMinimo": 104.99,
    "precoMaximo": 125,
    "desvioPadrao": 6.877601326043841,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GUAIBA",
    "municipioIbge": 4309308,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 105.67,
    "precoMinimo": 99.9,
    "precoMaximo": 112,
    "desvioPadrao": 5.520783243258842,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "GUANAMBI",
    "municipioIbge": 2911709,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 110.62,
    "precoMinimo": 110,
    "precoMaximo": 115,
    "desvioPadrao": 1.7677669529663689,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "GUARAPARI",
    "municipioIbge": 3202405,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.56,
    "precoMinimo": 104.99,
    "precoMaximo": 118,
    "desvioPadrao": 4.508354678234833,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "GUARAPUAVA",
    "municipioIbge": 4109401,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 114.22,
    "precoMinimo": 108,
    "precoMaximo": 120,
    "desvioPadrao": 3.5629263877386586,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 98.31,
    "precoMinimo": 79.99,
    "precoMaximo": 115,
    "desvioPadrao": 11.690806216852625,
    "coeficienteVariacao": 0.119
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARUJA",
    "municipioIbge": 3518701,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 116.66,
    "precoMinimo": 100,
    "precoMaximo": 130,
    "desvioPadrao": 15.053682273782716,
    "coeficienteVariacao": 0.129
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "LPG_P13",
    "postosPesquisados": 12,
    "unidade": "R$/13kg",
    "precoMedio": 109.16,
    "precoMinimo": 95,
    "precoMaximo": 125,
    "desvioPadrao": 7.384055098451643,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GUAXUPE",
    "municipioIbge": 3128709,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 99,
    "precoMinimo": 92,
    "precoMaximo": 105,
    "desvioPadrao": 5.865151319446072,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "GURUPI",
    "municipioIbge": 1709500,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 136.62,
    "precoMinimo": 125,
    "precoMaximo": 145,
    "desvioPadrao": 7.633338531917548,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 102.49,
    "precoMinimo": 94.99,
    "precoMaximo": 105,
    "desvioPadrao": 4.629873301259365,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "IBITINGA",
    "municipioIbge": 3519600,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114.57,
    "precoMinimo": 110,
    "precoMaximo": 120,
    "desvioPadrao": 4.2370250120079485,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ICO",
    "municipioIbge": 2305407,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 125.5,
    "precoMinimo": 120,
    "precoMaximo": 133,
    "desvioPadrao": 5.446711546122731,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "IGARASSU",
    "municipioIbge": 2606804,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 107.14,
    "precoMinimo": 100,
    "precoMaximo": 115,
    "desvioPadrao": 4.8795003647426665,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "IGUATU",
    "municipioIbge": 2305506,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 121.71,
    "precoMinimo": 108,
    "precoMaximo": 125.99,
    "desvioPadrao": 6.367590932661605,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "IJUI",
    "municipioIbge": 4310207,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 116.25,
    "precoMinimo": 105.99,
    "precoMaximo": 135,
    "desvioPadrao": 9.338340068668266,
    "coeficienteVariacao": 0.08
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ILHEUS",
    "municipioIbge": 2913606,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 140.42,
    "precoMinimo": 130,
    "precoMaximo": 150,
    "desvioPadrao": 8.30484740836281,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "IMPERATRIZ",
    "municipioIbge": 2105302,
    "produto": "LPG_P13",
    "postosPesquisados": 11,
    "unidade": "R$/13kg",
    "precoMedio": 118.63,
    "precoMinimo": 110,
    "precoMaximo": 120,
    "desvioPadrao": 3.2329285907250216,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "INDAIATUBA",
    "municipioIbge": 3520509,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 120.66,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 3.5027631949647984,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "IPATINGA",
    "municipioIbge": 3131307,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 120.5,
    "precoMinimo": 100,
    "precoMaximo": 132,
    "desvioPadrao": 14.05939780597543,
    "coeficienteVariacao": 0.117
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IPIRA",
    "municipioIbge": 2914000,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 110.75,
    "precoMinimo": 98,
    "precoMaximo": 115,
    "desvioPadrao": 8.5,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IRECE",
    "municipioIbge": 2914604,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120,
    "precoMinimo": 120,
    "precoMaximo": 120,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ITABAIANA",
    "municipioIbge": 2802908,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114,
    "precoMinimo": 110,
    "precoMaximo": 118,
    "desvioPadrao": 3.4156502553198664,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 114.99,
    "precoMinimo": 114.99,
    "precoMaximo": 115,
    "desvioPadrao": 0.00483045891539648,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 112.4,
    "precoMinimo": 110,
    "precoMaximo": 122,
    "desvioPadrao": 5.366563145999495,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "LPG_P13",
    "postosPesquisados": 11,
    "unidade": "R$/13kg",
    "precoMedio": 126.09,
    "precoMinimo": 112,
    "precoMaximo": 135,
    "desvioPadrao": 7.258312476051166,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAJUBA",
    "municipioIbge": 3132404,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 102.66,
    "precoMinimo": 98,
    "precoMaximo": 105,
    "desvioPadrao": 4.041451884327381,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITAMARAJU",
    "municipioIbge": 2915601,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 105,
    "precoMinimo": 100,
    "precoMaximo": 110,
    "desvioPadrao": 5,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPECERICA DA SERRA",
    "municipioIbge": 3522208,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 119.26,
    "precoMinimo": 109.99,
    "precoMaximo": 124.99,
    "desvioPadrao": 4.496694553198149,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.71,
    "precoMinimo": 120,
    "precoMaximo": 125,
    "desvioPadrao": 1.8898223650461363,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ITAPIPOCA",
    "municipioIbge": 2306405,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 113,
    "precoMinimo": 97,
    "precoMaximo": 135,
    "desvioPadrao": 16.299284237863535,
    "coeficienteVariacao": 0.144
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPIRA",
    "municipioIbge": 3522604,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 119.39,
    "precoMinimo": 115,
    "precoMaximo": 122,
    "desvioPadrao": 2.606536015481083,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPOLIS",
    "municipioIbge": 3522703,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 135,
    "precoMinimo": 130,
    "precoMaximo": 140,
    "desvioPadrao": 2.886751345948129,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 97.54,
    "precoMinimo": 89.99,
    "precoMaximo": 105,
    "desvioPadrao": 5.004637849035632,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 110.8,
    "precoMinimo": 109,
    "precoMaximo": 115,
    "desvioPadrao": 2.3874672772626644,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAUNA",
    "municipioIbge": 3133808,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 123.57,
    "precoMinimo": 110,
    "precoMaximo": 130,
    "desvioPadrao": 7.4801324154309565,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 116,
    "precoMinimo": 110,
    "precoMaximo": 120,
    "desvioPadrao": 4.183300132670378,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITUIUTABA",
    "municipioIbge": 3134202,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109,
    "precoMinimo": 100,
    "precoMaximo": 118,
    "desvioPadrao": 6.855654600401045,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ITUMBIARA",
    "municipioIbge": 5211503,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 118.57,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 3.7796447300922726,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "JABOATAO DOS GUARARAPES",
    "municipioIbge": 2607901,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 100,
    "precoMinimo": 100,
    "precoMaximo": 100,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JABOTICABAL",
    "municipioIbge": 3524303,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 105.2,
    "precoMinimo": 99.9,
    "precoMaximo": 116,
    "desvioPadrao": 7.590783885739339,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 111.53,
    "precoMinimo": 89,
    "precoMaximo": 124.9,
    "desvioPadrao": 13.15779944029818,
    "coeficienteVariacao": 0.118
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JACOBINA",
    "municipioIbge": 2917508,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 138,
    "precoMinimo": 135,
    "precoMaximo": 142,
    "desvioPadrao": 3,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JAGUAQUARA",
    "municipioIbge": 2917607,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 110.71,
    "precoMinimo": 110,
    "precoMaximo": 115,
    "desvioPadrao": 1.8898223650461363,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JALES",
    "municipioIbge": 3524808,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 114.15,
    "precoMinimo": 105,
    "precoMaximo": 120,
    "desvioPadrao": 5.8352734868784575,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANAUBA",
    "municipioIbge": 3135100,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 124.57,
    "precoMinimo": 122,
    "precoMaximo": 125,
    "desvioPadrao": 1.133893419027682,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANUARIA",
    "municipioIbge": 3135209,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 134.42,
    "precoMinimo": 128,
    "precoMaximo": 138,
    "desvioPadrao": 3.25868802112869,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JAU",
    "municipioIbge": 3525300,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 116.31,
    "precoMinimo": 107,
    "precoMaximo": 137.9,
    "desvioPadrao": 11.287234677575666,
    "coeficienteVariacao": 0.097
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JEQUIE",
    "municipioIbge": 2918001,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 105.7,
    "precoMinimo": 99.99,
    "precoMaximo": 125,
    "desvioPadrao": 10.180748873194329,
    "coeficienteVariacao": 0.096
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "JI-PARANA",
    "municipioIbge": 1100122,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 127.83,
    "precoMinimo": 120,
    "precoMaximo": 136,
    "desvioPadrao": 6.493586579592719,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO MONLEVADE",
    "municipioIbge": 3136207,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.42,
    "precoMinimo": 105,
    "precoMaximo": 125,
    "desvioPadrao": 6.267831705280087,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "LPG_P13",
    "postosPesquisados": 25,
    "unidade": "R$/13kg",
    "precoMedio": 106.72,
    "precoMinimo": 92.99,
    "precoMaximo": 125,
    "desvioPadrao": 6.599603826493426,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO PINHEIRO",
    "municipioIbge": 3136306,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 113.28,
    "precoMinimo": 105,
    "precoMaximo": 120,
    "desvioPadrao": 6.473388749701496,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 122.1,
    "precoMinimo": 110,
    "precoMaximo": 136,
    "desvioPadrao": 6.871034209717712,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JUAZEIRO",
    "municipioIbge": 2918407,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 105,
    "precoMinimo": 100,
    "precoMaximo": 110,
    "desvioPadrao": 7.0710678118654755,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "JUAZEIRO DO NORTE",
    "municipioIbge": 2307304,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 120,
    "precoMinimo": 120,
    "precoMaximo": 120,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 99.59,
    "precoMinimo": 84.99,
    "precoMaximo": 115,
    "desvioPadrao": 9.419237002766504,
    "coeficienteVariacao": 0.095
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 120.5,
    "precoMinimo": 110,
    "precoMaximo": 130,
    "desvioPadrao": 8.141603913585717,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 116.66,
    "precoMinimo": 115,
    "precoMaximo": 120,
    "desvioPadrao": 2.581988897471611,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114.99,
    "precoMinimo": 109.99,
    "precoMaximo": 125,
    "desvioPadrao": 5.774947124062201,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 126,
    "precoMinimo": 120,
    "precoMaximo": 130,
    "desvioPadrao": 4.183300132670378,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "LAJEDO",
    "municipioIbge": 2608800,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 101.25,
    "precoMinimo": 100,
    "precoMaximo": 105,
    "desvioPadrao": 2.5,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LAVRAS",
    "municipioIbge": 3138203,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 114.81,
    "precoMinimo": 99,
    "precoMaximo": 145,
    "desvioPadrao": 17.515734355144804,
    "coeficienteVariacao": 0.153
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LEME",
    "municipioIbge": 3526704,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 108.33,
    "precoMinimo": 105,
    "precoMaximo": 115,
    "desvioPadrao": 5.773502691896258,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LEOPOLDINA",
    "municipioIbge": 3138401,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109.57,
    "precoMinimo": 100,
    "precoMaximo": 125,
    "desvioPadrao": 8.244248500217186,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LIMEIRA",
    "municipioIbge": 3526902,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 103.99,
    "precoMinimo": 99.99,
    "precoMaximo": 110,
    "desvioPadrao": 5.479052837854368,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "LIMOEIRO DO NORTE",
    "municipioIbge": 2307601,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 122.5,
    "precoMinimo": 105,
    "precoMaximo": 130,
    "desvioPadrao": 11.726039399558575,
    "coeficienteVariacao": 0.096
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LINS",
    "municipioIbge": 3527108,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 109.16,
    "precoMinimo": 89.99,
    "precoMaximo": 130,
    "desvioPadrao": 16.255563662943217,
    "coeficienteVariacao": 0.149
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "LIVRAMENTO DE NOSSA SENHORA",
    "municipioIbge": 2919504,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 116.25,
    "precoMinimo": 115,
    "precoMaximo": 120,
    "desvioPadrao": 2.5,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "LONDRINA",
    "municipioIbge": 4113700,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 116.06,
    "precoMinimo": 100,
    "precoMaximo": 135,
    "desvioPadrao": 8.826885715164291,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LORENA",
    "municipioIbge": 3527207,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 97.81,
    "precoMinimo": 90,
    "precoMaximo": 110,
    "desvioPadrao": 6.788347859874792,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 147.83,
    "precoMinimo": 145,
    "precoMaximo": 151.99,
    "desvioPadrao": 3.185909080100477,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AP",
    "estadoNome": "AMAPA",
    "municipioNome": "MACAPA",
    "municipioIbge": 1600303,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 126.76,
    "precoMinimo": 111,
    "precoMaximo": 140,
    "desvioPadrao": 9.782244511987404,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "MACEIO",
    "municipioIbge": 2704302,
    "produto": "LPG_P13",
    "postosPesquisados": 25,
    "unidade": "R$/13kg",
    "precoMedio": 105.87,
    "precoMinimo": 86.99,
    "precoMaximo": 120,
    "desvioPadrao": 7.5643160739531945,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANACAPURU",
    "municipioIbge": 1302504,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 133,
    "precoMinimo": 127,
    "precoMaximo": 140,
    "desvioPadrao": 4.396968652757639,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "LPG_P13",
    "postosPesquisados": 63,
    "unidade": "R$/13kg",
    "precoMedio": 128.26,
    "precoMinimo": 120,
    "precoMaximo": 146,
    "desvioPadrao": 5.0216122771228715,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "MARABA",
    "municipioIbge": 1504208,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 128.75,
    "precoMinimo": 120,
    "precoMaximo": 135,
    "desvioPadrao": 5.175491695067657,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 96.28,
    "precoMinimo": 85,
    "precoMaximo": 105,
    "desvioPadrao": 7.0618711266578496,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MARILIA",
    "municipioIbge": 3529005,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 135,
    "precoMinimo": 130,
    "precoMaximo": 142,
    "desvioPadrao": 4.27617987059879,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "MARINGA",
    "municipioIbge": 4115200,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 113.88,
    "precoMinimo": 99.99,
    "precoMaximo": 130,
    "desvioPadrao": 10.55128686201093,
    "coeficienteVariacao": 0.093
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MATAO",
    "municipioIbge": 3529302,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 112.49,
    "precoMinimo": 94.99,
    "precoMaximo": 130,
    "desvioPadrao": 24.75580840934103,
    "coeficienteVariacao": 0.22
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 116.99,
    "precoMinimo": 114.99,
    "precoMaximo": 120,
    "desvioPadrao": 2.5841450337694973,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "MINEIROS",
    "municipioIbge": 5213103,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 138,
    "precoMinimo": 138,
    "precoMaximo": 138,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOCOCA",
    "municipioIbge": 3530508,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 119.99,
    "precoMinimo": 114.99,
    "precoMaximo": 130,
    "desvioPadrao": 5.0033346023284455,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 113.4,
    "precoMinimo": 108,
    "precoMaximo": 117,
    "desvioPadrao": 4.159326868617084,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI GUACU",
    "municipioIbge": 3530706,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 123,
    "precoMinimo": 120,
    "precoMaximo": 125,
    "desvioPadrao": 2.7386127875258306,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 118,
    "precoMinimo": 110,
    "precoMaximo": 125,
    "desvioPadrao": 7.582875444051551,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MONTE ALTO",
    "municipioIbge": 3531308,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.71,
    "precoMinimo": 100,
    "precoMaximo": 124,
    "desvioPadrao": 7.521398046336105,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTE CARMELO",
    "municipioIbge": 3143104,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 107.16,
    "precoMinimo": 95,
    "precoMaximo": 110,
    "desvioPadrao": 6.013872850889572,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTES CLAROS",
    "municipioIbge": 3143302,
    "produto": "LPG_P13",
    "postosPesquisados": 23,
    "unidade": "R$/13kg",
    "precoMedio": 115.47,
    "precoMinimo": 97,
    "precoMaximo": 130,
    "desvioPadrao": 8.929186278095715,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 116.25,
    "precoMinimo": 110,
    "precoMaximo": 120,
    "desvioPadrao": 4.787135538781691,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MURIAE",
    "municipioIbge": 3143906,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 107.5,
    "precoMinimo": 105,
    "precoMaximo": 110,
    "desvioPadrao": 2.7386127875258306,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 113,
    "precoMinimo": 97,
    "precoMaximo": 130,
    "desvioPadrao": 8.272156395316243,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 94.77,
    "precoMinimo": 80,
    "precoMaximo": 118.9,
    "desvioPadrao": 14.543549429214314,
    "coeficienteVariacao": 0.153
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 110.88,
    "precoMinimo": 105,
    "precoMaximo": 117,
    "desvioPadrao": 3.1402406135694623,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NOVA FRIBURGO",
    "municipioIbge": 3303401,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109.28,
    "precoMinimo": 96.99,
    "precoMaximo": 115,
    "desvioPadrao": 7.525070795427142,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "NOVA LIMA",
    "municipioIbge": 3144805,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 107.5,
    "precoMinimo": 100,
    "precoMaximo": 117,
    "desvioPadrao": 7.14142842854285,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "NOVO HAMBURGO",
    "municipioIbge": 4313409,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 103.8,
    "precoMinimo": 100,
    "precoMaximo": 110,
    "desvioPadrao": 3.155242550986462,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OLIMPIA",
    "municipioIbge": 3533908,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 96.14,
    "precoMinimo": 95,
    "precoMaximo": 100,
    "desvioPadrao": 2.0354009783964297,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "OLINDA",
    "municipioIbge": 2609600,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 101,
    "precoMinimo": 95,
    "precoMaximo": 110,
    "desvioPadrao": 4.594682917363407,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 111.14,
    "precoMinimo": 94.99,
    "precoMaximo": 124.99,
    "desvioPadrao": 7.946174535182936,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "OSORIO",
    "municipioIbge": 4313508,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.95,
    "precoMinimo": 106.99,
    "precoMaximo": 119.9,
    "desvioPadrao": 4.714791819875179,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OURINHOS",
    "municipioIbge": 3534708,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 114.18,
    "precoMinimo": 109.9,
    "precoMaximo": 122,
    "desvioPadrao": 5.866174221756459,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "OURO PRETO",
    "municipioIbge": 3146107,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 105.72,
    "precoMinimo": 94.9,
    "precoMaximo": 110,
    "desvioPadrao": 7.232046736574647,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PALMAS",
    "municipioIbge": 1721000,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 133.21,
    "precoMinimo": 125,
    "precoMaximo": 141,
    "desvioPadrao": 4.405915104956962,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 110,
    "precoMinimo": 105,
    "precoMaximo": 115,
    "desvioPadrao": 7.0710678118654755,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARA DE MINAS",
    "municipioIbge": 3147105,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 108.28,
    "precoMinimo": 95.99,
    "precoMaximo": 127,
    "desvioPadrao": 10.72256299318671,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARACATU",
    "municipioIbge": 3147006,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 119.28,
    "precoMinimo": 105,
    "precoMaximo": 130,
    "desvioPadrao": 9.322272357358043,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAGOMINAS",
    "municipioIbge": 1505502,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 135.71,
    "precoMinimo": 130,
    "precoMaximo": 140,
    "desvioPadrao": 5.3452248382484875,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PARAGUACU PAULISTA",
    "municipioIbge": 3535507,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 123.75,
    "precoMinimo": 120,
    "precoMaximo": 125,
    "desvioPadrao": 2.5,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PARAISO DO TOCANTINS",
    "municipioIbge": 1716109,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 135.71,
    "precoMinimo": 130,
    "precoMaximo": 140,
    "desvioPadrao": 3.4503277967117714,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAGUA",
    "municipioIbge": 4118204,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 106.42,
    "precoMinimo": 100,
    "precoMaximo": 110,
    "desvioPadrao": 3.7796447300922726,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAVAI",
    "municipioIbge": 4118402,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 104.23,
    "precoMinimo": 99.9,
    "precoMaximo": 104.99,
    "desvioPadrao": 1.9129707637225257,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAUAPEBAS",
    "municipioIbge": 1505536,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 126.66,
    "precoMinimo": 125,
    "precoMaximo": 135,
    "desvioPadrao": 4.08248290463863,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "PARINTINS",
    "municipioIbge": 1303403,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 121.14,
    "precoMinimo": 120,
    "precoMaximo": 124,
    "desvioPadrao": 1.9518001458970664,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PARNAIBA",
    "municipioIbge": 2207702,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.71,
    "precoMinimo": 119.99,
    "precoMaximo": 125,
    "desvioPadrao": 1.8904559792610378,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "PARNAMIRIM",
    "municipioIbge": 2403251,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 108.22,
    "precoMinimo": 99.9,
    "precoMaximo": 110,
    "desvioPadrao": 3.6985196523808845,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PASSO FUNDO",
    "municipioIbge": 4314100,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 123.8,
    "precoMinimo": 120,
    "precoMaximo": 130,
    "desvioPadrao": 3.6453928305312844,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PASSOS",
    "municipioIbge": 3147907,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.42,
    "precoMinimo": 105,
    "precoMaximo": 120,
    "desvioPadrao": 4.756450757605276,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PATO BRANCO",
    "municipioIbge": 4118501,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 127.83,
    "precoMinimo": 115,
    "precoMaximo": 132,
    "desvioPadrao": 6.337717780610515,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 117.33,
    "precoMinimo": 112,
    "precoMaximo": 120,
    "desvioPadrao": 3.32665998663324,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PATROCINIO",
    "municipioIbge": 3148103,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.28,
    "precoMinimo": 110,
    "precoMaximo": 119,
    "desvioPadrao": 3.4016802570830453,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PAULINIA",
    "municipioIbge": 3536505,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 116.66,
    "precoMinimo": 109.99,
    "precoMaximo": 120,
    "desvioPadrao": 4.0833025849182425,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PAULISTA",
    "municipioIbge": 2610707,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 103.49,
    "precoMinimo": 99.99,
    "precoMaximo": 115,
    "desvioPadrao": 4.743886826455942,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PAULO AFONSO",
    "municipioIbge": 2924009,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 112,
    "precoMinimo": 110,
    "precoMaximo": 113,
    "desvioPadrao": 1.7320508075688774,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PELOTAS",
    "municipioIbge": 4314407,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 119.79,
    "precoMinimo": 113,
    "precoMaximo": 131,
    "desvioPadrao": 4.544771983384027,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PETROLINA",
    "municipioIbge": 2611101,
    "produto": "LPG_P13",
    "postosPesquisados": 12,
    "unidade": "R$/13kg",
    "precoMedio": 115.91,
    "precoMinimo": 103,
    "precoMaximo": 130,
    "desvioPadrao": 6.6940724570776835,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 105.13,
    "precoMinimo": 89.99,
    "precoMaximo": 118,
    "desvioPadrao": 11.994206140982444,
    "coeficienteVariacao": 0.114
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PICOS",
    "municipioIbge": 2208007,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 111.83,
    "precoMinimo": 100,
    "precoMaximo": 115,
    "desvioPadrao": 5.879342366852493,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PIMENTA BUENO",
    "municipioIbge": 1100189,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 148,
    "precoMinimo": 147,
    "precoMaximo": 150,
    "desvioPadrao": 1.4142135623730951,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PINHEIRO",
    "municipioIbge": 2108603,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 133.55,
    "precoMinimo": 129.9,
    "precoMaximo": 140,
    "desvioPadrao": 3.795548771415074,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRACICABA",
    "municipioIbge": 3538709,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 106.87,
    "precoMinimo": 99.99,
    "precoMaximo": 115,
    "desvioPadrao": 6.516190824181169,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRASSUNUNGA",
    "municipioIbge": 3539301,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 115.81,
    "precoMinimo": 109.9,
    "precoMaximo": 128,
    "desvioPadrao": 6.762501650382688,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PIRIPIRI",
    "municipioIbge": 2208403,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.42,
    "precoMinimo": 110,
    "precoMaximo": 137.99,
    "desvioPadrao": 9.9789793351539,
    "coeficienteVariacao": 0.083
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109.99,
    "precoMinimo": 97.99,
    "precoMaximo": 114.99,
    "desvioPadrao": 5.745144948231548,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "POCOES",
    "municipioIbge": 2925105,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.85,
    "precoMinimo": 100,
    "precoMaximo": 120,
    "desvioPadrao": 7.358183005529092,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "POCOS DE CALDAS",
    "municipioIbge": 3151800,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 124.66,
    "precoMinimo": 123,
    "precoMaximo": 125,
    "desvioPadrao": 0.8156898920545725,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 114.9,
    "precoMinimo": 114.9,
    "precoMaximo": 114.9,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "PONTA PORA",
    "municipioIbge": 5006606,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 126.58,
    "precoMinimo": 120,
    "precoMaximo": 134.9,
    "desvioPadrao": 5.466443084858746,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "PORANGATU",
    "municipioIbge": 5218003,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.71,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 3.4503277967117714,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 118.66,
    "precoMinimo": 105,
    "precoMaximo": 135,
    "desvioPadrao": 10.074990251679084,
    "coeficienteVariacao": 0.085
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 113.5,
    "precoMinimo": 108,
    "precoMaximo": 118,
    "desvioPadrao": 4.203173404306164,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PORTO VELHO",
    "municipioIbge": 1100205,
    "produto": "LPG_P13",
    "postosPesquisados": 22,
    "unidade": "R$/13kg",
    "precoMedio": 123.4,
    "precoMinimo": 112,
    "precoMaximo": 139,
    "desvioPadrao": 6.953307475474162,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRAIA GRANDE",
    "municipioIbge": 3541000,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 125.37,
    "precoMinimo": 115.99,
    "precoMaximo": 130,
    "desvioPadrao": 4.931884471927991,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PRESIDENTE DUTRA",
    "municipioIbge": 2109106,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 118.25,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 4.7169905660283025,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRESIDENTE PRUDENTE",
    "municipioIbge": 3541406,
    "produto": "LPG_P13",
    "postosPesquisados": 12,
    "unidade": "R$/13kg",
    "precoMedio": 114.23,
    "precoMinimo": 99.99,
    "precoMaximo": 128,
    "desvioPadrao": 10.762396200182232,
    "coeficienteVariacao": 0.094
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "QUIXADA",
    "municipioIbge": 2311306,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 118.42,
    "precoMinimo": 105.99,
    "precoMaximo": 124,
    "desvioPadrao": 5.714935736838209,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "RECIFE",
    "municipioIbge": 2611606,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 101.79,
    "precoMinimo": 97,
    "precoMaximo": 110,
    "desvioPadrao": 3.571877857454175,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 126,
    "precoMinimo": 125,
    "precoMaximo": 127,
    "desvioPadrao": 1.0954451150103324,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PIRES",
    "municipioIbge": 3543303,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 107.84,
    "precoMinimo": 94.99,
    "precoMaximo": 120,
    "desvioPadrao": 11.50978569160463,
    "coeficienteVariacao": 0.107
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PRETO",
    "municipioIbge": 3543402,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 117.77,
    "precoMinimo": 109.99,
    "precoMaximo": 130,
    "desvioPadrao": 6.668125673680724,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 91.42,
    "precoMinimo": 90,
    "precoMaximo": 95,
    "desvioPadrao": 2.437312141723025,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AC",
    "estadoNome": "ACRE",
    "municipioNome": "RIO BRANCO",
    "municipioIbge": 1200401,
    "produto": "LPG_P13",
    "postosPesquisados": 23,
    "unidade": "R$/13kg",
    "precoMedio": 125.95,
    "precoMinimo": 115,
    "precoMaximo": 135,
    "desvioPadrao": 6.704667715104193,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 103,
    "precoMinimo": 103,
    "precoMaximo": 103,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 94.49,
    "precoMinimo": 89.99,
    "precoMaximo": 99.99,
    "desvioPadrao": 4.20238424389457,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "RIO LARGO",
    "municipioIbge": 2707701,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109,
    "precoMinimo": 100,
    "precoMaximo": 113,
    "desvioPadrao": 4.123105625617661,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "RIO VERDE",
    "municipioIbge": 5218805,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 118.32,
    "precoMinimo": 99.99,
    "precoMaximo": 135,
    "desvioPadrao": 14.3660489039649,
    "coeficienteVariacao": 0.121
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "RONDONOPOLIS",
    "municipioIbge": 5107602,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 138.85,
    "precoMinimo": 132,
    "precoMaximo": 150,
    "desvioPadrao": 6.51737604225738,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 124.16,
    "precoMinimo": 105,
    "precoMaximo": 135,
    "desvioPadrao": 10.684880283216403,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SALGUEIRO",
    "municipioIbge": 2612208,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 118,
    "precoMinimo": 115,
    "precoMaximo": 120,
    "desvioPadrao": 2.7386127875258306,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SALTO",
    "municipioIbge": 3545209,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 109.74,
    "precoMinimo": 99.99,
    "precoMaximo": 118,
    "desvioPadrao": 8.656791168402604,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SALVADOR",
    "municipioIbge": 2927408,
    "produto": "LPG_P13",
    "postosPesquisados": 27,
    "unidade": "R$/13kg",
    "precoMedio": 122.18,
    "precoMinimo": 110,
    "precoMaximo": 140,
    "desvioPadrao": 8.576043705638728,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SANTA CRUZ DO CAPIBARIBE",
    "municipioIbge": 2612505,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 115,
    "precoMaximo": 115,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTA MARIA",
    "municipioIbge": 4316907,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 116.9,
    "precoMinimo": 109.9,
    "precoMaximo": 125,
    "desvioPadrao": 4.146446910069147,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTANA DO LIVRAMENTO",
    "municipioIbge": null,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 124.16,
    "precoMinimo": 115,
    "precoMaximo": 135,
    "desvioPadrao": 8.612007121842542,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "SANTAREM",
    "municipioIbge": 1506807,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 95,
    "precoMinimo": 85,
    "precoMaximo": 105,
    "desvioPadrao": 14.142135623730951,
    "coeficienteVariacao": 0.149
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 115.69,
    "precoMinimo": 99.99,
    "precoMaximo": 129.99,
    "desvioPadrao": 8.89418168117662,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTO ANGELO",
    "municipioIbge": 4317509,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 122.49,
    "precoMinimo": 114.99,
    "precoMaximo": 135,
    "desvioPadrao": 9.576883191658268,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SANTO ANTONIO DA PLATINA",
    "municipioIbge": 4124103,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 117.15,
    "precoMinimo": 115,
    "precoMaximo": 122,
    "desvioPadrao": 2.781186797034676,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SANTO ANTONIO DE JESUS",
    "municipioIbge": 2928703,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 116.19,
    "precoMinimo": 108.99,
    "precoMaximo": 137,
    "desvioPadrao": 11.863221316320454,
    "coeficienteVariacao": 0.102
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 110.75,
    "precoMinimo": 100,
    "precoMaximo": 118,
    "desvioPadrao": 7.88986691902975,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTOS",
    "municipioIbge": 3548500,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 134.63,
    "precoMinimo": 125,
    "precoMaximo": 150,
    "desvioPadrao": 9.636000207555,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 138.99,
    "precoMinimo": 125,
    "precoMaximo": 150,
    "desvioPadrao": 11.401317029185707,
    "coeficienteVariacao": 0.082
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CAETANO DO SUL",
    "municipioIbge": 3548807,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 119.99,
    "precoMinimo": 119.99,
    "precoMaximo": 120,
    "desvioPadrao": 0.005,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CARLOS",
    "municipioIbge": 3548906,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 131.34,
    "precoMinimo": 119.99,
    "precoMaximo": 139,
    "desvioPadrao": 5.790722638956098,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 106.28,
    "precoMinimo": 99.99,
    "precoMaximo": 115,
    "desvioPadrao": 4.6180515371745265,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOAO DA BOA VISTA",
    "municipioIbge": 3549102,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114.71,
    "precoMinimo": 113,
    "precoMaximo": 115,
    "desvioPadrao": 0.7559289460184545,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO JOAO DEL REI",
    "municipioIbge": 3162500,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 109.99,
    "precoMinimo": 109.99,
    "precoMaximo": 110,
    "desvioPadrao": 0.0037796447300922726,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "SAO JOSE",
    "municipioIbge": 4216602,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 121.8,
    "precoMinimo": 100,
    "precoMaximo": 130,
    "desvioPadrao": 8.21651453544087,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO JOSE DE RIBAMAR",
    "municipioIbge": 2111201,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 121.12,
    "precoMinimo": 99.99,
    "precoMaximo": 130,
    "desvioPadrao": 13.477840013465489,
    "coeficienteVariacao": 0.111
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DO RIO PRETO",
    "municipioIbge": 3549805,
    "produto": "LPG_P13",
    "postosPesquisados": 21,
    "unidade": "R$/13kg",
    "precoMedio": 124.19,
    "precoMinimo": 113,
    "precoMaximo": 145,
    "desvioPadrao": 8.399767853935012,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 101.78,
    "precoMinimo": 79.99,
    "precoMaximo": 120,
    "desvioPadrao": 14.112266430645498,
    "coeficienteVariacao": 0.139
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 102.19,
    "precoMinimo": 95,
    "precoMaximo": 105,
    "desvioPadrao": 3.676424744381272,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 103.99,
    "precoMinimo": 98,
    "precoMaximo": 110,
    "desvioPadrao": 4.866211492086456,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO LUIS",
    "municipioIbge": 2111300,
    "produto": "LPG_P13",
    "postosPesquisados": 28,
    "unidade": "R$/13kg",
    "precoMedio": 129.02,
    "precoMinimo": 115,
    "precoMaximo": 138,
    "desvioPadrao": 4.149107301832095,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LUIZ GONZAGA",
    "municipioIbge": 4318903,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 111.33,
    "precoMinimo": 105,
    "precoMaximo": 120,
    "desvioPadrao": 6.377042156569664,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SAO MATEUS",
    "municipioIbge": 3204906,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 119.99,
    "precoMinimo": 119.99,
    "precoMaximo": 119.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "LPG_P13",
    "postosPesquisados": 43,
    "unidade": "R$/13kg",
    "precoMedio": 119.18,
    "precoMinimo": 99.99,
    "precoMaximo": 144.99,
    "desvioPadrao": 10.764516732638983,
    "coeficienteVariacao": 0.09
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO SEBASTIAO DO PARAISO",
    "municipioIbge": 3164704,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 107.49,
    "precoMinimo": 94.99,
    "precoMaximo": 120,
    "desvioPadrao": 8.866067637749154,
    "coeficienteVariacao": 0.082
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO VICENTE",
    "municipioIbge": 3551009,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 119.85,
    "precoMinimo": 109.99,
    "precoMaximo": 129.9,
    "desvioPadrao": 6.643614812568364,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPIRANGA",
    "municipioIbge": 4319901,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 113.85,
    "precoMinimo": 100,
    "precoMaximo": 122,
    "desvioPadrao": 6.644009116704849,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 111.28,
    "precoMinimo": 105,
    "precoMaximo": 118,
    "desvioPadrao": 5.282495802626057,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 96.42,
    "precoMinimo": 92,
    "precoMaximo": 100,
    "desvioPadrao": 2.438584679295603,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SENHOR DO BONFIM",
    "municipioIbge": 2930105,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 123.33,
    "precoMinimo": 120,
    "precoMaximo": 125,
    "desvioPadrao": 2.886751345948129,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 99.91,
    "precoMinimo": 92.99,
    "precoMaximo": 105.99,
    "desvioPadrao": 4.252212093993865,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SERRA TALHADA",
    "municipioIbge": 2613909,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 122.5,
    "precoMinimo": 115,
    "precoMaximo": 130,
    "desvioPadrao": 6.123724356957945,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SERRINHA",
    "municipioIbge": 2930501,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 127.85,
    "precoMinimo": 120,
    "precoMaximo": 135,
    "desvioPadrao": 5.669467095138409,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SERTAOZINHO",
    "municipioIbge": 3551702,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 106.24,
    "precoMinimo": 96.99,
    "precoMaximo": 115,
    "desvioPadrao": 7.369420488297118,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 107.71,
    "precoMinimo": 94.99,
    "precoMaximo": 120,
    "desvioPadrao": 10.64453917676638,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SINOP",
    "municipioIbge": 5107909,
    "produto": "LPG_P13",
    "postosPesquisados": 11,
    "unidade": "R$/13kg",
    "precoMedio": 141.18,
    "precoMinimo": 130,
    "precoMaximo": 145,
    "desvioPadrao": 6.585107164172529,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "SOBRAL",
    "municipioIbge": 2312908,
    "produto": "LPG_P13",
    "postosPesquisados": 2,
    "unidade": "R$/13kg",
    "precoMedio": 118,
    "precoMinimo": 118,
    "precoMaximo": 118,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SOROCABA",
    "municipioIbge": 3552205,
    "produto": "LPG_P13",
    "postosPesquisados": 15,
    "unidade": "R$/13kg",
    "precoMedio": 120.51,
    "precoMinimo": 107.99,
    "precoMaximo": 132,
    "desvioPadrao": 6.188903895567569,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SORRISO",
    "municipioIbge": 5107925,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 136.99,
    "precoMinimo": 124.99,
    "precoMaximo": 144,
    "desvioPadrao": 5.876224222331132,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "SOUSA",
    "municipioIbge": 2516201,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 115,
    "precoMinimo": 115,
    "precoMaximo": 115,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 100.88,
    "precoMinimo": 94.99,
    "precoMaximo": 109.99,
    "desvioPadrao": 4.284728696195362,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 107.94,
    "precoMinimo": 89.99,
    "precoMaximo": 119.99,
    "desvioPadrao": 11.264103505285176,
    "coeficienteVariacao": 0.104
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TABOAO DA SERRA",
    "municipioIbge": 3552809,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 116.56,
    "precoMinimo": 105,
    "precoMaximo": 136,
    "desvioPadrao": 10.19565874001563,
    "coeficienteVariacao": 0.087
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TATUI",
    "municipioIbge": 3554003,
    "produto": "LPG_P13",
    "postosPesquisados": 4,
    "unidade": "R$/13kg",
    "precoMedio": 127.5,
    "precoMinimo": 125,
    "precoMaximo": 130,
    "desvioPadrao": 2.886751345948129,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 98.98,
    "precoMinimo": 94.99,
    "precoMaximo": 109.9,
    "desvioPadrao": 4.794637919361354,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "TEIXEIRA DE FREITAS",
    "municipioIbge": 2931350,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 95.37,
    "precoMinimo": 89.99,
    "precoMaximo": 97,
    "desvioPadrao": 2.2672383295227574,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 126,
    "precoMinimo": 110,
    "precoMaximo": 130,
    "desvioPadrao": 7.302967433402215,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "TERESINA",
    "municipioIbge": 2211001,
    "produto": "LPG_P13",
    "postosPesquisados": 22,
    "unidade": "R$/13kg",
    "precoMedio": 111.59,
    "precoMinimo": 100,
    "precoMaximo": 120,
    "desvioPadrao": 4.971891924344224,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "TOLEDO",
    "municipioIbge": 4127700,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 108.48,
    "precoMinimo": 100,
    "precoMaximo": 130,
    "desvioPadrao": 9.439373802206255,
    "coeficienteVariacao": 0.087
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 120.66,
    "precoMinimo": 114.99,
    "precoMaximo": 127,
    "desvioPadrao": 6.032415215594276,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TRES CORACOES",
    "municipioIbge": 3169307,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 100,
    "precoMinimo": 95,
    "precoMaximo": 110,
    "desvioPadrao": 5,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "TRES LAGOAS",
    "municipioIbge": 5008305,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 125,
    "precoMinimo": 125,
    "precoMaximo": 125,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 99.99,
    "precoMinimo": 94.99,
    "precoMaximo": 104.99,
    "desvioPadrao": 2.8867554698756774,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "TRINDADE",
    "municipioIbge": 5221403,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 130,
    "precoMinimo": 130,
    "precoMaximo": 130,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 112.14,
    "precoMinimo": 100,
    "precoMaximo": 120,
    "desvioPadrao": 6.98638131005772,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBA",
    "municipioIbge": 3169901,
    "produto": "LPG_P13",
    "postosPesquisados": 1,
    "unidade": "R$/13kg",
    "precoMedio": 94.99,
    "precoMinimo": 94.99,
    "precoMaximo": 94.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "UBATUBA",
    "municipioIbge": 3555406,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 104.42,
    "precoMinimo": 85.95,
    "precoMaximo": 120,
    "desvioPadrao": 12.487055202050145,
    "coeficienteVariacao": 0.12
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERLANDIA",
    "municipioIbge": 3170206,
    "produto": "LPG_P13",
    "postosPesquisados": 14,
    "unidade": "R$/13kg",
    "precoMedio": 101.42,
    "precoMinimo": 87,
    "precoMaximo": 120,
    "desvioPadrao": 7.941186454661061,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UMUARAMA",
    "municipioIbge": 4128104,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 123.41,
    "precoMinimo": 107.9,
    "precoMaximo": 135,
    "desvioPadrao": 8.951802159607968,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UNAI",
    "municipioIbge": 3170404,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 130,
    "precoMinimo": 130,
    "precoMaximo": 130,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UNIAO DA VITORIA",
    "municipioIbge": 4128203,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114.42,
    "precoMinimo": 110,
    "precoMaximo": 128,
    "desvioPadrao": 7.699721701835352,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "URUGUAIANA",
    "municipioIbge": 4322400,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 132.28,
    "precoMinimo": 125,
    "precoMaximo": 161,
    "desvioPadrao": 13.22515640379205,
    "coeficienteVariacao": 0.1
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VACARIA",
    "municipioIbge": 4322509,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 123.85,
    "precoMinimo": 118,
    "precoMaximo": 128,
    "desvioPadrao": 3.7161167647860327,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VALENCA",
    "municipioIbge": 2932903,
    "produto": "LPG_P13",
    "postosPesquisados": 3,
    "unidade": "R$/13kg",
    "precoMedio": 118.33,
    "precoMinimo": 105,
    "precoMaximo": 130,
    "desvioPadrao": 12.583057392117915,
    "coeficienteVariacao": 0.106
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 104.16,
    "precoMinimo": 100,
    "precoMaximo": 110,
    "desvioPadrao": 4.915960401250875,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VALINHOS",
    "municipioIbge": 3556206,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 120.97,
    "precoMinimo": 109.99,
    "precoMaximo": 140,
    "desvioPadrao": 11.228067361156445,
    "coeficienteVariacao": 0.093
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "VALPARAISO DE GOIAS",
    "municipioIbge": 5221858,
    "produto": "LPG_P13",
    "postosPesquisados": 9,
    "unidade": "R$/13kg",
    "precoMedio": 108.43,
    "precoMinimo": 104.99,
    "precoMaximo": 110,
    "desvioPadrao": 1.9986710862748558,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VARGINHA",
    "municipioIbge": 3170701,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 112.14,
    "precoMinimo": 95,
    "precoMaximo": 120,
    "desvioPadrao": 9.511897312113419,
    "coeficienteVariacao": 0.085
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "LPG_P13",
    "postosPesquisados": 20,
    "unidade": "R$/13kg",
    "precoMedio": 118.24,
    "precoMinimo": 95,
    "precoMaximo": 135,
    "desvioPadrao": 12.208884125052025,
    "coeficienteVariacao": 0.103
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VARZEA PAULISTA",
    "municipioIbge": 3556503,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 112.49,
    "precoMinimo": 99.99,
    "precoMaximo": 130,
    "desvioPadrao": 10.842048545670078,
    "coeficienteVariacao": 0.096
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 114.7,
    "precoMinimo": 106,
    "precoMaximo": 125,
    "desvioPadrao": 8.330466173430311,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VICOSA",
    "municipioIbge": 3171303,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 120.71,
    "precoMinimo": 115,
    "precoMaximo": 125,
    "desvioPadrao": 3.4503277967117714,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "VIDEIRA",
    "municipioIbge": 4219309,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 123.66,
    "precoMinimo": 110,
    "precoMaximo": 133,
    "desvioPadrao": 7.890586163270762,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VILA VELHA",
    "municipioIbge": 3205200,
    "produto": "LPG_P13",
    "postosPesquisados": 13,
    "unidade": "R$/13kg",
    "precoMedio": 102.92,
    "precoMinimo": 100,
    "precoMaximo": 115,
    "desvioPadrao": 5.0242999257199745,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "VILHENA",
    "municipioIbge": 1100304,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 129.49,
    "precoMinimo": 117.5,
    "precoMaximo": 136,
    "desvioPadrao": 5.766138015955534,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VITORIA",
    "municipioIbge": 3205309,
    "produto": "LPG_P13",
    "postosPesquisados": 6,
    "unidade": "R$/13kg",
    "precoMedio": 101.66,
    "precoMinimo": 96.99,
    "precoMaximo": 115,
    "desvioPadrao": 6.654723886082729,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 120.5,
    "precoMinimo": 110,
    "precoMaximo": 138,
    "desvioPadrao": 9.396047801374484,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "VITORIA DE SANTO ANTAO",
    "municipioIbge": 2616407,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 96.71,
    "precoMinimo": 95,
    "precoMaximo": 100,
    "desvioPadrao": 2.3580692263354943,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "LPG_P13",
    "postosPesquisados": 8,
    "unidade": "R$/13kg",
    "precoMedio": 103.84,
    "precoMinimo": 94.99,
    "precoMaximo": 109.99,
    "desvioPadrao": 4.98199830819493,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTORANTIM",
    "municipioIbge": 3557006,
    "produto": "LPG_P13",
    "postosPesquisados": 7,
    "unidade": "R$/13kg",
    "precoMedio": 117.42,
    "precoMinimo": 114,
    "precoMaximo": 124.99,
    "desvioPadrao": 4.539826931880616,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTUPORANGA",
    "municipioIbge": 3557105,
    "produto": "LPG_P13",
    "postosPesquisados": 10,
    "unidade": "R$/13kg",
    "precoMedio": 114.29,
    "precoMinimo": 104.99,
    "precoMaximo": 120,
    "desvioPadrao": 4.740910484519005,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "XANXERE",
    "municipioIbge": 4219507,
    "produto": "LPG_P13",
    "postosPesquisados": 5,
    "unidade": "R$/13kg",
    "precoMedio": 115.96,
    "precoMinimo": 110,
    "precoMaximo": 119.9,
    "desvioPadrao": 4.135577347843951,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.34,
    "precoMinimo": 4.3,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.06363961030678929,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.59,
    "precoMinimo": 5.59,
    "precoMaximo": 5.59,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.89,
    "precoMinimo": 5.89,
    "precoMaximo": 5.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 4.83,
    "precoMinimo": 4.83,
    "precoMaximo": 4.83,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 3.89,
    "precoMinimo": 3.89,
    "precoMaximo": 3.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.98,
    "precoMinimo": 4.98,
    "precoMaximo": 4.98,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.7,
    "precoMinimo": 4.7,
    "precoMaximo": 4.7,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 6.08,
    "precoMinimo": 5.89,
    "precoMaximo": 6.28,
    "desvioPadrao": 0.27577164466275356,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.96,
    "precoMinimo": 4.89,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.05,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 4.54,
    "precoMinimo": 4.39,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.2179449471770337,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.96,
    "precoMinimo": 4.89,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.05,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 5.27,
    "precoMinimo": 4.95,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.28728615235220323,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "BELO JARDIM",
    "municipioIbge": 2601706,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 4.95,
    "precoMinimo": 4.87,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.06928203230275509,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CABO DE SANTO AGOSTINHO",
    "municipioIbge": 2602902,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CABO FRIO",
    "municipioIbge": 3300704,
    "produto": "CNG",
    "postosPesquisados": 6,
    "unidade": "R$/m³",
    "precoMedio": 4.88,
    "precoMinimo": 4.85,
    "precoMaximo": 4.95,
    "desvioPadrao": 0.033862466931200784,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.49,
    "precoMinimo": 5.49,
    "precoMaximo": 5.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.59,
    "precoMinimo": 4.59,
    "precoMaximo": 4.59,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 5.67,
    "precoMinimo": 5.67,
    "precoMaximo": 5.67,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 5.16,
    "precoMinimo": 4.99,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.17078251276599332,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.59,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 5.27,
    "precoMinimo": 5.27,
    "precoMaximo": 5.27,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.26,
    "precoMinimo": 4.19,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.04856267428111155,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CAUCAIA",
    "municipioIbge": 2303709,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.15,
    "precoMinimo": 5.15,
    "precoMaximo": 5.15,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.79,
    "precoMinimo": 4.79,
    "precoMaximo": 4.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.39,
    "precoMinimo": 4.39,
    "precoMaximo": 4.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.93,
    "precoMinimo": 4.89,
    "precoMaximo": 4.97,
    "desvioPadrao": 0.05656854249492381,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.74,
    "precoMinimo": 4.59,
    "precoMaximo": 4.89,
    "desvioPadrao": 0.21213203435596426,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.47,
    "precoMinimo": 5.46,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.021213203435596427,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.49,
    "precoMinimo": 4.49,
    "precoMaximo": 4.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.59,
    "precoMinimo": 4.49,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "FORTALEZA",
    "municipioIbge": 2304400,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 5.55,
    "precoMinimo": 5.55,
    "precoMaximo": 5.55,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.89,
    "precoMinimo": 4.89,
    "precoMaximo": 4.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.39,
    "precoMinimo": 5.39,
    "precoMaximo": 5.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 5.06,
    "precoMinimo": 4.99,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.15,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.09,
    "precoMinimo": 5.09,
    "precoMaximo": 5.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "IGARASSU",
    "municipioIbge": 2606804,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "CNG",
    "postosPesquisados": 9,
    "unidade": "R$/m³",
    "precoMedio": 4.36,
    "precoMinimo": 4.08,
    "precoMaximo": 4.49,
    "desvioPadrao": 0.13423652425642002,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.8,
    "precoMinimo": 4.8,
    "precoMaximo": 4.8,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.19,
    "precoMinimo": 4.99,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.282842712474619,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 6.49,
    "precoMinimo": 6.49,
    "precoMaximo": 6.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.19,
    "precoMinimo": 5.19,
    "precoMaximo": 5.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.18,
    "precoMinimo": 4.17,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.014142135623730952,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "JABOATAO DOS GUARARAPES",
    "municipioIbge": 2607901,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.39,
    "precoMinimo": 5.39,
    "precoMaximo": 5.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 4.72,
    "precoMinimo": 4.59,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.2309401076758503,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.79,
    "precoMinimo": 4.79,
    "precoMaximo": 4.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 5.02,
    "precoMinimo": 4.39,
    "precoMaximo": 5.39,
    "desvioPadrao": 0.5507570547286103,
    "coeficienteVariacao": 0.11
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.35,
    "precoMinimo": 5.35,
    "precoMaximo": 5.35,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.06,
    "precoMinimo": 4.96,
    "precoMaximo": 5.16,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.65,
    "precoMinimo": 5.65,
    "precoMaximo": 5.65,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.83,
    "precoMinimo": 4.79,
    "precoMaximo": 4.85,
    "desvioPadrao": 0.03,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "MACEIO",
    "municipioIbge": 2704302,
    "produto": "CNG",
    "postosPesquisados": 9,
    "unidade": "R$/m³",
    "precoMedio": 4.39,
    "precoMinimo": 4.39,
    "precoMaximo": 4.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.79,
    "precoMinimo": 5.79,
    "precoMaximo": 5.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.49,
    "precoMinimo": 5.49,
    "precoMaximo": 5.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 6.49,
    "precoMinimo": 6.49,
    "precoMaximo": 6.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.09,
    "precoMinimo": 5.09,
    "precoMaximo": 5.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 5.01,
    "precoMinimo": 4.98,
    "precoMaximo": 5.09,
    "desvioPadrao": 0.06350852961085883,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "CNG",
    "postosPesquisados": 8,
    "unidade": "R$/m³",
    "precoMedio": 4.08,
    "precoMinimo": 3.97,
    "precoMaximo": 4.39,
    "desvioPadrao": 0.16228282190581444,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.83,
    "precoMinimo": 4.83,
    "precoMaximo": 4.83,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "OLINDA",
    "municipioIbge": 2609600,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.49,
    "precoMinimo": 5.49,
    "precoMaximo": 5.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.94,
    "precoMinimo": 4.94,
    "precoMaximo": 4.94,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 6.15,
    "precoMinimo": 6.15,
    "precoMaximo": 6.15,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PAULISTA",
    "municipioIbge": 2610707,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 5.19,
    "precoMinimo": 5.19,
    "precoMaximo": 5.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.85,
    "precoMinimo": 4.85,
    "precoMaximo": 4.85,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.49,
    "precoMinimo": 4.39,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "CNG",
    "postosPesquisados": 7,
    "unidade": "R$/m³",
    "precoMedio": 4.7,
    "precoMinimo": 4.59,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.13758114488755874,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.7,
    "precoMinimo": 4.7,
    "precoMaximo": 4.7,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "RECIFE",
    "municipioIbge": 2611606,
    "produto": "CNG",
    "postosPesquisados": 10,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "CNG",
    "postosPesquisados": 6,
    "unidade": "R$/m³",
    "precoMedio": 4.14,
    "precoMinimo": 3.99,
    "precoMaximo": 4.29,
    "desvioPadrao": 0.12027745701779144,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.19,
    "precoMinimo": 4.19,
    "precoMaximo": 4.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "CNG",
    "postosPesquisados": 43,
    "unidade": "R$/m³",
    "precoMedio": 4.31,
    "precoMinimo": 3.99,
    "precoMaximo": 4.59,
    "desvioPadrao": 0.19282650181099187,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "RIO LARGO",
    "municipioIbge": 2707701,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.39,
    "precoMinimo": 4.39,
    "precoMaximo": 4.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.96,
    "precoMinimo": 5.96,
    "precoMaximo": 5.96,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SALVADOR",
    "municipioIbge": 2927408,
    "produto": "CNG",
    "postosPesquisados": 5,
    "unidade": "R$/m³",
    "precoMedio": 4.05,
    "precoMinimo": 3.99,
    "precoMaximo": 4.19,
    "desvioPadrao": 0.08944271909999159,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 5.39,
    "precoMinimo": 5.19,
    "precoMaximo": 5.79,
    "desvioPadrao": 0.282842712474619,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.98,
    "precoMinimo": 5.98,
    "precoMaximo": 5.98,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "CNG",
    "postosPesquisados": 6,
    "unidade": "R$/m³",
    "precoMedio": 4.17,
    "precoMinimo": 3.99,
    "precoMaximo": 4.48,
    "desvioPadrao": 0.1908315138195646,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "SAO JOSE",
    "municipioIbge": 4216602,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.56,
    "precoMinimo": 4.49,
    "precoMaximo": 4.79,
    "desvioPadrao": 0.15,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.64,
    "precoMinimo": 4.59,
    "precoMaximo": 4.69,
    "desvioPadrao": 0.07071067811865475,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.29,
    "precoMinimo": 4.29,
    "precoMaximo": 4.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.94,
    "precoMinimo": 4.89,
    "precoMaximo": 4.99,
    "desvioPadrao": 0.07071067811865475,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "CNG",
    "postosPesquisados": 11,
    "unidade": "R$/m³",
    "precoMedio": 4.79,
    "precoMinimo": 4.47,
    "precoMaximo": 5.29,
    "desvioPadrao": 0.27054826489253936,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 5.71,
    "precoMinimo": 4.99,
    "precoMaximo": 6.17,
    "desvioPadrao": 0.5062278801751902,
    "coeficienteVariacao": 0.089
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.29,
    "precoMinimo": 4.29,
    "precoMaximo": 4.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.19,
    "precoMinimo": 5.19,
    "precoMaximo": 5.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.09,
    "precoMinimo": 5.09,
    "precoMaximo": 5.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.34,
    "precoMinimo": 5.19,
    "precoMaximo": 5.49,
    "desvioPadrao": 0.21213203435596426,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 5.49,
    "precoMinimo": 5.49,
    "precoMaximo": 5.49,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.45,
    "precoMinimo": 5.45,
    "precoMaximo": 5.45,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "CNG",
    "postosPesquisados": 3,
    "unidade": "R$/m³",
    "precoMedio": 5.95,
    "precoMinimo": 5.89,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "CNG",
    "postosPesquisados": 6,
    "unidade": "R$/m³",
    "precoMedio": 4.94,
    "precoMinimo": 4.89,
    "precoMaximo": 4.96,
    "desvioPadrao": 0.028577380332470412,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 5.98,
    "precoMinimo": 5.98,
    "precoMaximo": 5.98,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 3.99,
    "precoMinimo": 3.99,
    "precoMaximo": 3.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.99,
    "precoMinimo": 4.99,
    "precoMaximo": 4.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VITORIA",
    "municipioIbge": 3205309,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 4.29,
    "precoMinimo": 4.29,
    "precoMaximo": 4.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "CNG",
    "postosPesquisados": 1,
    "unidade": "R$/m³",
    "precoMedio": 6.19,
    "precoMinimo": 6.19,
    "precoMaximo": 6.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "VITORIA DE SANTO ANTAO",
    "municipioIbge": 2616407,
    "produto": "CNG",
    "postosPesquisados": 2,
    "unidade": "R$/m³",
    "precoMedio": 4.69,
    "precoMinimo": 4.69,
    "precoMaximo": 4.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "CNG",
    "postosPesquisados": 4,
    "unidade": "R$/m³",
    "precoMedio": 4.89,
    "precoMinimo": 4.89,
    "precoMaximo": 4.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ABAETETUBA",
    "municipioIbge": 1500107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.63,
    "precoMinimo": 7.63,
    "precoMaximo": 7.63,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ADAMANTINA",
    "municipioIbge": 3500105,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.17,
    "precoMinimo": 5.99,
    "precoMaximo": 6.65,
    "desvioPadrao": 0.31784430150625637,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "AGUAS LINDAS DE GOIAS",
    "municipioIbge": 5200258,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.34469793539658267,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.25,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.5145353891295201,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALEGRETE",
    "municipioIbge": 4300406,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.09,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3209361307176243,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALENQUER",
    "municipioIbge": 1500404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.24,
    "precoMinimo": 6.99,
    "precoMaximo": 7.5,
    "desvioPadrao": 0.29444863728670917,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ALFENAS",
    "municipioIbge": 3101607,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.29,
    "precoMaximo": 6.72,
    "desvioPadrao": 0.30405591591021547,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "ALTA FLORESTA",
    "municipioIbge": 5100250,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.21,
    "precoMinimo": 7.05,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.1050714042925096,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALTAMIRA",
    "municipioIbge": 1500602,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.64,
    "precoMinimo": 6.99,
    "precoMaximo": 8.33,
    "desvioPadrao": 0.5138266028319065,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALVORADA",
    "municipioIbge": 4300604,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.18,
    "precoMinimo": 5.89,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.24540782383616053,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.26758176320519306,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ANAPOLIS",
    "municipioIbge": 5201108,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.08,
    "precoMinimo": 5.77,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3408078637590395,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.35,
    "precoMinimo": 7.29,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "APARECIDA DE GOIANIA",
    "municipioIbge": 5201405,
    "produto": "DIESEL_S500",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.19,
    "precoMinimo": 5.79,
    "precoMaximo": 7.95,
    "desvioPadrao": 0.5793187865159013,
    "coeficienteVariacao": 0.094
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "APUCARANA",
    "municipioIbge": 4101408,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.14719601443879746,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.89,
    "precoMaximo": 6.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARACATUBA",
    "municipioIbge": 3502804,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.98,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.3916886518652283,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "ARACRUZ",
    "municipioIbge": 3200607,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "ARAGUAINA",
    "municipioIbge": 1702109,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.25,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.22076166851542475,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.29,
    "precoMinimo": 7.29,
    "precoMaximo": 7.29,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAPONGAS",
    "municipioIbge": 4101507,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.537047483934149,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.4,
    "precoMinimo": 6.15,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.17,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3907258203224695,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAS",
    "municipioIbge": 3503307,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.07,
    "precoMaximo": 6.9,
    "desvioPadrao": 0.27033488931499833,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.87,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.06928203230275509,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAUCARIA",
    "municipioIbge": 4101804,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.04,
    "precoMinimo": 5.69,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3803682426281143,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ARAXA",
    "municipioIbge": 3104007,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 6.19,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.07559289460184546,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "ARIQUEMES",
    "municipioIbge": 1100023,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.23,
    "precoMinimo": 6.69,
    "precoMaximo": 7.88,
    "desvioPadrao": 0.5271215636427169,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ATIBAIA",
    "municipioIbge": 3504107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 5.99,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.459813626840888,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AVARE",
    "municipioIbge": 3504503,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.68,
    "precoMaximo": 6.68,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BACABAL",
    "municipioIbge": 2101202,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.7,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.03947573094109004,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BAGE",
    "municipioIbge": 4301602,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.19,
    "precoMaximo": 7.56,
    "desvioPadrao": 0.13501322686526468,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BALSAS",
    "municipioIbge": 2101400,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 6.79,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.3410506642062958,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.61,
    "precoMinimo": 7.59,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.028867513459481287,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.23,
    "precoMinimo": 6.89,
    "precoMaximo": 8.29,
    "desvioPadrao": 0.47662004434000327,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "BARREIRAS",
    "municipioIbge": 2903201,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.41,
    "precoMinimo": 6.99,
    "precoMaximo": 8.09,
    "desvioPadrao": 0.36444021000250054,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARRETOS",
    "municipioIbge": 3505500,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.39,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.6027713773341709,
    "coeficienteVariacao": 0.087
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARUERI",
    "municipioIbge": 3505708,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 6.14,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.2843120351538663,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BAURU",
    "municipioIbge": 3506003,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.37,
    "precoMinimo": 6.19,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.21266170318136737,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.89,
    "precoMaximo": 6.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BEBEDOURO",
    "municipioIbge": 3506102,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 5.85,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.4732194698727713,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.09,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.357603131977336,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 5.99,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.2058663459163551,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BETIM",
    "municipioIbge": 3106705,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 6.19,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.14175767384955953,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BIRIGUI",
    "municipioIbge": 3506508,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.96,
    "precoMinimo": 5.69,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.27371518043396864,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.69,
    "precoMaximo": 6.72,
    "desvioPadrao": 0.021213203435596427,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RR",
    "estadoNome": "RORAIMA",
    "municipioNome": "BOA VISTA",
    "municipioIbge": 1400100,
    "produto": "DIESEL_S500",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 7.2,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.07637626158259733,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BOM DESPACHO",
    "municipioIbge": 3107406,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 6.09,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.19944924166313593,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BRAGANCA",
    "municipioIbge": 1501709,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.4,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.035355339059327376,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BRAGANCA PAULISTA",
    "municipioIbge": 3507605,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.09,
    "precoMaximo": 7.88,
    "desvioPadrao": 0.7067389900097489,
    "coeficienteVariacao": 0.106
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "DF",
    "estadoNome": "DISTRITO FEDERAL",
    "municipioNome": "BRASILIA",
    "municipioIbge": 5300108,
    "produto": "DIESEL_S500",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.54,
    "precoMaximo": 7.32,
    "desvioPadrao": 0.20129389153481725,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.48,
    "precoMaximo": 6.68,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.15,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CABO FRIO",
    "municipioIbge": 3300704,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.29,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.15275252316519466,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CACADOR",
    "municipioIbge": 4203006,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.59,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.08944271909999159,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 5.99,
    "precoMaximo": 8.19,
    "desvioPadrao": 0.9591663046625439,
    "coeficienteVariacao": 0.146
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CACERES",
    "municipioIbge": 5102504,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.59,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRA DO SUL",
    "municipioIbge": 4303004,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.16,
    "precoMinimo": 5.85,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.27132391466044176,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRINHA",
    "municipioIbge": 4303103,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.15,
    "precoMinimo": 5.89,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.2309401076758503,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.31,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.3333599989334187,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "CACOAL",
    "municipioIbge": 1100049,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.59,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.30162338547709905,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "CAETITE",
    "municipioIbge": 2905206,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.88,
    "precoMinimo": 7.88,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.004082482904638631,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "CAICO",
    "municipioIbge": 2402006,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.57,
    "precoMinimo": 7.49,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.040824829046386304,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CALDAS NOVAS",
    "municipioIbge": 5204508,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.24,
    "precoMaximo": 6.77,
    "desvioPadrao": 0.18181492421324127,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMBE",
    "municipioIbge": 4103701,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.3346640106136302,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "DIESEL_S500",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.39,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.20402020102000298,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 5.99,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.5521674464226309,
    "coeficienteVariacao": 0.082
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CAMPO BELO",
    "municipioIbge": 3111200,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.19,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.40414518843273806,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "DIESEL_S500",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 6.09,
    "precoMaximo": 6.77,
    "desvioPadrao": 0.1788515551732184,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO LARGO",
    "municipioIbge": 4104204,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.06,
    "precoMinimo": 5.99,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.10430723848324239,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO MOURAO",
    "municipioIbge": 4104303,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.92,
    "precoMinimo": 5.69,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.2081665999466133,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.19734909846935372,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.22,
    "precoMinimo": 5.85,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.45838848153067724,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CARAGUATATUBA",
    "municipioIbge": 3510500,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.79,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.25926177247459115,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CARATINGA",
    "municipioIbge": 3113404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.49,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.59,
    "precoMaximo": 6.76,
    "desvioPadrao": 0.07135591542869216,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.87,
    "precoMaximo": 6.87,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASCAVEL",
    "municipioIbge": 4104808,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.13,
    "precoMinimo": 5.79,
    "precoMaximo": 6.38,
    "desvioPadrao": 0.21182539979898538,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CASTANHAL",
    "municipioIbge": 1502400,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.69,
    "precoMaximo": 7.28,
    "desvioPadrao": 0.25610544703305316,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASTRO",
    "municipioIbge": 4104907,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 5.99,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.26850822457918616,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CATALAO",
    "municipioIbge": 5205109,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.22730302828309762,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.27535330839567634,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CHAPECO",
    "municipioIbge": 4204202,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.29,
    "precoMaximo": 6.68,
    "desvioPadrao": 0.15989579940281942,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CIANORTE",
    "municipioIbge": 4105508,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.38,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.0608276253029822,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "CODO",
    "municipioIbge": 2103307,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.41,
    "precoMinimo": 7.28,
    "precoMaximo": 7.5,
    "desvioPadrao": 0.1067707825203131,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "COLATINA",
    "municipioIbge": 3201506,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.0906642156531451,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.19,
    "precoMinimo": 5.87,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.37015440793577714,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CONCEICAO DO ARAGUAIA",
    "municipioIbge": 1502707,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.24,
    "precoMinimo": 7.09,
    "precoMaximo": 7.65,
    "desvioPadrao": 0.27147743920996453,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CONCORDIA",
    "municipioIbge": 4204301,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.53,
    "precoMaximo": 7.34,
    "desvioPadrao": 0.2608593855846844,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONGONHAS",
    "municipioIbge": 3118007,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 6.05,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3484250278036869,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONSELHEIRO LAFAIETE",
    "municipioIbge": 3118304,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.29,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 6.15,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.04677368680976279,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CORNELIO PROCOPIO",
    "municipioIbge": 4106407,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.27018512172212594,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CORONEL FABRICIANO",
    "municipioIbge": 3119401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.29,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.09521904571390467,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CORUMBA",
    "municipioIbge": 5003207,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.48,
    "precoMinimo": 7.39,
    "precoMaximo": 7.58,
    "desvioPadrao": 0.13435028842544403,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COSMOPOLIS",
    "municipioIbge": 3512803,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.19,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.43204937989385733,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COTIA",
    "municipioIbge": 3513009,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 6.23,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.314928563328257,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CRATEUS",
    "municipioIbge": 2304103,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.2,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.34146742157927745,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.09,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.26903708365381973,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CRUZ ALTA",
    "municipioIbge": 4306106,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.6363961030678927,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.97,
    "precoMinimo": 6.61,
    "precoMaximo": 7.34,
    "desvioPadrao": 0.5161879502661797,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CUBATAO",
    "municipioIbge": 3513504,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.38,
    "precoMinimo": 7.38,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.005773502691896258,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CUIABA",
    "municipioIbge": 5103403,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.38279672586548247,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CURITIBA",
    "municipioIbge": 4106902,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.84,
    "precoMinimo": 5.59,
    "precoMaximo": 5.99,
    "desvioPadrao": 0.19148542155126763,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CURVELO",
    "municipioIbge": 3120904,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.27,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.1883259585576738,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "DELMIRO GOUVEIA",
    "municipioIbge": 2702405,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.73,
    "precoMinimo": 7.29,
    "precoMaximo": 7.96,
    "desvioPadrao": 0.38682468035704926,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "DIADEMA",
    "municipioIbge": 3513801,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 6.39,
    "precoMaximo": 7.89,
    "desvioPadrao": 1.0606601717798214,
    "coeficienteVariacao": 0.149
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "DIVINOPOLIS",
    "municipioIbge": 3122306,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 6.22,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.12020815280171308,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "DOURADOS",
    "municipioIbge": 5003702,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 6.04,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.3520692797984195,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "EMBU DAS ARTES",
    "municipioIbge": 3515004,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 5.98,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.5208838642154314,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ERECHIM",
    "municipioIbge": 4307005,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 5.99,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.3070423423568808,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.32710854467592254,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "EUNAPOLIS",
    "municipioIbge": 2910727,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.6,
    "precoMinimo": 7.49,
    "precoMaximo": 7.67,
    "desvioPadrao": 0.06906518659932803,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.18,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.480029760982141,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.59,
    "precoMaximo": 6.59,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FORMIGA",
    "municipioIbge": 3126109,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.19,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.574456264653803,
    "coeficienteVariacao": 0.088
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "FORMOSA",
    "municipioIbge": 5208004,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.12,
    "precoMinimo": 6.09,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "FRANCA",
    "municipioIbge": 3516200,
    "produto": "DIESEL_S500",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 5.98,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2453754081180323,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "FRANCISCO BELTRAO",
    "municipioIbge": 4108403,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.09,
    "precoMinimo": 6.09,
    "precoMaximo": 6.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FRUTAL",
    "municipioIbge": 3127107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.72,
    "precoMaximo": 6.58,
    "desvioPadrao": 0.37625789028271556,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GARCA",
    "municipioIbge": 3516705,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.09,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.2217355782608345,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIANIA",
    "municipioIbge": 5208707,
    "produto": "DIESEL_S500",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 5.63,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.5251158602314985,
    "coeficienteVariacao": 0.084
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIATUBA",
    "municipioIbge": 5209101,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.74,
    "precoMinimo": 5.69,
    "precoMaximo": 5.79,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GOVERNADOR VALADARES",
    "municipioIbge": 3127701,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.55,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.09899494936611666,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAMADO",
    "municipioIbge": 4309100,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 7.39,
    "precoMaximo": 7.39,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.22,
    "precoMinimo": 5.89,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.4163331998932266,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GUAIBA",
    "municipioIbge": 4309308,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.16,
    "precoMinimo": 6.09,
    "precoMaximo": 6.25,
    "desvioPadrao": 0.06377042156569664,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "GUANAMBI",
    "municipioIbge": 2911709,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.41,
    "precoMinimo": 6.95,
    "precoMaximo": 7.87,
    "desvioPadrao": 0.3322900339562815,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "GUARAPARI",
    "municipioIbge": 3202405,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 7.09,
    "precoMaximo": 7.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "GUARAPUAVA",
    "municipioIbge": 4109401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 5.96,
    "precoMinimo": 5.74,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.24784787961282106,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 5.99,
    "precoMaximo": 7.37,
    "desvioPadrao": 0.6867313885355758,
    "coeficienteVariacao": 0.105
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARUJA",
    "municipioIbge": 3518701,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.4,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.410731055558257,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.36,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.23408382706893294,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GUAXUPE",
    "municipioIbge": 3128709,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 6.09,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.3947573094109004,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "GURUPI",
    "municipioIbge": 1709500,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.59,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.3484660262185848,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 6.09,
    "precoMaximo": 6.47,
    "desvioPadrao": 0.12967909109284606,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "IBITINGA",
    "municipioIbge": 3519600,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 5.92,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.31920474098400653,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ICO",
    "municipioIbge": 2305407,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.55,
    "precoMinimo": 7.49,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "IGUATU",
    "municipioIbge": 2305506,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.24,
    "precoMinimo": 7.09,
    "precoMaximo": 7.56,
    "desvioPadrao": 0.2713546265191241,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "IJUI",
    "municipioIbge": 4310207,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.43,
    "precoMinimo": 5.94,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.30737237640649784,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ILHEUS",
    "municipioIbge": 2913606,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.82,
    "precoMinimo": 7.67,
    "precoMaximo": 7.97,
    "desvioPadrao": 0.21213203435596426,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "IMPERATRIZ",
    "municipioIbge": 2105302,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.06900655593423542,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "INDAIATUBA",
    "municipioIbge": 3520509,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 5.97,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.328146308831899,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "IPATINGA",
    "municipioIbge": 3131307,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.36,
    "precoMaximo": 6.36,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IPIRA",
    "municipioIbge": 2914000,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.71,
    "precoMinimo": 7.29,
    "precoMaximo": 7.92,
    "desvioPadrao": 0.28925190866555517,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IRECE",
    "municipioIbge": 2914604,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.93,
    "precoMinimo": 7.38,
    "precoMaximo": 8.48,
    "desvioPadrao": 0.32730501283752356,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ITABAIANA",
    "municipioIbge": 2802908,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.65,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.13880441875771343,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.49,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.45694443238288207,
    "coeficienteVariacao": 0.067
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.79,
    "precoMaximo": 6.83,
    "desvioPadrao": 0.028284271247461905,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.19,
    "precoMaximo": 6.65,
    "desvioPadrao": 0.1981665965797465,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAJUBA",
    "municipioIbge": 3132404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.63,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.11313708498984762,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITAMARAJU",
    "municipioIbge": 2915601,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.67,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.04949747468305833,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPECERICA DA SERRA",
    "municipioIbge": 3522208,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.54,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.2182506204649447,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.89,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.24832774042918904,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPIRA",
    "municipioIbge": 3522604,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.17,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.31667017541915754,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPOLIS",
    "municipioIbge": 3522703,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.59,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.09358596760910971,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 5.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.5737304826019503,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.97,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.3142034524377629,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAUNA",
    "municipioIbge": 3133808,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 6.29,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.74,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.35,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITUIUTABA",
    "municipioIbge": 3134202,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.22,
    "precoMinimo": 5.98,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.15905973720586866,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ITUMBIARA",
    "municipioIbge": 5211503,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.9,
    "precoMinimo": 5.79,
    "precoMaximo": 6.27,
    "desvioPadrao": 0.18618986725025258,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JABOTICABAL",
    "municipioIbge": 3524303,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.19,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.30331501776206204,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 6.29,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JACOBINA",
    "municipioIbge": 2917508,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 7.04,
    "precoMaximo": 7.63,
    "desvioPadrao": 0.22098013988189577,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JAGUAQUARA",
    "municipioIbge": 2917607,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.11,
    "precoMinimo": 6.49,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.4655498541151814,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JALES",
    "municipioIbge": 3524808,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 5.99,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.29840847683606286,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANAUBA",
    "municipioIbge": 3135100,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.75,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.22366003112717642,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANUARIA",
    "municipioIbge": 3135209,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.79,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.10606601717798213,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JAU",
    "municipioIbge": 3525300,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.49,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JEQUIE",
    "municipioIbge": 2918001,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.4,
    "precoMinimo": 6.89,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.4811444689487763,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "JI-PARANA",
    "municipioIbge": 1100122,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.46,
    "precoMinimo": 6.57,
    "precoMaximo": 7.94,
    "desvioPadrao": 0.5163590482083825,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO MONLEVADE",
    "municipioIbge": 3136207,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.39,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.12261049438499681,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.28,
    "precoMaximo": 7.07,
    "desvioPadrao": 0.35095583767762006,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO PINHEIRO",
    "municipioIbge": 3136306,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.1,
    "precoMinimo": 5.94,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.20499709637897198,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.49,
    "precoMaximo": 7.02,
    "desvioPadrao": 0.22461077445216204,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JUAZEIRO",
    "municipioIbge": 2918407,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.95,
    "precoMaximo": 6.95,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "JUAZEIRO DO NORTE",
    "municipioIbge": 2307304,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.75,
    "precoMaximo": 7.13,
    "desvioPadrao": 0.1527088733505686,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.09,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2514245129542577,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.09,
    "precoMaximo": 6.9,
    "desvioPadrao": 0.36560908085002486,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.65,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1267543556122103,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 5.98,
    "precoMaximo": 7.47,
    "desvioPadrao": 0.697949377342894,
    "coeficienteVariacao": 0.108
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 5.94,
    "precoMinimo": 5.69,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.16030179870065922,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LEME",
    "municipioIbge": 3526704,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.13,
    "precoMinimo": 5.79,
    "precoMaximo": 6.55,
    "desvioPadrao": 0.31368774282716244,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LEOPOLDINA",
    "municipioIbge": 3138401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.39,
    "precoMaximo": 6.75,
    "desvioPadrao": 0.15874507866387544,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LIMEIRA",
    "municipioIbge": 3526902,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 5.89,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.35662616592479895,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "LIMOEIRO DO NORTE",
    "municipioIbge": 2307601,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.52,
    "precoMinimo": 7.44,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.07637626158259733,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LINS",
    "municipioIbge": 3527108,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.27,
    "precoMaximo": 6.53,
    "desvioPadrao": 0.12793227374930324,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "LIVRAMENTO DE NOSSA SENHORA",
    "municipioIbge": 2919504,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.75,
    "precoMinimo": 7.69,
    "precoMaximo": 7.8,
    "desvioPadrao": 0.056745043836444437,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "LONDRINA",
    "municipioIbge": 4113700,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.99,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3023715784073818,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LORENA",
    "municipioIbge": 3527207,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.19,
    "precoMinimo": 6.19,
    "precoMaximo": 6.19,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.5,
    "precoMinimo": 7.39,
    "precoMaximo": 7.65,
    "desvioPadrao": 0.10719919153924001,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANACAPURU",
    "municipioIbge": 1302504,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "DIESEL_S500",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.11,
    "precoMinimo": 6.99,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.15447859516333118,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "MARABA",
    "municipioIbge": 1504208,
    "produto": "DIESEL_S500",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.19,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.3891389095285781,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.78,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.06350852961085883,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MARILIA",
    "municipioIbge": 3529005,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 5.79,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.45519531827313187,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "MARINGA",
    "municipioIbge": 4115200,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 5.69,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3840572873934304,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MATAO",
    "municipioIbge": 3529302,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 5.95,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.7381056834898374,
    "coeficienteVariacao": 0.108
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 5.89,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.6849574196011506,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "MINEIROS",
    "municipioIbge": 5213103,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 5.96,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.24443326092743406,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOCOCA",
    "municipioIbge": 3530508,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 5.79,
    "precoMaximo": 7.98,
    "desvioPadrao": 0.7148592935143318,
    "coeficienteVariacao": 0.107
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.29,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.40987803063838396,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI GUACU",
    "municipioIbge": 3530706,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.09,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.3593976442141304,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.12,
    "precoMinimo": 5.77,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.31855925665408,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MONTE ALTO",
    "municipioIbge": 3531308,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.29,
    "precoMaximo": 6.68,
    "desvioPadrao": 0.16593171286204858,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTE CARMELO",
    "municipioIbge": 3143104,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.34,
    "precoMaximo": 6.37,
    "desvioPadrao": 0.021213203435596427,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTES CLAROS",
    "municipioIbge": 3143302,
    "produto": "DIESEL_S500",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.29,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.09849780800514386,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.06,
    "precoMinimo": 6.79,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.21990257583107767,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MURIAE",
    "municipioIbge": 3143906,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.69,
    "precoMaximo": 6.78,
    "desvioPadrao": 0.045,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.76,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.224825858536483,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.89,
    "precoMaximo": 6.89,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.66,
    "precoMaximo": 6.87,
    "desvioPadrao": 0.11590225767142474,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NOVA FRIBURGO",
    "municipioIbge": 3303401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.69,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.5611416933360058,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "NOVO HAMBURGO",
    "municipioIbge": 4313409,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 5.67,
    "precoMinimo": 5.59,
    "precoMaximo": 5.79,
    "desvioPadrao": 0.08366600265340755,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OLIMPIA",
    "municipioIbge": 3533908,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.16,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.6569554598224115,
    "coeficienteVariacao": 0.1
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.31091263510296047,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "OSORIO",
    "municipioIbge": 4313508,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.89,
    "precoMinimo": 5.59,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.264575131106459,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OURINHOS",
    "municipioIbge": 3534708,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.06,
    "precoMinimo": 6.06,
    "precoMaximo": 6.06,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "OURO PRETO",
    "municipioIbge": 3146107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.76,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.16194134740701646,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.25,
    "precoMaximo": 7.25,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARA DE MINAS",
    "municipioIbge": 3147105,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 6.14,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.2157489722979441,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARACATU",
    "municipioIbge": 3147006,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.87,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.24070036698490235,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAGOMINAS",
    "municipioIbge": 1505502,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.14,
    "precoMaximo": 7.1,
    "desvioPadrao": 0.5253887449625595,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PARAGUACU PAULISTA",
    "municipioIbge": 3535507,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.15,
    "precoMinimo": 5.49,
    "precoMaximo": 6.87,
    "desvioPadrao": 0.6919537556802478,
    "coeficienteVariacao": 0.113
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PARAISO DO TOCANTINS",
    "municipioIbge": 1716109,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.23,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.24709647238814778,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAGUA",
    "municipioIbge": 4118204,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.09,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.34455768747772847,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAVAI",
    "municipioIbge": 4118402,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.32,
    "precoMinimo": 5.63,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.624686588085044,
    "coeficienteVariacao": 0.099
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAUAPEBAS",
    "municipioIbge": 1505536,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.34,
    "precoMinimo": 6.89,
    "precoMaximo": 8.09,
    "desvioPadrao": 0.6515622252197663,
    "coeficienteVariacao": 0.089
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PARNAIBA",
    "municipioIbge": 2207702,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.35,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2433105012119288,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "PARNAMIRIM",
    "municipioIbge": 2403251,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PASSO FUNDO",
    "municipioIbge": 4314100,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.36,
    "precoMinimo": 5.99,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.25,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PASSOS",
    "municipioIbge": 3147907,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.16,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.28359616660717707,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PATO BRANCO",
    "municipioIbge": 4118501,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.47,
    "precoMinimo": 6.45,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.028284271247461905,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.79,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.03579039509354962,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PATROCINIO",
    "municipioIbge": 3148103,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.4,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.30858837585736393,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PAULINIA",
    "municipioIbge": 3536505,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.47258156262526085,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PAULO AFONSO",
    "municipioIbge": 2924009,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 7.15,
    "precoMaximo": 7.15,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PELOTAS",
    "municipioIbge": 4314407,
    "produto": "DIESEL_S500",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.09,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2962185925046815,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PETROLINA",
    "municipioIbge": 2611101,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.45,
    "precoMinimo": 7.27,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.16761634196950517,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.79,
    "precoMaximo": 6.84,
    "desvioPadrao": 0.025,
    "coeficienteVariacao": 0.004
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PICOS",
    "municipioIbge": 2208007,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.8,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.17061652909375458,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PIMENTA BUENO",
    "municipioIbge": 1100189,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.06,
    "precoMinimo": 6.9,
    "precoMaximo": 7.14,
    "desvioPadrao": 0.12393546707863734,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PINHEIRO",
    "municipioIbge": 2108603,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.32,
    "precoMinimo": 7.2,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.12549900398011135,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRACICABA",
    "municipioIbge": 3538709,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.18,
    "precoMinimo": 5.89,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.4050308630215727,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRASSUNUNGA",
    "municipioIbge": 3539301,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.49,
    "precoMinimo": 6.39,
    "precoMaximo": 6.6,
    "desvioPadrao": 0.14849242404917498,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PIRIPIRI",
    "municipioIbge": 2208403,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 6.69,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.33304654329387656,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.59,
    "precoMaximo": 6.59,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "POCOES",
    "municipioIbge": 2925105,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.18318608805567868,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "POCOS DE CALDAS",
    "municipioIbge": 3151800,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.54,
    "precoMaximo": 6.95,
    "desvioPadrao": 0.14282856857085702,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.89,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.19895710233974703,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "PONTA PORA",
    "municipioIbge": 5006606,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.57,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17237832147426693,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "PORANGATU",
    "municipioIbge": 5218003,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.26,
    "precoMinimo": 5.95,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.26837473800639283,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.62,
    "precoMaximo": 6.48,
    "desvioPadrao": 0.4134710791982111,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.46,
    "precoMinimo": 6.29,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2872281323269015,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PORTO SEGURO",
    "municipioIbge": 2925303,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 8.47,
    "precoMinimo": 8.45,
    "precoMaximo": 8.49,
    "desvioPadrao": 0.028284271247461905,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PORTO VELHO",
    "municipioIbge": 1100205,
    "produto": "DIESEL_S500",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.34,
    "precoMinimo": 7.06,
    "precoMaximo": 7.84,
    "desvioPadrao": 0.2492716663328659,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRAIA GRANDE",
    "municipioIbge": 3541000,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.3535533905932738,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PRESIDENTE DUTRA",
    "municipioIbge": 2109106,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 5.94,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3095803611342296,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRESIDENTE PRUDENTE",
    "municipioIbge": 3541406,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.58,
    "precoMinimo": 6.29,
    "precoMaximo": 7.07,
    "desvioPadrao": 0.2769906307509507,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.95,
    "precoMinimo": 5.89,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PIRES",
    "municipioIbge": 3543303,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PRETO",
    "municipioIbge": 3543402,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.3,
    "precoMinimo": 5.99,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.5639148871948674,
    "coeficienteVariacao": 0.09
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.58,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.4782258880487337,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AC",
    "estadoNome": "ACRE",
    "municipioNome": "RIO BRANCO",
    "municipioIbge": 1200401,
    "produto": "DIESEL_S500",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.74,
    "precoMinimo": 7.58,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.16168900189355284,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 5.99,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.45284287193977857,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.59,
    "precoMaximo": 7.87,
    "desvioPadrao": 0.3848953681774366,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "RIO VERDE",
    "municipioIbge": 5218805,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.29,
    "precoMinimo": 5.94,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.23049635881846686,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "RONDONOPOLIS",
    "municipioIbge": 5107602,
    "produto": "DIESEL_S500",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.2,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.28426406843999935,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.29,
    "precoMaximo": 6.68,
    "desvioPadrao": 0.27577164466275356,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SALTO",
    "municipioIbge": 3545209,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 5.79,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.5029910535983717,
    "coeficienteVariacao": 0.077
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTA MARIA",
    "municipioIbge": 4316907,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 5.99,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.362284418654736,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTANA DO LIVRAMENTO",
    "municipioIbge": null,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2228601953392904,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "SANTAREM",
    "municipioIbge": 1506807,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.97,
    "precoMinimo": 6.51,
    "precoMaximo": 7.4,
    "desvioPadrao": 0.34132096331752027,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.29,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.4903230227785217,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTO ANGELO",
    "municipioIbge": 4317509,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 5.88,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.41976183723630717,
    "coeficienteVariacao": 0.065
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SANTO ANTONIO DE JESUS",
    "municipioIbge": 2928703,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.18,
    "precoMinimo": 6.96,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.27622454633866267,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.49,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.28441251060822936,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTOS",
    "municipioIbge": 3548500,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.19,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.8082903768654761,
    "coeficienteVariacao": 0.121
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.28,
    "precoMinimo": 6.89,
    "precoMaximo": 7.67,
    "desvioPadrao": 0.4017876719529027,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CAETANO DO SUL",
    "municipioIbge": 3548807,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 5.97,
    "precoMaximo": 6.68,
    "desvioPadrao": 0.3555746522649405,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CARLOS",
    "municipioIbge": 3548906,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.42,
    "precoMinimo": 6.39,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.97,
    "precoMinimo": 6.89,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.14379769740081993,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOAO DA BOA VISTA",
    "municipioIbge": 3549102,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.23,
    "precoMinimo": 5.77,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.26583202716502513,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO JOAO DEL REI",
    "municipioIbge": 3162500,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.44,
    "precoMaximo": 6.62,
    "desvioPadrao": 0.07797435475847171,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO JOSE DE RIBAMAR",
    "municipioIbge": 2111201,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.65,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.24041630560342617,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DO RIO PRETO",
    "municipioIbge": 3549805,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 5.89,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3535533905932738,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.22,
    "precoMinimo": 5.99,
    "precoMaximo": 6.58,
    "desvioPadrao": 0.3157530680769389,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.14,
    "precoMinimo": 5.49,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.43243496620879307,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.01,
    "precoMinimo": 5.79,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.30384833309368264,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO LUIS",
    "municipioIbge": 2111300,
    "produto": "DIESEL_S500",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.25,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.29452917664882694,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LUIZ GONZAGA",
    "municipioIbge": 4318903,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.29,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.29676028485406647,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SAO MATEUS",
    "municipioIbge": 3204906,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.79,
    "precoMaximo": 6.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "DIESEL_S500",
    "postosPesquisados": 34,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 5.99,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4250196598158096,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO SEBASTIAO DO PARAISO",
    "municipioIbge": 3164704,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.48,
    "precoMinimo": 6.19,
    "precoMaximo": 6.87,
    "desvioPadrao": 0.23147559780882385,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO VICENTE",
    "municipioIbge": 3551009,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.09,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.33166247903553997,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPIRANGA",
    "municipioIbge": 4319901,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 5.91,
    "precoMinimo": 5.79,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.15,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 5.89,
    "precoMinimo": 5.79,
    "precoMaximo": 6.09,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.12,
    "precoMinimo": 6.99,
    "precoMaximo": 7.37,
    "desvioPadrao": 0.15962455951387933,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SENHOR DO BONFIM",
    "municipioIbge": 2930105,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.64,
    "precoMinimo": 7.16,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.30644919825496547,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1320101006236518,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SERRINHA",
    "municipioIbge": 2930501,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.28,
    "precoMaximo": 7.68,
    "desvioPadrao": 0.6224601727553873,
    "coeficienteVariacao": 0.09
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SERTAOZINHO",
    "municipioIbge": 3551702,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 6.09,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.25819888974716115,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 5.97,
    "precoMaximo": 6.85,
    "desvioPadrao": 0.31127235050751967,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SINOP",
    "municipioIbge": 5107909,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.03,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.4868949236402724,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SOROCABA",
    "municipioIbge": 3552205,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 6.09,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2720784200679405,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SORRISO",
    "municipioIbge": 5107925,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.45,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.3920459156782532,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "SOUSA",
    "municipioIbge": 2516201,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.69,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.431335136523794,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 5.79,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.3898717737923586,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 5.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.6133436852128472,
    "coeficienteVariacao": 0.094
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TABOAO DA SERRA",
    "municipioIbge": 3552809,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.44,
    "precoMinimo": 6.19,
    "precoMaximo": 8.69,
    "desvioPadrao": 1.7677669529663689,
    "coeficienteVariacao": 0.238
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TATUI",
    "municipioIbge": 3554003,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 5.99,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.7416198487095663,
    "coeficienteVariacao": 0.105
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.34,
    "precoMinimo": 5.99,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.31091263510296047,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "TEIXEIRA DE FREITAS",
    "municipioIbge": 2931350,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.87,
    "precoMaximo": 6.87,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.15,
    "precoMaximo": 6.84,
    "desvioPadrao": 0.2766947776883402,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "TERESINA",
    "municipioIbge": 2211001,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 6.89,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.2434474618201362,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "TOLEDO",
    "municipioIbge": 4127700,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.19,
    "precoMinimo": 5.85,
    "precoMaximo": 6.73,
    "desvioPadrao": 0.35600963068835256,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.33,
    "precoMinimo": 6.19,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.09604686356149274,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TRES CORACOES",
    "municipioIbge": 3169307,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.29,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.45747131057586554,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.39,
    "precoMaximo": 7.18,
    "desvioPadrao": 0.4561067126598044,
    "coeficienteVariacao": 0.069
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.02,
    "precoMinimo": 5.99,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.08164965809277261,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBA",
    "municipioIbge": 3169901,
    "produto": "DIESEL_S500",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.54,
    "precoMaximo": 6.54,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERABA",
    "municipioIbge": 3170107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.25,
    "precoMinimo": 5.84,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.3918249426903368,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERLANDIA",
    "municipioIbge": 3170206,
    "produto": "DIESEL_S500",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.18,
    "precoMinimo": 5.79,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.2941560432453798,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UMUARAMA",
    "municipioIbge": 4128104,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 5.99,
    "precoMinimo": 5.74,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3195756114420677,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UNAI",
    "municipioIbge": 3170404,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.57,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.08485281374238571,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UNIAO DA VITORIA",
    "municipioIbge": 4128203,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 5.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.41576092031014994,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "URUGUAIANA",
    "municipioIbge": 4322400,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.45,
    "precoMinimo": 5.57,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.773132157741051,
    "coeficienteVariacao": 0.12
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VACARIA",
    "municipioIbge": 4322509,
    "produto": "DIESEL_S500",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 5.58,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.26746161273295704,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.09574271077563382,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VALENCA",
    "municipioIbge": 2932903,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.89,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.2240535650240808,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VALINHOS",
    "municipioIbge": 3556206,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.44,
    "precoMinimo": 5.89,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.45790828776076986,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "VALPARAISO DE GOIAS",
    "municipioIbge": 5221858,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.25,
    "precoMinimo": 6.19,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VARGINHA",
    "municipioIbge": 3170701,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "DIESEL_S500",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.25,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.24680819620564817,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VARZEA PAULISTA",
    "municipioIbge": 3556503,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.31,
    "precoMinimo": 6.07,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.45343136195018535,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.41,
    "precoMinimo": 5.99,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.3095695936834452,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VICOSA",
    "municipioIbge": 3171303,
    "produto": "DIESEL_S500",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.282842712474619,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "VIDEIRA",
    "municipioIbge": 4219309,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.48,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.3025447625283461,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VILA VELHA",
    "municipioIbge": 3205200,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.47,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.15577761927397232,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "VILHENA",
    "municipioIbge": 1100304,
    "produto": "DIESEL_S500",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.22,
    "precoMinimo": 6.95,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.2083866598417471,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "DIESEL_S500",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.64,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.32471525988163846,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.97,
    "precoMinimo": 6.59,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.33291640592396965,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTORANTIM",
    "municipioIbge": 3557006,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 5.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.6928203230275509,
    "coeficienteVariacao": 0.105
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTUPORANGA",
    "municipioIbge": 3557105,
    "produto": "DIESEL_S500",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.18,
    "precoMinimo": 6.17,
    "precoMaximo": 6.19,
    "desvioPadrao": 0.011547005383792516,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "XANXERE",
    "municipioIbge": 4219507,
    "produto": "DIESEL_S500",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.37,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.13885243966167826,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ABAETETUBA",
    "municipioIbge": 1500107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 6.65,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.38811080891930855,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ADAMANTINA",
    "municipioIbge": 3500105,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.58,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.26034775278644595,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "AGUAS LINDAS DE GOIAS",
    "municipioIbge": 5200258,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.10690449676496976,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ALAGOINHAS",
    "municipioIbge": 2900702,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.3,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.09574271077563382,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALEGRETE",
    "municipioIbge": 4300406,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2516611478423583,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALENQUER",
    "municipioIbge": 1500404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.15,
    "precoMaximo": 7.5,
    "desvioPadrao": 0.15546703830716016,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ALFENAS",
    "municipioIbge": 3101607,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.64,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.3300937817680072,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "ALTA FLORESTA",
    "municipioIbge": 5100250,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.82,
    "precoMinimo": 7.63,
    "precoMaximo": 7.98,
    "desvioPadrao": 0.17691806012954134,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ALTAMIRA",
    "municipioIbge": 1500602,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.95,
    "precoMinimo": 7.39,
    "precoMaximo": 8.53,
    "desvioPadrao": 0.45382816131218656,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ALVORADA",
    "municipioIbge": 4300604,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.39,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.21213203435596426,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AMERICANA",
    "municipioIbge": 3501608,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.97,
    "precoMinimo": 6.59,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.29743855999129803,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "ANANINDEUA",
    "municipioIbge": 1500800,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.43,
    "precoMaximo": 9.15,
    "desvioPadrao": 0.9734376982534386,
    "coeficienteVariacao": 0.139
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ANAPOLIS",
    "municipioIbge": 5201108,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.39,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.31874754901018454,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ANGRA DOS REIS",
    "municipioIbge": 3300100,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.79,
    "precoMinimo": 7.74,
    "precoMaximo": 7.85,
    "desvioPadrao": 0.045,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "APARECIDA DE GOIANIA",
    "municipioIbge": 5201405,
    "produto": "DIESEL_S10",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.29,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4683570575248476,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "APUCARANA",
    "municipioIbge": 4101408,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.15588457268119896,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ARACAJU",
    "municipioIbge": 2800308,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.76,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.265,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARACATUBA",
    "municipioIbge": 3502804,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.23,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.36914643559039134,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "ARACRUZ",
    "municipioIbge": 3200607,
    "produto": "DIESEL_S10",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 7.09,
    "precoMaximo": 7.09,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "ARAGUAINA",
    "municipioIbge": 1702109,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.09330952077181978,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "ARAPIRACA",
    "municipioIbge": 2700300,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.19,
    "precoMinimo": 6.99,
    "precoMaximo": 7.43,
    "desvioPadrao": 0.18064698539785637,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAPONGAS",
    "municipioIbge": 4101507,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 6.69,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.3579385422108103,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ARARANGUA",
    "municipioIbge": 4201406,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.53,
    "precoMinimo": 6.29,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.13416407864998736,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAQUARA",
    "municipioIbge": 3503208,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.27,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.41004064839151416,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ARARAS",
    "municipioIbge": 3503307,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.47,
    "precoMaximo": 7.3,
    "desvioPadrao": 0.26283255578590786,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARARIPINA",
    "municipioIbge": 2601102,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.63,
    "precoMaximo": 7.41,
    "desvioPadrao": 0.2969337347913552,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ARARUAMA",
    "municipioIbge": 3300209,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.36,
    "precoMinimo": 6.99,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.2058663459163551,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "ARAUCARIA",
    "municipioIbge": 4101804,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.37,
    "precoMaximo": 7.04,
    "desvioPadrao": 0.30911163032147465,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ARAXA",
    "municipioIbge": 3104007,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.44,
    "precoMaximo": 6.74,
    "desvioPadrao": 0.11475906437899736,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "ARCOVERDE",
    "municipioIbge": 2601201,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.79,
    "precoMaximo": 7.05,
    "desvioPadrao": 0.0805228450281569,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "ARIQUEMES",
    "municipioIbge": 1100023,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.34,
    "precoMinimo": 6.89,
    "precoMaximo": 7.94,
    "desvioPadrao": 0.4540905353403816,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ASSIS",
    "municipioIbge": 3504008,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.34,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.49413223601245315,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ATIBAIA",
    "municipioIbge": 3504107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 6.49,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.3919647479510927,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "AVARE",
    "municipioIbge": 3504503,
    "produto": "DIESEL_S10",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.98,
    "precoMaximo": 6.98,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BACABAL",
    "municipioIbge": 2101202,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.84,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.10473606283006277,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BAGE",
    "municipioIbge": 4301602,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.36,
    "precoMinimo": 7.29,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.14501231474799453,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "BALSAS",
    "municipioIbge": 2101400,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.36,
    "precoMinimo": 6.85,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.3152089254235461,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA DO PIRAI",
    "municipioIbge": 3300308,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.45,
    "precoMinimo": 6.99,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.3566510900025402,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "BARRA MANSA",
    "municipioIbge": 3300407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 6.99,
    "precoMaximo": 8.59,
    "desvioPadrao": 0.5545783469061364,
    "coeficienteVariacao": 0.075
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "BARREIRAS",
    "municipioIbge": 2903201,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.37,
    "precoMinimo": 6.79,
    "precoMaximo": 8.29,
    "desvioPadrao": 0.4078248534740264,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARRETOS",
    "municipioIbge": 3505500,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.29,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2875388172552907,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BARUERI",
    "municipioIbge": 3505708,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.49,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2781186797034676,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BAURU",
    "municipioIbge": 3506003,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.10039920318408907,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "BAYEUX",
    "municipioIbge": 2501807,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.88,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.07454624643228429,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BEBEDOURO",
    "municipioIbge": 3506102,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.15099668870541502,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BELEM",
    "municipioIbge": 1501402,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.76,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.21400517350221768,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BELO HORIZONTE",
    "municipioIbge": 3106200,
    "produto": "DIESEL_S10",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.39,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.2516611478423583,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "BELO JARDIM",
    "municipioIbge": 2601706,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.18392545073635524,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "BENTO GONCALVES",
    "municipioIbge": 4302105,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.5,
    "precoMinimo": 6.49,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.03779644730092273,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BETIM",
    "municipioIbge": 3106705,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.44,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.24283665879999022,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BIRIGUI",
    "municipioIbge": 3506508,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.39,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.2058663459163551,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BLUMENAU",
    "municipioIbge": 4202404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.46,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2567621189238898,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RR",
    "estadoNome": "RORAIMA",
    "municipioNome": "BOA VISTA",
    "municipioIbge": 1400100,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.2,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.07888106377466154,
    "coeficienteVariacao": 0.011
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "BOM DESPACHO",
    "municipioIbge": 3107406,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.49,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.19667231630303234,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "BRAGANCA",
    "municipioIbge": 1501709,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.47,
    "precoMinimo": 7.45,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.023094010767585032,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "BRAGANCA PAULISTA",
    "municipioIbge": 3507605,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.59,
    "precoMaximo": 7.98,
    "desvioPadrao": 0.39912404086950215,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "DF",
    "estadoNome": "DISTRITO FEDERAL",
    "municipioNome": "BRASILIA",
    "municipioIbge": 5300108,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.59,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.1845120510148239,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "BRUSQUE",
    "municipioIbge": 4202909,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 6.89,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.32108669649592564,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CABEDELO",
    "municipioIbge": 2503209,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.84,
    "precoMaximo": 7.48,
    "desvioPadrao": 0.27910571473905726,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CABO DE SANTO AGOSTINHO",
    "municipioIbge": 2602902,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17286107827082528,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CABO FRIO",
    "municipioIbge": 3300704,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.29,
    "precoMinimo": 7.19,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CACADOR",
    "municipioIbge": 4203006,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.69,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.24348657927227588,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CACAPAVA",
    "municipioIbge": 3508504,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.28784916685156975,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CACERES",
    "municipioIbge": 5102504,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.75,
    "precoMaximo": 7.05,
    "desvioPadrao": 0.11301074538037775,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRA DO SUL",
    "municipioIbge": 4303004,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.29,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.25282404948896775,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CACHOEIRINHA",
    "municipioIbge": 4303103,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 6.09,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.15695009822658074,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CACHOEIRO DE ITAPEMIRIM",
    "municipioIbge": 3201209,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.69,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.28190620977749165,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "CACOAL",
    "municipioIbge": 1100049,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.99,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.24768932153001674,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "CAETITE",
    "municipioIbge": 2905206,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 8.08,
    "precoMinimo": 8.08,
    "precoMaximo": 8.09,
    "desvioPadrao": 0.00447213595499958,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "CAICO",
    "municipioIbge": 2402006,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.65,
    "precoMinimo": 7.59,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.14019756468233371,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CALDAS NOVAS",
    "municipioIbge": 5204508,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.67,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.07823042886243178,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMBE",
    "municipioIbge": 4103701,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 6.89,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.24443813123160635,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "CAMPINA GRANDE",
    "municipioIbge": 2504009,
    "produto": "DIESEL_S10",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.67,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.23895376351692205,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CAMPINAS",
    "municipioIbge": 3509502,
    "produto": "DIESEL_S10",
    "postosPesquisados": 20,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.19,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.47782401517052725,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CAMPO BELO",
    "municipioIbge": 3111200,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.89,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CAMPO GRANDE",
    "municipioIbge": 5002704,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2159317372493334,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO LARGO",
    "municipioIbge": 4104204,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.15399443403670704,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CAMPO MOURAO",
    "municipioIbge": 4104303,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.38418745424597095,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "CAMPOS DOS GOYTACAZES",
    "municipioIbge": 3301009,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.13650396819628846,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CANINDE",
    "municipioIbge": 2302800,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 6.99,
    "precoMaximo": 7.28,
    "desvioPadrao": 0.1024230256850294,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CANOAS",
    "municipioIbge": 4304606,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 6.29,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.08164965809277261,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CARAGUATATUBA",
    "municipioIbge": 3510500,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.54,
    "precoMinimo": 7.39,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.12909944487358058,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CARATINGA",
    "municipioIbge": 3113404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.18929694486000911,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "CARIACICA",
    "municipioIbge": 3201308,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.10301698889018258,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "CARUARU",
    "municipioIbge": 2604106,
    "produto": "DIESEL_S10",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.49,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.19855429867874813,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASCAVEL",
    "municipioIbge": 4104808,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 5.89,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.3531446036839741,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CASTANHAL",
    "municipioIbge": 1502400,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.68,
    "precoMaximo": 7.38,
    "desvioPadrao": 0.2536927275268253,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CASTRO",
    "municipioIbge": 4104907,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.59,
    "precoMaximo": 7.28,
    "desvioPadrao": 0.2553429066960741,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "CATALAO",
    "municipioIbge": 5205109,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.65,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.3330093663776412,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CAUCAIA",
    "municipioIbge": 2303709,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.48,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.18953691572947584,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CAXIAS DO SUL",
    "municipioIbge": 4305108,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.54,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1502442455914147,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CHAPECO",
    "municipioIbge": 4204202,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.39,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.397437303554171,
    "coeficienteVariacao": 0.059
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CIANORTE",
    "municipioIbge": 4105508,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.74,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.10606601717798213,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "CODO",
    "municipioIbge": 2103307,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.6,
    "precoMinimo": 7.51,
    "precoMaximo": 7.8,
    "desvioPadrao": 0.10483547200483333,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "COLATINA",
    "municipioIbge": 3201506,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.09797958971132713,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "COLOMBO",
    "municipioIbge": 4105805,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2251983252919207,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "CONCEICAO DO ARAGUAIA",
    "municipioIbge": 1502707,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.29,
    "precoMaximo": 7.85,
    "desvioPadrao": 0.2285315441392428,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CONCORDIA",
    "municipioIbge": 4204301,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.69,
    "precoMaximo": 7.34,
    "desvioPadrao": 0.25718994277900264,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONGONHAS",
    "municipioIbge": 3118007,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.6,
    "precoMinimo": 6.39,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.2680609383454939,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONSELHEIRO LAFAIETE",
    "municipioIbge": 3118304,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.11,
    "precoMinimo": 6.79,
    "precoMaximo": 7.58,
    "desvioPadrao": 0.33290210201170184,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CONTAGEM",
    "municipioIbge": 3118601,
    "produto": "DIESEL_S10",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.45,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.14164677731529768,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CORNELIO PROCOPIO",
    "municipioIbge": 4106407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 7.19,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.282842712474619,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CORONEL FABRICIANO",
    "municipioIbge": 3119401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.69,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.05131601439446885,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "CORUMBA",
    "municipioIbge": 5003207,
    "produto": "DIESEL_S10",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 7.69,
    "precoMinimo": 7.69,
    "precoMaximo": 7.69,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COSMOPOLIS",
    "municipioIbge": 3512803,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.79,
    "precoMaximo": 6.79,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "COTIA",
    "municipioIbge": 3513009,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.59,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.16132782359737788,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "CRATEUS",
    "municipioIbge": 2304103,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.72,
    "precoMaximo": 7.28,
    "desvioPadrao": 0.23241485896273212,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "CRICIUMA",
    "municipioIbge": 4204608,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.39,
    "precoMaximo": 8.38,
    "desvioPadrao": 0.5397558370563154,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "CRUZ ALTA",
    "municipioIbge": 4306106,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2309401076758503,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CRUZEIRO",
    "municipioIbge": 3513405,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.89,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.29046514420838865,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "CUBATAO",
    "municipioIbge": 3513504,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.69,
    "precoMinimo": 7.49,
    "precoMaximo": 7.92,
    "desvioPadrao": 0.13633292583476184,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "CUIABA",
    "municipioIbge": 5103403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.49,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.25239219120610323,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "CURITIBA",
    "municipioIbge": 4106902,
    "produto": "DIESEL_S10",
    "postosPesquisados": 25,
    "unidade": "R$/l",
    "precoMedio": 6.97,
    "precoMinimo": 6.57,
    "precoMaximo": 7.74,
    "desvioPadrao": 0.306090945090943,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "CURVELO",
    "municipioIbge": 3120904,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.57,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.14838014242703323,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "DELMIRO GOUVEIA",
    "municipioIbge": 2702405,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.87,
    "precoMinimo": 7.29,
    "precoMaximo": 8.26,
    "desvioPadrao": 0.3575886503472151,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "DIADEMA",
    "municipioIbge": 3513801,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.03,
    "precoMinimo": 6.29,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.5222329678670935,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "DIVINOPOLIS",
    "municipioIbge": 3122306,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2549322972682673,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "DOURADOS",
    "municipioIbge": 5003702,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.65,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.25153970307333634,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "EMBU DAS ARTES",
    "municipioIbge": 3515004,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.48,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.5053711507397312,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ERECHIM",
    "municipioIbge": 4307005,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.65,
    "precoMinimo": 6.45,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.18200765290032647,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "ESTEIO",
    "municipioIbge": 4307708,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.27018512172212594,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "EUNAPOLIS",
    "municipioIbge": 2910727,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 8.16,
    "precoMinimo": 7.87,
    "precoMaximo": 8.39,
    "desvioPadrao": 0.1994590899694185,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "FEIRA DE SANTANA",
    "municipioIbge": 2910800,
    "produto": "DIESEL_S10",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.53,
    "precoMinimo": 7.28,
    "precoMaximo": 8.14,
    "desvioPadrao": 0.2626084286788732,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "FLORIANOPOLIS",
    "municipioIbge": 4205407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.14456832294800961,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FORMIGA",
    "municipioIbge": 3126109,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.65,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.38796907093220717,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "FORMOSA",
    "municipioIbge": 5208004,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.61,
    "precoMinimo": 6.59,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.044721359549995794,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "FORTALEZA",
    "municipioIbge": 2304400,
    "produto": "DIESEL_S10",
    "postosPesquisados": 38,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.15,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.19084691831528475,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "FRANCA",
    "municipioIbge": 3516200,
    "produto": "DIESEL_S10",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.21836622798365485,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "FRANCISCO BELTRAO",
    "municipioIbge": 4108403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 1,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.77,
    "precoMaximo": 6.77,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "FRUTAL",
    "municipioIbge": 3127107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.32,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.23838369431294104,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "GARANHUNS",
    "municipioIbge": 2606002,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.5,
    "precoMaximo": 6.85,
    "desvioPadrao": 0.12367391841143426,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GARCA",
    "municipioIbge": 3516705,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.37,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.23380903889000243,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIANIA",
    "municipioIbge": 5208707,
    "produto": "DIESEL_S10",
    "postosPesquisados": 37,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.34,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.3120974283854399,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "GOIATUBA",
    "municipioIbge": 5209101,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 6.19,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.057735026918962574,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GOVERNADOR VALADARES",
    "municipioIbge": 3127701,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.75,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.15513435037626797,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAMADO",
    "municipioIbge": 4309100,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.39,
    "precoMinimo": 7.29,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GRAVATAI",
    "municipioIbge": 4309209,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.54,
    "precoMinimo": 6.19,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.4949747468305833,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "GUAIBA",
    "municipioIbge": 4309308,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.29,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.043996753126955696,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "GUANAMBI",
    "municipioIbge": 2911709,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.84,
    "precoMinimo": 7.55,
    "precoMaximo": 8.05,
    "desvioPadrao": 0.17932412792801436,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "GUARAPARI",
    "municipioIbge": 3202405,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 7.09,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.11547005383792515,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "GUARAPUAVA",
    "municipioIbge": 4109401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.39,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.23746524711995984,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARATINGUETA",
    "municipioIbge": 3518404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.49,
    "precoMaximo": 7.57,
    "desvioPadrao": 0.3952937424968208,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARUJA",
    "municipioIbge": 3518701,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.35,
    "precoMinimo": 6.68,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4012722821781296,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "GUARULHOS",
    "municipioIbge": 3518800,
    "produto": "DIESEL_S10",
    "postosPesquisados": 20,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.29,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.4114979056031628,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "GUAXUPE",
    "municipioIbge": 3128709,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.29859193367728953,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "GURUPI",
    "municipioIbge": 1709500,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.86,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.16969159700833186,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "HORTOLANDIA",
    "municipioIbge": 3519071,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.152362350055011,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "IBITINGA",
    "municipioIbge": 3519600,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.39,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.38544964466377263,
    "coeficienteVariacao": 0.057
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ICO",
    "municipioIbge": 2305407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.71,
    "precoMinimo": 7.48,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.1820910290408148,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "IGARASSU",
    "municipioIbge": 2606804,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.62,
    "precoMinimo": 6.55,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.10636863125135021,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "IGUATU",
    "municipioIbge": 2305506,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.45,
    "precoMinimo": 7.09,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.37855867004556465,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "IJUI",
    "municipioIbge": 4310207,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.14,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2830832229417899,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ILHEUS",
    "municipioIbge": 2913606,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.99,
    "precoMinimo": 7.99,
    "precoMaximo": 7.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "IMPERATRIZ",
    "municipioIbge": 2105302,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.67,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.28678785317246747,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "INDAIATUBA",
    "municipioIbge": 3520509,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.49,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.26352313834736496,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "IPATINGA",
    "municipioIbge": 3131307,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.76,
    "precoMaximo": 6.85,
    "desvioPadrao": 0.045,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IPIRA",
    "municipioIbge": 2914000,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.72,
    "precoMinimo": 7.49,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.2098412098071619,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "IRECE",
    "municipioIbge": 2914604,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 8.06,
    "precoMinimo": 7.68,
    "precoMaximo": 8.49,
    "desvioPadrao": 0.24109497239529015,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "ITABAIANA",
    "municipioIbge": 2802908,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.76,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.08131727983645297,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITABORAI",
    "municipioIbge": 3301900,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.03,
    "precoMinimo": 6.24,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4468221122549778,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITABUNA",
    "municipioIbge": 2914802,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.57,
    "precoMinimo": 7.55,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.023094010767585032,
    "coeficienteVariacao": 0.003
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "ITAJAI",
    "municipioIbge": 4208203,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.69,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.26807252523874725,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAJUBA",
    "municipioIbge": 3132404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.99,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "ITAMARAJU",
    "municipioIbge": 2915601,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.77,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.06994045086119097,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPECERICA DA SERRA",
    "municipioIbge": 3522208,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.67,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.1614222501922918,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "ITAPERUNA",
    "municipioIbge": 3302205,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.27,
    "precoMinimo": 6.99,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.25713809519400277,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "ITAPIPOCA",
    "municipioIbge": 2306405,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.65,
    "precoMinimo": 7.56,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.04138236339311713,
    "coeficienteVariacao": 0.005
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPIRA",
    "municipioIbge": 3522604,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.49,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.3563705936241092,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAPOLIS",
    "municipioIbge": 3522703,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.86,
    "precoMinimo": 6.67,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.1711139970896595,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITAQUAQUECETUBA",
    "municipioIbge": 3523107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.29,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.3988077469754306,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITATIBA",
    "municipioIbge": 3523404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.37,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.4601883672294785,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITAUNA",
    "municipioIbge": 3133808,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.59,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.15666160072863147,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "ITU",
    "municipioIbge": 3523909,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.09,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.3208470930877466,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "ITUIUTABA",
    "municipioIbge": 3134202,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 5.99,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.26307793522072503,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "ITUMBIARA",
    "municipioIbge": 5211503,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.29277002188455997,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "JABOATAO DOS GUARARAPES",
    "municipioIbge": 2607901,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.282842712474619,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JABOTICABAL",
    "municipioIbge": 3524303,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.79,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.11282097069504157,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JACAREI",
    "municipioIbge": 3524402,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 5.99,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.438953300477397,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JACOBINA",
    "municipioIbge": 2917508,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.53,
    "precoMinimo": 7.34,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.21486171263292947,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JAGUAQUARA",
    "municipioIbge": 2917607,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.72,
    "precoMinimo": 7.39,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.2634387974463898,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JALES",
    "municipioIbge": 3524808,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.19518001458970666,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANAUBA",
    "municipioIbge": 3135100,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.29,
    "precoMinimo": 7.08,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.3633730865102698,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JANUARIA",
    "municipioIbge": 3135209,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 7.09,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.07302967433402216,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JAU",
    "municipioIbge": 3525300,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.89,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.17888543819998318,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JEQUIE",
    "municipioIbge": 2918001,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.83,
    "precoMinimo": 6.99,
    "precoMaximo": 8.29,
    "desvioPadrao": 0.3773119209808852,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "JI-PARANA",
    "municipioIbge": 1100122,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.69,
    "precoMinimo": 7.15,
    "precoMaximo": 7.98,
    "desvioPadrao": 0.3339562631757125,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO MONLEVADE",
    "municipioIbge": 3136207,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.77,
    "precoMaximo": 7.15,
    "desvioPadrao": 0.18766104195241662,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "JOAO PESSOA",
    "municipioIbge": 2507507,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.79,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.09592610792593527,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JOAO PINHEIRO",
    "municipioIbge": 3136306,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.56,
    "precoMinimo": 6.44,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.13632288352081087,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "JOINVILLE",
    "municipioIbge": 4209102,
    "produto": "DIESEL_S10",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.44,
    "precoMaximo": 7.32,
    "desvioPadrao": 0.2398351081907716,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "JUAZEIRO",
    "municipioIbge": 2918407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.95,
    "precoMinimo": 6.95,
    "precoMaximo": 6.95,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "JUAZEIRO DO NORTE",
    "municipioIbge": 2307304,
    "produto": "DIESEL_S10",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 7.29,
    "precoMinimo": 7.05,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.32376946530929485,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "JUIZ DE FORA",
    "municipioIbge": 3136702,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.92,
    "precoMinimo": 6.65,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.14058485894328226,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "JUNDIAI",
    "municipioIbge": 3525904,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.59,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.33203116867200433,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "LAGARTO",
    "municipioIbge": 2803500,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.76,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.01341640786499874,
    "coeficienteVariacao": 0.002
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "LAGUNA",
    "municipioIbge": 4209409,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.18,
    "precoMaximo": 7.66,
    "desvioPadrao": 0.6519943762538651,
    "coeficienteVariacao": 0.096
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "LAJEADO",
    "municipioIbge": 4311403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 5.99,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.16274554098687655,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "LAJEDO",
    "municipioIbge": 2608800,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.54,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.107496769977314,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LAVRAS",
    "municipioIbge": 3138203,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.69,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.4242640687119285,
    "coeficienteVariacao": 0.061
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LEME",
    "municipioIbge": 3526704,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.39,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.2546893532652409,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "LEOPOLDINA",
    "municipioIbge": 3138401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.69,
    "precoMaximo": 6.95,
    "desvioPadrao": 0.09633275663033837,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LIMEIRA",
    "municipioIbge": 3526902,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.29,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.34483197489370226,
    "coeficienteVariacao": 0.051
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "LIMOEIRO DO NORTE",
    "municipioIbge": 2307601,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.19,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.1518432205808466,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LINS",
    "municipioIbge": 3527108,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.49,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.12464234547582248,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "LIVRAMENTO DE NOSSA SENHORA",
    "municipioIbge": 2919504,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.93,
    "precoMinimo": 7.79,
    "precoMaximo": 8.39,
    "desvioPadrao": 0.20701966780270625,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "LONDRINA",
    "municipioIbge": 4113700,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.12,
    "precoMinimo": 6.79,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.2659156090023884,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "LORENA",
    "municipioIbge": 3527207,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.37,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.5100326786916043,
    "coeficienteVariacao": 0.074
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MACAE",
    "municipioIbge": 3302403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.7,
    "precoMinimo": 7.55,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.09423375191511797,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AP",
    "estadoNome": "AMAPA",
    "municipioNome": "MACAPA",
    "municipioIbge": 1600303,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.89,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.041633319989322654,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "MACEIO",
    "municipioIbge": 2704302,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.11700630833624395,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANACAPURU",
    "municipioIbge": 1302504,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.28,
    "precoMinimo": 6.99,
    "precoMaximo": 8.85,
    "desvioPadrao": 0.6944267934264716,
    "coeficienteVariacao": 0.095
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "MANAUS",
    "municipioIbge": 1302603,
    "produto": "DIESEL_S10",
    "postosPesquisados": 27,
    "unidade": "R$/l",
    "precoMedio": 7.1,
    "precoMinimo": 6.99,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.14669385917306943,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "MARABA",
    "municipioIbge": 1504208,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.59,
    "precoMaximo": 7.36,
    "desvioPadrao": 0.28391900253417346,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "MARICA",
    "municipioIbge": 3302700,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.36,
    "precoMinimo": 6.89,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4845862250660965,
    "coeficienteVariacao": 0.066
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MARILIA",
    "municipioIbge": 3529005,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.15,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.4545681711495232,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "MARINGA",
    "municipioIbge": 4115200,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.44,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.3293765153876167,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MATAO",
    "municipioIbge": 3529302,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.45,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.44800297618059043,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MAUA",
    "municipioIbge": 3529401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.29,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.44633818767586736,
    "coeficienteVariacao": 0.064
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "MINEIROS",
    "municipioIbge": 5213103,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2064784088793144,
    "coeficienteVariacao": 0.03
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOCOCA",
    "municipioIbge": 3530508,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.39,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.372827037646145,
    "coeficienteVariacao": 0.054
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI DAS CRUZES",
    "municipioIbge": 3530607,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.98,
    "precoMinimo": 6.69,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.19692073983655908,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI GUACU",
    "municipioIbge": 3530706,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.59,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.18571611720708622,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MOGI MIRIM",
    "municipioIbge": 3530805,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.52,
    "precoMinimo": 6.25,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.26701168157074723,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "MONTE ALTO",
    "municipioIbge": 3531308,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.69,
    "precoMaximo": 7.08,
    "desvioPadrao": 0.1336662510384228,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTE CARMELO",
    "municipioIbge": 3143104,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.05,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.3661283927804562,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MONTES CLAROS",
    "municipioIbge": 3143302,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.15874507866387544,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "MOSSORO",
    "municipioIbge": 2408003,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 6.89,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.1885233975626671,
    "coeficienteVariacao": 0.026
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "MURIAE",
    "municipioIbge": 3143906,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.79,
    "precoMaximo": 6.88,
    "desvioPadrao": 0.045,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "NATAL",
    "municipioIbge": 2408102,
    "produto": "DIESEL_S10",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 6.96,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.22214528897044994,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NITEROI",
    "municipioIbge": 3303302,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.79,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.1385285223885374,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SE",
    "estadoNome": "SERGIPE",
    "municipioNome": "NOSSA SENHORA DO SOCORRO",
    "municipioIbge": 2804805,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.76,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.12308533625091171,
    "coeficienteVariacao": 0.018
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "NOVA FRIBURGO",
    "municipioIbge": 3303401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.47,
    "precoMinimo": 6.79,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.521536192416212,
    "coeficienteVariacao": 0.07
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "NOVA LIMA",
    "municipioIbge": 3144805,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.69,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.17320508075688773,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "NOVO HAMBURGO",
    "municipioIbge": 4313409,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.28,
    "precoMinimo": 5.99,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.29559732369860486,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OLIMPIA",
    "municipioIbge": 3533908,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.64,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.5562523408190447,
    "coeficienteVariacao": 0.078
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "OLINDA",
    "municipioIbge": 2609600,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.95,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.10733126291998991,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OSASCO",
    "municipioIbge": 3534401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.49,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.3174281116420001,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "OSORIO",
    "municipioIbge": 4313508,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.27,
    "precoMinimo": 5.99,
    "precoMaximo": 6.49,
    "desvioPadrao": 0.2565800719723442,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "OURINHOS",
    "municipioIbge": 3534708,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.29,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.5118593556827892,
    "coeficienteVariacao": 0.076
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "OURO PRETO",
    "municipioIbge": 3146107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 7.15,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.052153619241621194,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "PALMEIRA DOS INDIOS",
    "municipioIbge": 2706307,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 7.2,
    "precoMaximo": 7.64,
    "desvioPadrao": 0.15614096195425467,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARA DE MINAS",
    "municipioIbge": 3147105,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.84,
    "precoMinimo": 6.44,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.46735068916892236,
    "coeficienteVariacao": 0.068
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PARACATU",
    "municipioIbge": 3147006,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.37,
    "precoMaximo": 6.92,
    "desvioPadrao": 0.18803495115840263,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAGOMINAS",
    "municipioIbge": 1505502,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.64,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.24772969139770065,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PARAGUACU PAULISTA",
    "municipioIbge": 3535507,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.09,
    "precoMaximo": 7.37,
    "desvioPadrao": 0.4204124958498102,
    "coeficienteVariacao": 0.063
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "TO",
    "estadoNome": "TOCANTINS",
    "municipioNome": "PARAISO DO TOCANTINS",
    "municipioIbge": 1716109,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.08380817098475259,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAGUA",
    "municipioIbge": 4118204,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.49,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.5163977794943223,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PARANAVAI",
    "municipioIbge": 4118402,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.35,
    "precoMaximo": 7.53,
    "desvioPadrao": 0.49327477129891817,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "PARAUAPEBAS",
    "municipioIbge": 1505536,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.58,
    "precoMinimo": 7.19,
    "precoMaximo": 8.09,
    "desvioPadrao": 0.3044302510884518,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AM",
    "estadoNome": "AMAZONAS",
    "municipioNome": "PARINTINS",
    "municipioIbge": 1303403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 8.49,
    "precoMinimo": 8.29,
    "precoMaximo": 8.99,
    "desvioPadrao": 0.34156502553198664,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PARNAIBA",
    "municipioIbge": 2207702,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 6.99,
    "precoMaximo": 7.65,
    "desvioPadrao": 0.26545558322752727,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RN",
    "estadoNome": "RIO GRANDE DO NORTE",
    "municipioNome": "PARNAMIRIM",
    "municipioIbge": 2403251,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.99,
    "precoMaximo": 6.99,
    "desvioPadrao": 0,
    "coeficienteVariacao": 0
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PASSO FUNDO",
    "municipioIbge": 4314100,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.64,
    "precoMinimo": 6.49,
    "precoMaximo": 6.69,
    "desvioPadrao": 0.1,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PASSOS",
    "municipioIbge": 3147907,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.59,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.24494897427831783,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PATO BRANCO",
    "municipioIbge": 4118501,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.59,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.3464462440264001,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "PATOS",
    "municipioIbge": 2510808,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 6.85,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.2031888635868469,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "PATROCINIO",
    "municipioIbge": 3148103,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 6.75,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.2981051268708183,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PAULINIA",
    "municipioIbge": 3536505,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.69,
    "precoMinimo": 6.39,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.2549509756796392,
    "coeficienteVariacao": 0.038
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PAULISTA",
    "municipioIbge": 2610707,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.55,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.12999313168669444,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PAULO AFONSO",
    "municipioIbge": 2924009,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.52,
    "precoMinimo": 7.15,
    "precoMaximo": 8.57,
    "desvioPadrao": 0.612633658885961,
    "coeficienteVariacao": 0.081
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PELOTAS",
    "municipioIbge": 4314407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.83,
    "precoMinimo": 6.39,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.23315011121372936,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "PETROLINA",
    "municipioIbge": 2611101,
    "produto": "DIESEL_S10",
    "postosPesquisados": 15,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 6.99,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.21820043210642037,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "PETROPOLIS",
    "municipioIbge": 3303906,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 7.13,
    "precoMinimo": 6.89,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4259534759059534,
    "coeficienteVariacao": 0.06
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PICOS",
    "municipioIbge": 2208007,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.22,
    "precoMinimo": 7.09,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.10522462745109731,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PIMENTA BUENO",
    "municipioIbge": 1100189,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.16,
    "precoMinimo": 7.15,
    "precoMaximo": 7.17,
    "desvioPadrao": 0.009759000729485334,
    "coeficienteVariacao": 0.001
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PINHEIRO",
    "municipioIbge": 2108603,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.59,
    "precoMinimo": 7.19,
    "precoMaximo": 7.84,
    "desvioPadrao": 0.32137205852407275,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRACICABA",
    "municipioIbge": 3538709,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.49,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2600699206681996,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PIRASSUNUNGA",
    "municipioIbge": 3539301,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.29,
    "precoMaximo": 7.27,
    "desvioPadrao": 0.4940985056983408,
    "coeficienteVariacao": 0.072
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "PIRIPIRI",
    "municipioIbge": 2208403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.47,
    "precoMinimo": 7.29,
    "precoMaximo": 7.9,
    "desvioPadrao": 0.2069391444937606,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "POA",
    "municipioIbge": 3539806,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.42,
    "precoMinimo": 6.95,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.3702971779530598,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "POCOES",
    "municipioIbge": 2925105,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.43,
    "precoMinimo": 7.36,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.10034938963441681,
    "coeficienteVariacao": 0.013
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "POCOS DE CALDAS",
    "municipioIbge": 3151800,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.96,
    "precoMinimo": 6.49,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2546052032536051,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "PONTA GROSSA",
    "municipioIbge": 4119905,
    "produto": "DIESEL_S10",
    "postosPesquisados": 16,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.29,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.33848436694575224,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MS",
    "estadoNome": "MATO GROSSO DO SUL",
    "municipioNome": "PONTA PORA",
    "municipioIbge": 5006606,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.22,
    "precoMinimo": 7.17,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.06187545093630776,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "PORANGATU",
    "municipioIbge": 5218003,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.45,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.26835921200261914,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "PORTO ALEGRE",
    "municipioIbge": 4314902,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.39,
    "precoMinimo": 5.94,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.18396145841403352,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PORTO FERREIRA",
    "municipioIbge": 3540705,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.04,
    "precoMinimo": 6.85,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.242156973882645,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "PORTO SEGURO",
    "municipioIbge": 2925303,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 8.47,
    "precoMinimo": 8.45,
    "precoMaximo": 8.55,
    "desvioPadrao": 0.05,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "PORTO VELHO",
    "municipioIbge": 1100205,
    "produto": "DIESEL_S10",
    "postosPesquisados": 19,
    "unidade": "R$/l",
    "precoMedio": 7.32,
    "precoMinimo": 6.49,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.34484423129820385,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRAIA GRANDE",
    "municipioIbge": 3541000,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.19,
    "precoMinimo": 6.79,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.33628030635831835,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "PRESIDENTE DUTRA",
    "municipioIbge": 2109106,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.63,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.1529160989998546,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "PRESIDENTE PRUDENTE",
    "municipioIbge": 3541406,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.59,
    "precoMaximo": 7.37,
    "desvioPadrao": 0.24637369989509839,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "QUIXADA",
    "municipioIbge": 2311306,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.09,
    "precoMinimo": 6.59,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.7071067811865476,
    "coeficienteVariacao": 0.1
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "RECIFE",
    "municipioIbge": 2611606,
    "produto": "DIESEL_S10",
    "postosPesquisados": 18,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.49,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.14521676382818902,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RESENDE",
    "municipioIbge": 3304201,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.03,
    "precoMinimo": 6.39,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.515936504029785,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PIRES",
    "municipioIbge": 3543303,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.07,
    "precoMinimo": 6.55,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.2533067028609502,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIBEIRAO PRETO",
    "municipioIbge": 3543402,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.39,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.368216421868082,
    "coeficienteVariacao": 0.053
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO BONITO",
    "municipioIbge": 3304300,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.25,
    "precoMinimo": 6.97,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.32140317359976395,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AC",
    "estadoNome": "ACRE",
    "municipioNome": "RIO BRANCO",
    "municipioIbge": 1200401,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 8,
    "precoMinimo": 7.89,
    "precoMaximo": 8.15,
    "desvioPadrao": 0.07927123419897392,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "RIO CLARO",
    "municipioIbge": 3543907,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.39,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.2842709974654467,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "RIO DE JANEIRO",
    "municipioIbge": 3304557,
    "produto": "DIESEL_S10",
    "postosPesquisados": 38,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.49,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.31760494619765867,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "AL",
    "estadoNome": "ALAGOAS",
    "municipioNome": "RIO LARGO",
    "municipioIbge": 2707701,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.77,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.25812510809406247,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "RIO VERDE",
    "municipioIbge": 5218805,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.79,
    "precoMinimo": 6.52,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1324427099865124,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "RONDONOPOLIS",
    "municipioIbge": 5107602,
    "produto": "DIESEL_S10",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.54,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.15989179033141326,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SABARA",
    "municipioIbge": 3156700,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.54,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.28654260881528015,
    "coeficienteVariacao": 0.042
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SALGUEIRO",
    "municipioIbge": 2612208,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.49,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.3741402843599609,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SALTO",
    "municipioIbge": 3545209,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.39,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.27224988521577015,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SALVADOR",
    "municipioIbge": 2927408,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.61,
    "precoMinimo": 7.33,
    "precoMaximo": 7.94,
    "desvioPadrao": 0.26315394733881536,
    "coeficienteVariacao": 0.035
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SANTA CRUZ DO CAPIBARIBE",
    "municipioIbge": 2612505,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.1,
    "precoMinimo": 6.99,
    "precoMaximo": 7.24,
    "desvioPadrao": 0.10023781246425448,
    "coeficienteVariacao": 0.014
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTA MARIA",
    "municipioIbge": 4316907,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 6.27,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.27214171145032345,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTANA DO LIVRAMENTO",
    "municipioIbge": null,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.08,
    "precoMinimo": 6.79,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.15221577729375776,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PA",
    "estadoNome": "PARA",
    "municipioNome": "SANTAREM",
    "municipioIbge": 1506807,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.12,
    "precoMinimo": 6.79,
    "precoMaximo": 7.45,
    "desvioPadrao": 0.3167994708990291,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTO ANDRE",
    "municipioIbge": 3547809,
    "produto": "DIESEL_S10",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.59,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.2986167745153946,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SANTO ANGELO",
    "municipioIbge": 4317509,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.8,
    "precoMinimo": 6.48,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.28134879217288794,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SANTO ANTONIO DE JESUS",
    "municipioIbge": 2928703,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.77,
    "precoMinimo": 7.69,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.044721359549995794,
    "coeficienteVariacao": 0.006
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SANTO ANTONIO DE PADUA",
    "municipioIbge": 3304706,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.59,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.3229219277605214,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SANTOS",
    "municipioIbge": 3548500,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 7.17,
    "precoMinimo": 6.39,
    "precoMaximo": 8.29,
    "desvioPadrao": 0.6170755401263465,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO BERNARDO DO CAMPO",
    "municipioIbge": 3548708,
    "produto": "DIESEL_S10",
    "postosPesquisados": 14,
    "unidade": "R$/l",
    "precoMedio": 7.35,
    "precoMinimo": 6.89,
    "precoMaximo": 7.87,
    "desvioPadrao": 0.35625956705873757,
    "coeficienteVariacao": 0.048
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CAETANO DO SUL",
    "municipioIbge": 3548807,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.17,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.5964450240103163,
    "coeficienteVariacao": 0.086
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO CARLOS",
    "municipioIbge": 3548906,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.39,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.30659419433511786,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAO GONCALO",
    "municipioIbge": 3304904,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7,
    "precoMinimo": 6.79,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.14638501094227999,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOAO DA BOA VISTA",
    "municipioIbge": 3549102,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.71,
    "precoMinimo": 6.19,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.30331501776206204,
    "coeficienteVariacao": 0.045
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO JOAO DEL REI",
    "municipioIbge": 3162500,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.84,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.060553007081949835,
    "coeficienteVariacao": 0.009
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "SAO JOSE",
    "municipioIbge": 4216602,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.59,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.12727922061357858,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO JOSE DE RIBAMAR",
    "municipioIbge": 2111201,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.05,
    "precoMinimo": 6.77,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.20046473782466362,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DO RIO PRETO",
    "municipioIbge": 3549805,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.39,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2644319239884671,
    "coeficienteVariacao": 0.039
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO JOSE DOS CAMPOS",
    "municipioIbge": 3549904,
    "produto": "DIESEL_S10",
    "postosPesquisados": 13,
    "unidade": "R$/l",
    "precoMedio": 6.68,
    "precoMinimo": 5.99,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.2870004020367058,
    "coeficienteVariacao": 0.043
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "SAO JOSE DOS PINHAIS",
    "municipioIbge": 4125506,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.49,
    "precoMaximo": 7.24,
    "desvioPadrao": 0.24644594957232724,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LEOPOLDO",
    "municipioIbge": 4318705,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.35,
    "precoMinimo": 6.09,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.2615202805574687,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MA",
    "estadoNome": "MARANHAO",
    "municipioNome": "SAO LUIS",
    "municipioIbge": 2111300,
    "produto": "DIESEL_S10",
    "postosPesquisados": 20,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.64,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.191977931845797,
    "coeficienteVariacao": 0.028
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAO LUIZ GONZAGA",
    "municipioIbge": 4318903,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.54,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.27688746209726917,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SAO MATEUS",
    "municipioIbge": 3204906,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.94,
    "precoMinimo": 6.89,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.07071067811865475,
    "coeficienteVariacao": 0.01
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO PAULO",
    "municipioIbge": 3550308,
    "produto": "DIESEL_S10",
    "postosPesquisados": 137,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.14,
    "precoMaximo": 9.19,
    "desvioPadrao": 0.49553428668756516,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SAO SEBASTIAO DO PARAISO",
    "municipioIbge": 3164704,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.77,
    "precoMinimo": 6.67,
    "precoMaximo": 6.97,
    "desvioPadrao": 0.10977249200050075,
    "coeficienteVariacao": 0.016
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SAO VICENTE",
    "municipioIbge": 3551009,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.39,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.34641016151377546,
    "coeficienteVariacao": 0.05
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPIRANGA",
    "municipioIbge": 4319901,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.21,
    "precoMinimo": 6.02,
    "precoMaximo": 6.39,
    "desvioPadrao": 0.20800641015763593,
    "coeficienteVariacao": 0.033
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "SAPUCAIA DO SUL",
    "municipioIbge": 4320008,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.06,
    "precoMinimo": 5.84,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.31819805153394637,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "SAQUAREMA",
    "municipioIbge": 3305505,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.31,
    "precoMinimo": 7.19,
    "precoMaximo": 7.59,
    "desvioPadrao": 0.16431676725154984,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SENHOR DO BONFIM",
    "municipioIbge": 2930105,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.83,
    "precoMinimo": 7.59,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.17182493859684492,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "SERRA",
    "municipioIbge": 3205002,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.11562631380634965,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "SERRA TALHADA",
    "municipioIbge": 2613909,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.9,
    "precoMinimo": 6.68,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.42661458015403086,
    "coeficienteVariacao": 0.062
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "SERRINHA",
    "municipioIbge": 2930501,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.29,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.2199567056967175,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SERTAOZINHO",
    "municipioIbge": 3551702,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.85,
    "precoMinimo": 6.79,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.13416407864998736,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "SETE LAGOAS",
    "municipioIbge": 3167202,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.37,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.3080816218379242,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SINOP",
    "municipioIbge": 5107909,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.59,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.39115214431215894,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "CE",
    "estadoNome": "CEARA",
    "municipioNome": "SOBRAL",
    "municipioIbge": 2312908,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.41,
    "precoMinimo": 7.39,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.05,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SOROCABA",
    "municipioIbge": 3552205,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.76,
    "precoMinimo": 6.39,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.3734199033828061,
    "coeficienteVariacao": 0.055
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "SORRISO",
    "municipioIbge": 5107925,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 6.77,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.40480447955360704,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PB",
    "estadoNome": "PARAIBA",
    "municipioNome": "SOUSA",
    "municipioIbge": 2516201,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.79,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.24237711663163805,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUMARE",
    "municipioIbge": 3552403,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 5.99,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.34656408738740757,
    "coeficienteVariacao": 0.052
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "SUZANO",
    "municipioIbge": 3552502,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.75,
    "precoMinimo": 6.38,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.4760083282584755,
    "coeficienteVariacao": 0.071
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TABOAO DA SERRA",
    "municipioIbge": 3552809,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.14,
    "precoMinimo": 6.49,
    "precoMaximo": 7.75,
    "desvioPadrao": 0.5927309676404634,
    "coeficienteVariacao": 0.083
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TATUI",
    "municipioIbge": 3554003,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.02,
    "precoMinimo": 6.29,
    "precoMaximo": 7.85,
    "desvioPadrao": 0.6467795679548092,
    "coeficienteVariacao": 0.092
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "TAUBATE",
    "municipioIbge": 3554102,
    "produto": "DIESEL_S10",
    "postosPesquisados": 11,
    "unidade": "R$/l",
    "precoMedio": 6.74,
    "precoMinimo": 6.49,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.246429041972071,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "TEIXEIRA DE FREITAS",
    "municipioIbge": 2931350,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 7.38,
    "precoMinimo": 6.97,
    "precoMaximo": 7.79,
    "desvioPadrao": 0.579827560572969,
    "coeficienteVariacao": 0.079
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TEOFILO OTONI",
    "municipioIbge": 3168606,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.91,
    "precoMinimo": 6.69,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.1299038105676658,
    "coeficienteVariacao": 0.019
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PI",
    "estadoNome": "PIAUI",
    "municipioNome": "TERESINA",
    "municipioIbge": 2211001,
    "produto": "DIESEL_S10",
    "postosPesquisados": 17,
    "unidade": "R$/l",
    "precoMedio": 7.43,
    "precoMinimo": 6.99,
    "precoMaximo": 8.09,
    "desvioPadrao": 0.30154016413777335,
    "coeficienteVariacao": 0.041
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "TOLEDO",
    "municipioIbge": 4127700,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.19,
    "precoMaximo": 7.25,
    "desvioPadrao": 0.33230675253111813,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "TORRES",
    "municipioIbge": 4321501,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.55,
    "precoMinimo": 6.49,
    "precoMaximo": 6.59,
    "desvioPadrao": 0.04716990566028302,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "TRES CORACOES",
    "municipioIbge": 3169307,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.2,
    "precoMinimo": 6.69,
    "precoMaximo": 7.56,
    "desvioPadrao": 0.31814566894217916,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "TRES RIOS",
    "municipioIbge": 3306008,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.49,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.15,
    "coeficienteVariacao": 0.023
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "TUBARAO",
    "municipioIbge": 4218707,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.24,
    "precoMinimo": 6.19,
    "precoMaximo": 6.29,
    "desvioPadrao": 0.05270462766947299,
    "coeficienteVariacao": 0.008
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBA",
    "municipioIbge": 3169901,
    "produto": "DIESEL_S10",
    "postosPesquisados": 2,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1414213562373095,
    "coeficienteVariacao": 0.021
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "UBATUBA",
    "municipioIbge": 3555406,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 7.31,
    "precoMinimo": 6.97,
    "precoMaximo": 7.89,
    "desvioPadrao": 0.33525399042403375,
    "coeficienteVariacao": 0.046
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERABA",
    "municipioIbge": 3170107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 6.81,
    "precoMinimo": 6.37,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.4982971001320397,
    "coeficienteVariacao": 0.073
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UBERLANDIA",
    "municipioIbge": 3170206,
    "produto": "DIESEL_S10",
    "postosPesquisados": 10,
    "unidade": "R$/l",
    "precoMedio": 6.66,
    "precoMinimo": 6.29,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.22939776226749323,
    "coeficienteVariacao": 0.034
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UMUARAMA",
    "municipioIbge": 4128104,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.67,
    "precoMinimo": 6.47,
    "precoMaximo": 6.98,
    "desvioPadrao": 0.2121657034355122,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "UNAI",
    "municipioIbge": 3170404,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.93,
    "precoMinimo": 6.74,
    "precoMaximo": 7.18,
    "desvioPadrao": 0.22479620400116487,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PR",
    "estadoNome": "PARANA",
    "municipioNome": "UNIAO DA VITORIA",
    "municipioIbge": 4128203,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.1,
    "precoMinimo": 6.79,
    "precoMaximo": 7.44,
    "desvioPadrao": 0.3119161212035484,
    "coeficienteVariacao": 0.044
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "URUGUAIANA",
    "municipioIbge": 4322400,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.99,
    "precoMinimo": 6.77,
    "precoMaximo": 7.24,
    "desvioPadrao": 0.17477877173049092,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VACARIA",
    "municipioIbge": 4322509,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.59,
    "precoMinimo": 6.47,
    "precoMaximo": 6.94,
    "desvioPadrao": 0.1590541237620524,
    "coeficienteVariacao": 0.024
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VALENCA",
    "municipioIbge": 2932903,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 7.49,
    "precoMinimo": 7.19,
    "precoMaximo": 7.65,
    "desvioPadrao": 0.1623165631310208,
    "coeficienteVariacao": 0.022
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VALENCA",
    "municipioIbge": 3306107,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 7.26,
    "precoMinimo": 7.19,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.05,
    "coeficienteVariacao": 0.007
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VALINHOS",
    "municipioIbge": 3556206,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.7,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.16516658257650063,
    "coeficienteVariacao": 0.025
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "GO",
    "estadoNome": "GOIAS",
    "municipioNome": "VALPARAISO DE GOIAS",
    "municipioIbge": 5221858,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.73,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1986621923433512,
    "coeficienteVariacao": 0.029
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VARGINHA",
    "municipioIbge": 3170701,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.87,
    "precoMinimo": 6.59,
    "precoMaximo": 7.19,
    "desvioPadrao": 0.27457326197296816,
    "coeficienteVariacao": 0.04
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MT",
    "estadoNome": "MATO GROSSO",
    "municipioNome": "VARZEA GRANDE",
    "municipioIbge": 5108402,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.82,
    "precoMinimo": 6.57,
    "precoMaximo": 7.29,
    "desvioPadrao": 0.24628670864897045,
    "coeficienteVariacao": 0.036
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VARZEA PAULISTA",
    "municipioIbge": 3556503,
    "produto": "DIESEL_S10",
    "postosPesquisados": 7,
    "unidade": "R$/l",
    "precoMedio": 6.89,
    "precoMinimo": 6.49,
    "precoMaximo": 7.35,
    "desvioPadrao": 0.32559835029417106,
    "coeficienteVariacao": 0.047
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RS",
    "estadoNome": "RIO GRANDE DO SUL",
    "municipioNome": "VIAMAO",
    "municipioIbge": 4323002,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 6.63,
    "precoMinimo": 6.29,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.20736441353327723,
    "coeficienteVariacao": 0.031
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "MG",
    "estadoNome": "MINAS GERAIS",
    "municipioNome": "VICOSA",
    "municipioIbge": 3171303,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.15,
    "precoMinimo": 6.79,
    "precoMaximo": 7.39,
    "desvioPadrao": 0.23021728866442678,
    "coeficienteVariacao": 0.032
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "VIDEIRA",
    "municipioIbge": 4219309,
    "produto": "DIESEL_S10",
    "postosPesquisados": 5,
    "unidade": "R$/l",
    "precoMedio": 7.01,
    "precoMinimo": 6.64,
    "precoMaximo": 7.69,
    "desvioPadrao": 0.40394306529509827,
    "coeficienteVariacao": 0.058
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VILA VELHA",
    "municipioIbge": 3205200,
    "produto": "DIESEL_S10",
    "postosPesquisados": 12,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.59,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.1332205962782305,
    "coeficienteVariacao": 0.02
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RO",
    "estadoNome": "RONDONIA",
    "municipioNome": "VILHENA",
    "municipioIbge": 1100304,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 7.4,
    "precoMinimo": 7,
    "precoMaximo": 7.99,
    "desvioPadrao": 0.273965586994321,
    "coeficienteVariacao": 0.037
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "ES",
    "estadoNome": "ESPIRITO SANTO",
    "municipioNome": "VITORIA",
    "municipioIbge": 3205309,
    "produto": "DIESEL_S10",
    "postosPesquisados": 4,
    "unidade": "R$/l",
    "precoMedio": 6.88,
    "precoMinimo": 6.79,
    "precoMaximo": 6.99,
    "desvioPadrao": 0.08225975119502044,
    "coeficienteVariacao": 0.012
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "BA",
    "estadoNome": "BAHIA",
    "municipioNome": "VITORIA DA CONQUISTA",
    "municipioIbge": 2933307,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.5,
    "precoMinimo": 6.64,
    "precoMaximo": 8.19,
    "desvioPadrao": 0.42130748865881795,
    "coeficienteVariacao": 0.056
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "PE",
    "estadoNome": "PERNAMBUCO",
    "municipioNome": "VITORIA DE SANTO ANTAO",
    "municipioIbge": 2616407,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.51,
    "precoMinimo": 6.47,
    "precoMaximo": 6.79,
    "desvioPadrao": 0.11313708498984762,
    "coeficienteVariacao": 0.017
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "RJ",
    "estadoNome": "RIO DE JANEIRO",
    "municipioNome": "VOLTA REDONDA",
    "municipioIbge": 3306305,
    "produto": "DIESEL_S10",
    "postosPesquisados": 9,
    "unidade": "R$/l",
    "precoMedio": 7.28,
    "precoMinimo": 6.99,
    "precoMaximo": 7.49,
    "desvioPadrao": 0.19974984355438177,
    "coeficienteVariacao": 0.027
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTORANTIM",
    "municipioIbge": 3557006,
    "produto": "DIESEL_S10",
    "postosPesquisados": 6,
    "unidade": "R$/l",
    "precoMedio": 6.57,
    "precoMinimo": 6.14,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.3243711865543342,
    "coeficienteVariacao": 0.049
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SP",
    "estadoNome": "SAO PAULO",
    "municipioNome": "VOTUPORANGA",
    "municipioIbge": 3557105,
    "produto": "DIESEL_S10",
    "postosPesquisados": 3,
    "unidade": "R$/l",
    "precoMedio": 6.78,
    "precoMinimo": 6.69,
    "precoMaximo": 6.89,
    "desvioPadrao": 0.1014889156509222,
    "coeficienteVariacao": 0.015
  },
  {
    "semanaInicio": "2026-07-26",
    "semanaFim": "2026-08-01",
    "uf": "SC",
    "estadoNome": "SANTA CATARINA",
    "municipioNome": "XANXERE",
    "municipioIbge": 4219507,
    "produto": "DIESEL_S10",
    "postosPesquisados": 8,
    "unidade": "R$/l",
    "precoMedio": 6.72,
    "precoMinimo": 6.29,
    "precoMaximo": 7.09,
    "desvioPadrao": 0.276091987776331,
    "coeficienteVariacao": 0.041
  }
]
